import { useToggle as ti, useDeepCompareMemo as Ea } from "@react-hookz/web";
import { g as fa, a as gn } from "./environment-BQ4WWa7b.mjs";
import * as N from "react";
import u, { createContext as Xn, useContext as Kn, useCallback as de, useState as Se, useMemo as Fe, useEffect as Qe, useLayoutEffect as ga, useRef as Ue, useDebugValue as Aa } from "react";
import { Transition as Ta, SwitchTransition as ct } from "react-transition-group";
import { useLatest as Ia } from "react-use";
import { u as re, a as Sa, b as ha, R as Ca } from "./contexts-BZGAPJKE.mjs";
import { b as Ra, u as ba, a as ya } from "./tracking-impression-event-BSYv6VZE.mjs";
import { fetchQuery as ni, commitMutation as Na } from "react-relay";
import { u as Bt } from "./fallback-storage-value-DraZAU_d.mjs";
import { n as qe, u as An, e as Oa, b as va, f as wa } from "./index-CnymUPx7.mjs";
import { withEmotionCache as Pa, ThemeContext as ri, useTheme as Dt, css as ii } from "@emotion/react";
import { getRegisteredStyles as La, registerStyles as Ba, insertStyles as ka } from "@emotion/utils";
import { b as le, f as W, a as dt } from "./variables-BSQ2K9t-.mjs";
import { useGoogleReCaptcha as Da } from "react-google-recaptcha-v3";
import Nr from "qs";
import { ThemeProvider as Ma } from "@mui/material";
import ai from "deepmerge";
import { t as oi } from "./breakpoints-DvaoDEis.mjs";
function Tn() {
  return Tn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tn.apply(null, arguments);
}
function si(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var xa = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Ua = /* @__PURE__ */ si(
  function(e) {
    return xa.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function Fa(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Ga = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Va = !1, ja = /[A-Z]|^ms/g, Ya = /_EMO_([^_]+?)_([^]*?)_EMO_/g, li = function(t) {
  return t.charCodeAt(1) === 45;
}, Or = function(t) {
  return t != null && typeof t != "boolean";
}, an = /* @__PURE__ */ si(function(e) {
  return li(e) ? e : e.replace(ja, "-$&").toLowerCase();
}), vr = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Ya, function(r, i, a) {
          return Te = {
            name: i,
            styles: a,
            next: Te
          }, i;
        });
  }
  return Ga[t] !== 1 && !li(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, Ha = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function pt(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return Te = {
          name: i.name,
          styles: i.styles,
          next: Te
        }, i.name;
      var a = n;
      if (a.styles !== void 0) {
        var s = a.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Te = {
              name: s.name,
              styles: s.styles,
              next: Te
            }, s = s.next;
        var l = a.styles + ";";
        return l;
      }
      return za(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = Te, E = n(e);
        return Te = c, pt(e, t, E);
      }
      break;
    }
  }
  var p = n;
  if (t == null)
    return p;
  var d = t[p];
  return d !== void 0 ? d : p;
}
function za(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += pt(e, t, n[i]) + ";";
  else
    for (var a in n) {
      var s = n[a];
      if (typeof s != "object") {
        var l = s;
        t != null && t[l] !== void 0 ? r += a + "{" + t[l] + "}" : Or(l) && (r += an(a) + ":" + vr(a, l) + ";");
      } else {
        if (a === "NO_COMPONENT_SELECTOR" && Va)
          throw new Error(Ha);
        if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
          for (var c = 0; c < s.length; c++)
            Or(s[c]) && (r += an(a) + ":" + vr(a, s[c]) + ";");
        else {
          var E = pt(e, t, s);
          switch (a) {
            case "animation":
            case "animationName": {
              r += an(a) + ":" + E + ";";
              break;
            }
            default:
              r += a + "{" + E + "}";
          }
        }
      }
    }
  return r;
}
var wr = /label:\s*([^\s;{]+)\s*(;|$)/g, Te;
function Wa(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  Te = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    r = !1, i += pt(n, t, a);
  else {
    var s = a;
    i += s[0];
  }
  for (var l = 1; l < e.length; l++)
    if (i += pt(n, t, e[l]), r) {
      var c = a;
      i += c[l];
    }
  wr.lastIndex = 0;
  for (var E = "", p; (p = wr.exec(i)) !== null; )
    E += "-" + p[1];
  var d = Fa(i) + E;
  return {
    name: d,
    styles: i,
    next: Te
  };
}
var Xa = function(t) {
  return t();
}, Ka = N.useInsertionEffect ? N.useInsertionEffect : !1, Ja = Ka || Xa, Qa = { CI_SERVER_REVISION: "f2789346710", FF_USE_WINDOWS_LEGACY_PROCESS_STRATEGY: "false", GITLAB_USER_LOGIN: "tony.kan", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", CI_COMMIT_SHORT_SHA: "c24c7807", FF_SCRIPT_SECTIONS: "false", NEXT_PUBLIC_ENV_SLUG: "local", PRISMACLOUD_CONSOLE_ADDRESS: "https://asia-southeast1.cloud.twistlock.com/aws-singapore-961147807", CI_SERVER_VERSION_PATCH: "3", CF_BAN_WORKER_MQ_EXCHANGE_NAME: "varnish_bans", FF_POSIXLY_CORRECT_ESCAPES: "false", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", KUBERNETES_SERVICE_PORT: "443", TECH_TEST_K8S_TKN: "eyJhbGciOiJSUzI1NiIsImtpZCI6IiJ9.eyJpc3MiOiJrdWJlcm5ldGVzL3NlcnZpY2VhY2NvdW50Iiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9uYW1lc3BhY2UiOiJwcm9kdWN0LXdlYiIsImt1YmVybmV0ZXMuaW8vc2VydmljZWFjY291bnQvc2VjcmV0Lm5hbWUiOiJnaXRsYWItdG9rZW4tdmRuajgiLCJrdWJlcm5ldGVzLmlvL3NlcnZpY2VhY2NvdW50L3NlcnZpY2UtYWNjb3VudC5uYW1lIjoiZ2l0bGFiIiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9zZXJ2aWNlLWFjY291bnQudWlkIjoiNGRmNTkyYjEtZGI1Yy0xMWU5LTk0NTctNDY0ZDU0MjlmYzc3Iiwic3ViIjoic3lzdGVtOnNlcnZpY2VhY2NvdW50OnByb2R1Y3Qtd2ViOmdpdGxhYiJ9.bJsbob7RAgJTsZSGTlaXPrh_Panqb8OVRqPqpcKroF_I8OHNr2R70y2IdLDNx2O6h1FlkDDauCGBfcYwsGHv2QVsMrUsWegNGxDp42mT81C2vse7OZjfssWBowAIw7OBpCAa3F_cU8gQwh5txTWZPdJYgeYe4da9FRqx4FwMEubGoR_y6WCd_GGA6y0BudD3AdvTfDKw8J3OhnUipLjNMufOSOPObSK97XUTKA5mC-rm5aq97df_KqE8dopwPvSQUIt4jQ5uC6FQhf8Tu_NMu3ZO8hRZSvyApw2IbCDbrCYn374ZPpXK18px9HD7CCa6XbVTRzPScUpFtXqoe4OD0Q", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", FF_GITLAB_REGISTRY_HELPER_IMAGE: "1", PLANTUML_SERVER_SERVICE_PORT: "8080", CI_DEPENDENCY_PROXY_PASSWORD: "glcbt-64_w8gsVaFfgQ9zuetNzxum", CF_BAN_WORKER_DEBUG: "true", CF_BAN_WORKER_MQ_PATH: "scmp", PLANTUML_SERVER_PORT: "tcp://10.200.132.244:8080", KUBERNETES_PORT: "tcp://10.200.128.1:443", CI_DEPENDENCY_PROXY_SERVER: "project.scmp.tech:443", CI_MERGE_REQUEST_TARGET_BRANCH_PROTECTED: "true", FF_USE_DUMB_INIT_WITH_KUBERNETES_EXECUTOR: "false", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", npm_config_user_agent: "pnpm/9.14.2 npm/? node/v20.18.1 linux x64", DEV_2_K8S_CA: `-----BEGIN CERTIFICATE-----
MIIC/zCCAmigAwIBAgIDChmPMA0GCSqGSIb3DQEBCwUAMGIxCzAJBgNVBAYTAkNO
MREwDwYDVQQIDAhaaGVKaWFuZzERMA8GA1UEBwwISGFuZ1pob3UxEDAOBgNVBAoM
B0FsaWJhYmExDDAKBgNVBAsMA0FDUzENMAsGA1UEAwwEcm9vdDAeFw0xODA5MTcw
NDUwMDBaFw0zODA5MTIwNDU1NDVaMGoxKjAoBgNVBAoTIWNiMTRhNjliNDA3Zjc0
ZjgyOTJmN2IxYzFhNTkxMmY1MDEQMA4GA1UECxMHZGVmYXVsdDEqMCgGA1UEAxMh
Y2IxNGE2OWI0MDdmNzRmODI5MmY3YjFjMWE1OTEyZjUwMIGfMA0GCSqGSIb3DQEB
AQUAA4GNADCBiQKBgQCmblHyvBcwmgL5h7jdNRvyxzh/+v98y0pHTMQ1VPRWdabG
V/tFL86A+Jz7iWgvAgvYCHiIvMQHvfeXX77DU1IYWDmHN5/WPqWtfeyIsy8cN53G
ihkrj93kWiNIFr34MDmlYAbYCfJEZPMw2JmU0YCyrHHJ7z8pqas+ZJhMtPzK6wID
AQABo4G6MIG3MA4GA1UdDwEB/wQEAwICrDAPBgNVHRMBAf8EBTADAQH/MB8GA1Ud
IwQYMBaAFIVa/90jzSVvWEFvnm1FOZtYfXX/MDwGCCsGAQUFBwEBBDAwLjAsBggr
BgEFBQcwAYYgaHR0cDovL2NlcnRzLmFjcy5hbGl5dW4uY29tL29jc3AwNQYDVR0f
BC4wLDAqoCigJoYkaHR0cDovL2NlcnRzLmFjcy5hbGl5dW4uY29tL3Jvb3QuY3Js
MA0GCSqGSIb3DQEBCwUAA4GBADKz+HFYxSJDeA7Q0lm9c4xefH9Sdw+tzHH5uYPu
tDyY1YWG+fUboTyWTRpfbbpt+hvO7NZKl4Y7F9Zivk7EaoqfiOAqHE/tBHvSqwkG
48KggF0CTP3GutsGerKqOGnciQtk0Wh3Nk47gLN+yK9BFdwGPeN6l8oIAP9oVIIP
k6UF
-----END CERTIFICATE-----`, CI_PROJECT_NAME: "scmp-pwa-v2", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_PORT_9200_TCP: "tcp://10.200.143.51:9200", NPM_CI_USERNAME: "verdaccio", CI_SERVER_PROTOCOL: "https", TECH_TEST_K8S_NS: "product-web", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", FF_USE_LEGACY_KUBERNETES_EXECUTION_STRATEGY: "0", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", CI_RUNNER_REVISION: "66269445", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_SERVICE_PORT: "9200", FF_LOG_IMAGES_CONFIGURED_FOR_JOB: "false", CI: "true", NODE_VERSION: "20.18.1", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_PORT: "tcp://10.200.143.51:9200", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/local", HOSTNAME: "runner-cnuehfn36-project-1232-concurrent-0-h6m7etnj", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", YARN_VERSION: "1.22.22", ECI_CONTAINER_TYPE: "normal", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", CI_COMMIT_DESCRIPTION: `Merge branch 'SCMPWEB-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-version-2' into 'master'

Resolve SCMPWEB-6681 "Track undefined appconfig call on Piano execution"

Closes SCMPWEB-6681

See merge request product/web/scmp-pwa-v2!3261`, CI_JOB_STAGE: "misc", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", CI_PROJECT_DESCRIPTION: `South China Morning Post web app v2\r
\r
http://product.pages.scmp.tech/web/scmp-pwa-v2`, NEXT_PUBLIC_SITE_URL: "https://local.product-web.dev-2.scmp.tech/", ELASTICSEARCH_GITLAB_ES_HTTP_SERVICE_PORT: "9200", ELASTICSEARCH_GITLAB_ES_HTTP_PORT: "tcp://10.200.135.60:9200", K8S_VAULT_ROLE: "product-web-scmp-pwa-v2", CI_SERVER_VERSION: "17.3.3-ee", ELASTICSEARCH_GITLAB_ES_HTTP_PORT_9200_TCP: "tcp://10.200.135.60:9200", VAULT_ADDR: "https://vault.dev-2.scmp.tech", CI_MERGE_REQUEST_SOURCE_PROJECT_ID: "1232", SHLVL: "2", CI_DEPENDENCY_PROXY_USER: "gitlab-ci-token", FF_DISABLE_POWERSHELL_STDIN: "false", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", PLANTUML_SERVER_PORT_8080_TCP: "tcp://10.200.132.244:8080", CF_BAN_WORKER_CLOUDFLARE_API_KEY: "DO NOT SET IN LOCAL", HOME: "/root", FF_DISABLE_AUTOMATIC_TOKEN_ROTATION: "false", CI_PROJECT_ROOT_NAMESPACE: "product", APP_RUNTIME_BASE_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2/scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-app-runtime-base:scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-c24c7807732604b54cb07006988e629b8b11829e", FF_CLEAN_UP_FAILED_CACHE_EXTRACT: "false", OLDPWD: "/app", FF_NETWORK_PER_BUILD: "false", CI_COMMIT_REF_NAME: "SCMPWEB-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-version-2", CI_SERVER_HOST: "project.scmp.tech", CI_JOB_ID: "2618122", CI_RUNNER_VERSION: "17.3.1", CI_MERGE_REQUEST_TARGET_BRANCH_SHA: "80b1b6ac84065cb4786b93b6f2598e3e551e874f", CI_PIPELINE_SOURCE: "merge_request_event", FF_RESOLVE_FULL_TLS_CHAIN: "false", FF_SKIP_NOOP_BUILD_STAGES: "true", CI_MERGE_REQUEST_SOURCE_BRANCH_NAME: "SCMPWEB-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-version-2", CI_MERGE_REQUEST_SOURCE_PROJECT_PATH: "product/web/scmp-pwa-v2", FF_USE_WINDOWS_JOB_OBJECT: "false", CI_DEFAULT_BRANCH: "master", PROD_US_K8S_CA: `-----BEGIN CERTIFICATE-----
MIIDGjCCAgKgAwIBAgIBADANBgkqhkiG9w0BAQsFADA+MScwFAYDVQQKEw1hbGli
YWJhIGNsb3VkMA8GA1UEChMIaGFuZ3pob3UxEzARBgNVBAMTCmt1YmVybmV0ZXMw
HhcNMTkxMjA1MDcxMDA4WhcNMjkxMjAyMDcxMDA4WjA+MScwFAYDVQQKEw1hbGli
YWJhIGNsb3VkMA8GA1UEChMIaGFuZ3pob3UxEzARBgNVBAMTCmt1YmVybmV0ZXMw
ggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDEYXp13ukiTy3fevdO/47O
Ocr5skJ2MMOaIyx/aFLm2RlIo0qO9RanMLD8Pjx9Lz4bJHhEpx4BnPnUemsC2cm/
UrhY+Lfjr4op8nwmtE42evx4FRzuYRBsiEbc7+Yvjvl8tE0my5HVw5MAvWOFlE+X
J75pgHmC1IT91jWmhx8NnBHgHowZ0eqPWNns5rxjc83k1U3u6275SYi9ZLhBDmUj
kTR0IwtVLRdQhljU6pIN2lfjyerab3JEcEo6RvuFlBcLHCr0tzCNLpWWXceIiDuj
vmYCac07wpw9+HtBCCnd8i7rb6uJknn0IeGD/Flx519+dbHaCK+v0/zj0iYKetmb
AgMBAAGjIzAhMA4GA1UdDwEB/wQEAwICpDAPBgNVHRMBAf8EBTADAQH/MA0GCSqG
SIb3DQEBCwUAA4IBAQBOHn3zDbHPTT+xpn7MsmRxMT6H8NSPRgUHQxcBOQwT+ylY
vGnbhAYRHv9wrEZy3Pt+F4ncjcEFTMjuf5cLjIuKOfG6+BMpGL6kt17ZKrX5mwSb
BkZHrnb7ifCPLuMtcp2JzZ2oOTwFyTVkdCo9xgaHXGZjARvJgNv39dbZiI5UtqbC
OINGWinvMu3JA6kvIHcKp67BRDl+oYj25d13nV+pY7JaIJWFnXBsVrOd2MoIByrH
NaqLulwTvcRcPJ3CiyyzP2v4t6r+0IJA+lYLD5XtYGjkxBZOw+jkvSINEuMCtIcT
reUxC93rX4LAojF3ozW5uPKWMXXqPwPDa5oAOFJQ
-----END CERTIFICATE-----`, CI_BUILDS_DIR: "/builds", CI_SERVER_VERSION_MAJOR: "17", FF_USE_FASTZIP: "false", CI_REGISTRY_PASSWORD: "glcbt-64_w8gsVaFfgQ9zuetNzxum", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", CI_COMMIT_REF_PROTECTED: "false", UNLEASH_SERVER_API_TOKEN: "token", CI_SERVER_URL: "https://project.scmp.tech", CI_TEMPLATE_REGISTRY_HOST: "registry.gitlab.com", CI_MERGE_REQUEST_DIFF_ID: "352616", CF_BAN_WORKER_CLOUDFLARE_ZONE: "DO NOT SET IN LOCAL", PRISMACLOUD_ACCESS_KEY_ID: "407567c0-39ea-479f-8bac-55a292a0053b", CI_MERGE_REQUEST_ASSIGNEES: "shawn.yeung", GITLAB_FEATURES: "audit_events,blocked_issues,board_iteration_lists,code_owners,code_review_analytics,full_codequality_report,group_activity_analytics,group_bulk_edit,issuable_default_templates,issue_weights,iterations,ldap_group_sync,merge_request_approvers,milestone_charts,multiple_issue_assignees,multiple_ldap_servers,multiple_merge_request_assignees,multiple_merge_request_reviewers,project_merge_request_analytics,protected_refs_for_users,push_rules,resource_access_token,seat_link,seat_usage_quotas,pipelines_usage_quotas,transfer_usage_quotas,product_analytics_usage_quotas,wip_limits,zoekt_code_search,blocked_work_items,description_diffs,send_emails_from_admin_area,repository_size_limit,maintenance_mode,scoped_issue_board,contribution_analytics,group_webhooks,member_lock,elastic_search,repository_mirrors,ai_chat,adjourned_deletion_for_projects_and_groups,admin_audit_log,auditor_user,blocking_merge_requests,board_assignee_lists,board_milestone_lists,ci_secrets_management,ci_pipeline_cancellation_restrictions,cluster_agents_ci_impersonation,cluster_agents_user_impersonation,cluster_deployments,code_owner_approval_required,code_suggestions,commit_committer_check,commit_committer_name_check,compliance_framework,custom_compliance_frameworks,custom_file_templates,custom_project_templates,cycle_analytics_for_groups,cycle_analytics_for_projects,db_load_balancing,default_branch_protection_restriction_in_groups,default_project_deletion_protection,delete_unconfirmed_users,dependency_proxy_for_packages,disable_name_update_for_users,disable_personal_access_tokens,domain_verification,epics,extended_audit_events,external_authorization_service_api_management,feature_flags_code_references,file_locks,geo,generic_alert_fingerprinting,git_two_factor_enforcement,group_allowed_email_domains,group_coverage_reports,group_forking_protection,group_level_compliance_dashboard,group_milestone_project_releases,group_project_templates,group_repository_analytics,group_saml,group_scoped_ci_variables,ide_schema_config,incident_metric_upload,instance_level_scim,jira_issues_integration,ldap_group_sync_filter,merge_request_performance_metrics,admin_merge_request_approvers_rules,merge_trains,metrics_reports,multiple_alert_http_integrations,multiple_approval_rules,multiple_group_issue_boards,object_storage,microsoft_group_sync,operations_dashboard,package_forwarding,pages_size_limit,pages_multiple_versions,productivity_analytics,project_aliases,protected_environments,reject_non_dco_commits,reject_unsigned_commits,remote_development,saml_group_sync,service_accounts,scoped_labels,smartcard_auth,ssh_certificates,swimlanes,target_branch_rules,type_of_work_analytics,minimal_access_role,unprotection_restrictions,ci_project_subscriptions,incident_timeline_view,oncall_schedules,escalation_policies,zentao_issues_integration,coverage_check_approval_rule,issuable_resource_links,group_protected_branches,group_level_merge_checks_setting,oidc_client_groups_claim,disable_deleting_account_for_users,disable_private_profiles,group_saved_replies,requested_changes_block_merge_request,project_saved_replies,group_ip_restriction,issues_analytics,password_complexity,group_wikis,email_additional_text,custom_file_templates_for_namespace,incident_sla,export_user_permissions,cross_project_pipelines,feature_flags_related_issues,merge_pipelines,ci_cd_projects,github_integration", OSS_HOST: "assets-v2-dev.i-scmp.com", aliyun_log_crd_user_defined_id: "k8s-group-cb14a69b407f74f8292f7b1c1a5912f50", CI_REGISTRY_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", DEV_2_K8S_API: "https://172.17.31.240:6443", CI_PROJECT_ID: "1232", PRISMACLOUD_SECRET_ACCESS_KEY: "naF4oChJr+EIx8iNtw/UKjbp+eM=", CI_MERGE_REQUEST_SOURCE_BRANCH_PROTECTED: "false", CI_COMMIT_SHA: "c24c7807732604b54cb07006988e629b8b11829e", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_COMMIT_SHA: "123456", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", GITLAB_CI: "true", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", FF_USE_LEGACY_GCS_CACHE_ADAPTER: "false", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", FF_RETRIEVE_POD_WARNING_EVENTS: "true", CONTAINER_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2/scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to:my-app-c24c7807732604b54cb07006988e629b8b11829e", TECH_TEST_K8S_CA: `-----BEGIN CERTIFICATE-----
MIIDGjCCAgKgAwIBAgIBADANBgkqhkiG9w0BAQsFADA+MScwFAYDVQQKEw1hbGli
YWJhIGNsb3VkMA8GA1UEChMIaGFuZ3pob3UxEzARBgNVBAMTCmt1YmVybmV0ZXMw
HhcNMTkwOTA2MDgxODExWhcNMjkwOTAzMDgxODExWjA+MScwFAYDVQQKEw1hbGli
YWJhIGNsb3VkMA8GA1UEChMIaGFuZ3pob3UxEzARBgNVBAMTCmt1YmVybmV0ZXMw
ggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQCjpJnyPbkYl4u9FhpfYBzf
yvzQijTIRcMTjO7S5J+vL1mW9TrEc2amGqZdE1LprnX7DmIT/kEj7AdRPtfrYoNy
fyhfZUx028Tw9y6iYTRQYrLMMHN/SfwxwE3PY62i+RwoktglL/u5d/SOGOVgqufJ
EZn9hzOPTw+N+eKGqNh0lX8LXr1r5jGmZsXlkKbUGGLjqEuKQKO207aqajEt97tb
q8ZpStK6ATIgrwlYelxv3ZwzCVso2OH0CyyvH/qugGq4vyM9Hnn729/quufLnayF
mer0PAVALX1NsdSZm0k71H1mgeT8XZJxwrsfVFf4FcGsXMEMopvqXYoXCPDydkjh
AgMBAAGjIzAhMA4GA1UdDwEB/wQEAwICpDAPBgNVHRMBAf8EBTADAQH/MA0GCSqG
SIb3DQEBCwUAA4IBAQASqGWWDbUWBePbDgMHIjQGQFrUYUpLHcFyJ1DSjmec3Y2n
lPrcBtdCNJoiI3GJW2opePg4WiSz0VEzk989MGumjT/Fgh5nun5G4ZXgpVW3eFp9
ACl/34lYHPoI3JQnFPinB9Z+IesuA/TTImlznt5YTS8+NTdLk0ZQBaJrTciPSHvH
yNkFzVqwG2pjeBnwH0jxQWzuMKRpFfTpxS749k5e02F7sg6asTB8uCoozPyPwwTJ
IWcOi0WlKqCLaBT5NzGQlsMdYNkmuebuO0uBSFEHSgtI9cwy2VE7Cx5gj3pOf3CU
7VgXQvpVBIpaQUMMffhrdBALeLq49VqmqYlxf0vT
-----END CERTIFICATE-----`, CI_CONCURRENT_ID: "3", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NPM_CI_AUTH: "product-group-access-token:glpat-T5AespE5Pb7n-PTGxdkP", CI_REGISTRY_USER: "gitlab-ci-token", KIBANA_GITLAB_KB_HTTP_PORT_5601_TCP_ADDR: "10.200.140.234", NPM_CI_TOKEN: "CmMfvanLky2LHKwSaYZf", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", FF_USE_DOCKER_AUTOSCALER_DIAL_STDIO: "true", CI_SERVER_PORT: "443", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "local-dev-sw", KANIKO_BUILD_TOKEN: "wmBPb7CzvxxsRiLK1724", CI_MERGE_REQUEST_SQUASH_ON_MERGE: "false", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", DEV_2_ARGOCD_SERVER: "argocd.dev-2.scmp.tech:443", DEV_2_ARGOCD_TKN: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJhZWNlNTM1ZS0yMWUwLTQ4MTEtOWI0ZS1lZjY4ZGU4NzEzN2IiLCJpYXQiOjE2MjU4MDU5OTAsImlzcyI6ImFyZ29jZCIsIm5iZiI6MTYyNTgwNTk5MCwic3ViIjoicHJvajpwcm9kdWN0LXdlYjpHaXRsYWItQ0kifQ.6yuMOdMujHfVuyWNjK9ydu1Evo6Q18MUTvqES1ZsOEY", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", FF_DISABLE_UMASK_FOR_DOCKER_EXECUTOR: "false", DEPENDABOT_REDIS_MASTER_SERVICE_HOST: "10.200.139.161", CI_PROJECT_PATH: "product/web/scmp-pwa-v2", CI_MERGE_REQUEST_PROJECT_URL: "https://project.scmp.tech/product/web/scmp-pwa-v2", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", CI_PROJECT_DIR: "/builds/product/web/scmp-pwa-v2", CF_BAN_WORKER_MQ_PASSWORD: "123456", CI_PROJECT_NAMESPACE: "product/web", KIBANA_GITLAB_KB_HTTP_SERVICE_PORT_HTTPS: "5601", CHUNK_SIZE_NEEDS_JOB_NAME: "build-qa-app-image", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", GITLAB_PRIVATE_ACCESS_TOKEN: "glpat-47s2_tfGH97pMgaR4vbD", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", FF_ENABLE_JOB_CLEANUP: "false", CI_COMMIT_TIMESTAMP: "2024-11-21T09:37:17+08:00", DEPENDABOT_DEPENDABOT_GITLAB_PORT_3000_TCP_ADDR: "10.200.143.203", DEV_2_K8S_DIR: "k8s.dev-2", _: "/usr/local/bin/pnpm", CI_SERVER_NAME: "GitLab", KIBANA_GITLAB_KB_HTTP_PORT_5601_TCP_PORT: "5601", PROD_US_K8S_API: "https://47.254.23.77:6443", FF_USE_DIRECT_DOWNLOAD: "true", CI_MERGE_REQUEST_DESCRIPTION: `![image](/uploads/ab28b1aabb977f0b1ce389c16453e400/image.png){width=952 height=414}

Keep track of piano performance calls even if the app configuration is undefined.
Related to SCMPWEB-6681`, K8S_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", CI_JOB_TOKEN: "glcbt-64_w8gsVaFfgQ9zuetNzxum", FF_USE_DYNAMIC_TRACE_FORCE_SEND_INTERVAL: "false", CI_NODE_TOTAL: "1", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", DOCKER_REGISTRY_MIRROR: "http://172.17.30.2:5000", CF_BAN_WORKER_MQ_HOST: "rabbitmq", KIBANA_GITLAB_KB_HTTP_PORT_5601_TCP_PROTO: "tcp", CF_BAN_WORKER_SITE_HOSTS: "staging-scmp-pwa-v2.product-web.dev-2.scmp.tech", CI_PROJECT_NAMESPACE_ID: "10", CI_MERGE_REQUEST_SOURCE_BRANCH_SHA: "47b9f3bd42d7e5adbc88435200634658ebe1b145", CI_PIPELINE_CREATED_AT: "2024-11-21T09:37:19+08:00", KIBANA_GITLAB_KB_HTTP_SERVICE_HOST: "10.200.140.234", DEPENDABOT_DEPENDABOT_GITLAB_PORT_3000_TCP_PORT: "3000", CI_JOB_NAME_SLUG: "checking", RUNNER_TEMP_PROJECT_DIR: "/builds/product/web/scmp-pwa-v2.tmp", PROD_2_ARGOCD_SERVER: "argocd.scmp.tech:443", CI_CONCURRENT_PROJECT_ID: "0", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", CI_MERGE_REQUEST_IID: "3261", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://local.product-web.dev.scmp.tech/", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", KUBERNETES_PORT_443_TCP_ADDR: "10.200.128.1", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", CI_PIPELINE_URL: "https://project.scmp.tech/product/web/scmp-pwa-v2/-/pipelines/520889", DEPENDABOT_DEPENDABOT_GITLAB_PORT_3000_TCP_PROTO: "tcp", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", FF_KUBERNETES_HONOR_ENTRYPOINT: "false", PATH: "./node_modules/.bin:/builds/product/web/scmp-pwa-v2/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", CI_RUNNER_DESCRIPTION: "", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", CI_SERVER_VERSION_MINOR: "3", TECH_TEST_K8S_API: "https://172.17.28.97:6443", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", CI_JOB_STARTED_AT: "2024-11-21T09:43:49+08:00", NEXT_PUBLIC_APPLICATION: "", GITLAB_USER_EMAIL: "tony.kan@scmp.com", FF_USE_NEW_BASH_EVAL_STRATEGY: "false", FF_DISABLE_UMASK_FOR_KUBERNETES_EXECUTOR: "false", CI_PROJECT_VISIBILITY: "private", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", DEPENDABOT_REDIS_MASTER_PORT: "tcp://10.200.139.161:6379", PROD_US_K8S_DIR: "k8s.prod-us", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", CI_COMMIT_TITLE: "Merge branch 'SCMPWEB-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-version-2' into 'master'", DEPENDABOT_DEPENDABOT_GITLAB_SERVICE_PORT_HTTP: "3000", KUBERNETES_PORT_443_TCP_PORT: "443", CI_PROJECT_TITLE: "SCMP PWA V2", DEPENDABOT_REDIS_MASTER_SERVICE_PORT: "6379", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", CI_SERVER: "yes", NEXT_PUBLIC_NAVIGATOR_INFO_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", FF_USE_GIT_BUNDLE_URIS: "true", DOLLAR_SIGN: "$", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", CI_MERGE_REQUEST_EVENT_TYPE: "merge_train", APP_DIR: "./app", KUBERNETES_PORT_443_TCP_PROTO: "tcp", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", DEPENDABOT_REDIS_MASTER_PORT_6379_TCP_ADDR: "10.200.139.161", FF_TIMESTAMPS: "false", BASE_CONTAINER_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2/scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-base:scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-c24c7807732604b54cb07006988e629b8b11829e", CI_MERGE_REQUEST_ID: "77221", CI_PAGES_URL: "https://product.pages.scmp.tech/web/scmp-pwa-v2", CI_MERGE_REQUEST_APPROVED: "true", CI_PROJECT_REPOSITORY_LANGUAGES: "tsx,typescript,javascript,html,jsonnet", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://local.product-web.dev-2.scmp.tech/centralize/register?email", GITLAB_CI_TOKEN: "glcbt-64_w8gsVaFfgQ9zuetNzxum", KIBANA_GITLAB_KB_HTTP_PORT: "tcp://10.200.140.234:5601", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", FF_SET_PERMISSIONS_BEFORE_CLEANUP: "true", FF_PRINT_POD_EVENTS: "false", CF_BAN_WORKER_MQ_PORT: "5672", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", CI_SERVER_FQDN: "project.scmp.tech", DOCKER_HUB_TOKEN: "6a334d0b-ba15-4be9-9300-97c1b2d631e7", SENTRY_PROJECT: "scmp-pwa-v2-dev", CI_COMMIT_AUTHOR: "Tony Kan <tony.kan@scmp.com>", KIBANA_GITLAB_KB_HTTP_SERVICE_PORT: "5601", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", KIBANA_GITLAB_KB_HTTP_PORT_5601_TCP: "tcp://10.200.140.234:5601", CI_RUNNER_SHORT_TOKEN: "CnuEHfn36", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", CI_PAGES_DOMAIN: "pages.scmp.tech", PLANTUML_SERVER_SERVICE_PORT_HTTP: "8080", CF_BAN_WORKER_DRY_RUN: "true", TECH_TEST_K8S_DIR: "k8s.tech-test", CI_JOB_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2/scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-base:scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-c24c7807732604b54cb07006988e629b8b11829e", CI_PIPELINE_NAME: "", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", CI_JOB_TIMEOUT: "3600", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", CI_REPOSITORY_URL: "https://gitlab-ci-token:glcbt-64_w8gsVaFfgQ9zuetNzxum@project.scmp.tech/product/web/scmp-pwa-v2.git", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", GITLAB_ENV: "/builds/product/web/scmp-pwa-v2.tmp/gitlab_runner_env", DOCKER_IO_REGISTRY_PASSWORD: "6a334d0b-ba15-4be9-9300-97c1b2d631e7", CI_PROJECT_CLASSIFICATION_LABEL: "", DEPENDABOT_REDIS_MASTER_PORT_6379_TCP_PORT: "6379", NODE_PATH: "/builds/product/web/scmp-pwa-v2/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules/nx/bin/node_modules:/builds/product/web/scmp-pwa-v2/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules/nx/node_modules:/builds/product/web/scmp-pwa-v2/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules:/builds/product/web/scmp-pwa-v2/node_modules/.pnpm/node_modules", DEPENDABOT_REDIS_MASTER_PORT_6379_TCP_PROTO: "tcp", FF_USE_POWERSHELL_PATH_RESOLVER: "false", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", CI_API_GRAPHQL_URL: "https://project.scmp.tech/api/graphql", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NPM_CI_EMAIL: "verdaccio@scmp.com", OSS_REGION: "oss-cn-hongkong", CI_RUNNER_ID: "1466", DEPENDABOT_DEPENDABOT_GITLAB_PORT_3000_TCP: "tcp://10.200.143.203:3000", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_SERVICE_PORT_HTTP: "9200", NX_HEAD: "c24c7807732604b54cb07006988e629b8b11829e", BURP_SUITE_SCANNING_API_KEY: "YoegcJ6dUKVEBlg5IJ01X3htuKXO9cX5", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", CI_API_V4_URL: "https://project.scmp.tech/api/v4", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", VAULT_TOKEN: "hvs.CAESIDMD7acriDL71ER02SBKu441KlPYh2kZLfnvmSsSuuSsGh4KHGh2cy52ZDdiUnZVVlFUQVZVWnlXeHBYNlE0OG8", CI_MERGE_REQUEST_SOURCE_PROJECT_URL: "https://project.scmp.tech/product/web/scmp-pwa-v2", CI_DEPENDENCY_PROXY_DIRECT_GROUP_IMAGE_PREFIX: "project.scmp.tech:443/product/web/dependency_proxy/containers", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", DEPENDABOT_DEPENDABOT_GITLAB_SERVICE_HOST: "10.200.143.203", CI_REGISTRY: "registry.scmp.tech", GITLAB_USER_NAME: "Tony Kan", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://local.product-web.dev-2.scmp.tech/centralize/signin?nonce", DEV_2_K8S_TKN: "eyJhbGciOiJSUzI1NiIsImtpZCI6IiJ9.eyJpc3MiOiJrdWJlcm5ldGVzL3NlcnZpY2VhY2NvdW50Iiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9uYW1lc3BhY2UiOiJwcm9kdWN0LXdlYiIsImt1YmVybmV0ZXMuaW8vc2VydmljZWFjY291bnQvc2VjcmV0Lm5hbWUiOiJnaXRsYWItdG9rZW4tazI5Z2giLCJrdWJlcm5ldGVzLmlvL3NlcnZpY2VhY2NvdW50L3NlcnZpY2UtYWNjb3VudC5uYW1lIjoiZ2l0bGFiIiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9zZXJ2aWNlLWFjY291bnQudWlkIjoiMmFmZGY4MDItYmE0Ni0xMWU4LTljNjQtMDAxNjNlMDEzMWQyIiwic3ViIjoic3lzdGVtOnNlcnZpY2VhY2NvdW50OnByb2R1Y3Qtd2ViOmdpdGxhYiJ9.FfAFuH12VLsbQQHJe-gXtPnyNowE1zB00ewEOtqZPar5WSySlkXo2gLWt34Il_3Lih1IqaIgJ8bsXiNFEn0WaRsbqwegIkq6zq9CMXhX3LK8iIVudD78Kc_YyN53EA4FZhUm_5I-UQoMNCjQmK18uBpNvIIjIOjex5TXhD4S6UxAcM7l-dgi1DLs-AslmjUKNOwIU8tvk5PX8f44mA3DMgeOO-s4DLzNkqM_gP_8Zx1zjsBImRoYEtfbD3-kwQwEeXpf8XZNCRUl6Tr5AaSxsQjM3A3wsu40J1KWxWuomi8stEI_68Eamw_otwcNygaX3xzU-CTOVDlpWJ7n1nPE3Q", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", ELASTICSEARCH_GITLAB_ES_HTTP_SERVICE_PORT_HTTP: "9200", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", CI_MERGE_REQUEST_PROJECT_ID: "1232", CI_PIPELINE_IID: "80800", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_PORT_9200_TCP_ADDR: "10.200.143.51", KUBERNETES_SERVICE_PORT_HTTPS: "443", CI_RUNNER_EXECUTABLE_ARCH: "linux/amd64", DOCKER_IO_REGISTRY_USER: "scmptechsys", NEXT_PUBLIC_DRUPAL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/scmp-d8", CI_MERGE_REQUEST_DESCRIPTION_IS_TRUNCATED: "false", KUBERNETES_PORT_443_TCP: "tcp://10.200.128.1:443", FF_USE_POD_ACTIVE_DEADLINE_SECONDS: "true", FF_USE_ADVANCED_POD_SPEC_CONFIGURATION: "false", VAULT_ID_TOKEN: "eyJraWQiOiJSM0NZUDNmS1FHZ29sZml6eTJhczBSa1NlZVNKWlBIUFFrOFQ2RWlObzVrIiwidHlwIjoiSldUIiwiYWxnIjoiUlMyNTYifQ.eyJuYW1lc3BhY2VfaWQiOiIxMCIsIm5hbWVzcGFjZV9wYXRoIjoicHJvZHVjdC93ZWIiLCJwcm9qZWN0X2lkIjoiMTIzMiIsInByb2plY3RfcGF0aCI6InByb2R1Y3Qvd2ViL3NjbXAtcHdhLXYyIiwidXNlcl9pZCI6IjIxIiwidXNlcl9sb2dpbiI6InRvbnkua2FuIiwidXNlcl9lbWFpbCI6InRvbnkua2FuQHNjbXAuY29tIiwidXNlcl9hY2Nlc3NfbGV2ZWwiOiJkZXZlbG9wZXIiLCJwaXBlbGluZV9pZCI6IjUyMDg4OSIsInBpcGVsaW5lX3NvdXJjZSI6Im1lcmdlX3JlcXVlc3RfZXZlbnQiLCJqb2JfaWQiOiIyNjE4MTIyIiwicmVmIjoiU0NNUFdFQi02NjgxLW1pZ3JhdGUtcm9zZXR0YS1zZGstcy1jb250ZW50LXNlcnZpY2UtZW5kcG9pbnQtdG8tdmVyc2lvbi0yIiwicmVmX3R5cGUiOiJicmFuY2giLCJyZWZfcGF0aCI6InJlZnMvaGVhZHMvU0NNUFdFQi02NjgxLW1pZ3JhdGUtcm9zZXR0YS1zZGstcy1jb250ZW50LXNlcnZpY2UtZW5kcG9pbnQtdG8tdmVyc2lvbi0yIiwicmVmX3Byb3RlY3RlZCI6ImZhbHNlIiwicnVubmVyX2lkIjoxNDY2LCJydW5uZXJfZW52aXJvbm1lbnQiOiJzZWxmLWhvc3RlZCIsInNoYSI6ImMyNGM3ODA3NzMyNjA0YjU0Y2IwNzAwNjk4OGU2MjliOGIxMTgyOWUiLCJwcm9qZWN0X3Zpc2liaWxpdHkiOiJwcml2YXRlIiwiY2lfY29uZmlnX3JlZl91cmkiOiJwcm9qZWN0LnNjbXAudGVjaC9wcm9kdWN0L3dlYi9zY21wLXB3YS12Mi8vLmdpdGxhYi1jaS55bWxAcmVmcy9oZWFkcy9TQ01QV0VCLTY2ODEtbWlncmF0ZS1yb3NldHRhLXNkay1zLWNvbnRlbnQtc2VydmljZS1lbmRwb2ludC10by12ZXJzaW9uLTIiLCJjaV9jb25maWdfc2hhIjoiYzI0Yzc4MDc3MzI2MDRiNTRjYjA3MDA2OTg4ZTYyOWI4YjExODI5ZSIsImp0aSI6IjIzNTU4ZDJhLTJlNzgtNDcxNS04YjhiLWRhZjQ1NjA0MjU2NCIsImlhdCI6MTczMjE1MzQzMCwibmJmIjoxNzMyMTUzNDI1LCJleHAiOjE3MzIxNTcwMzAsImlzcyI6Imh0dHBzOi8vcHJvamVjdC5zY21wLnRlY2giLCJzdWIiOiJwcm9qZWN0X3BhdGg6cHJvZHVjdC93ZWIvc2NtcC1wd2EtdjI6cmVmX3R5cGU6YnJhbmNoOnJlZjpTQ01QV0VCLTY2ODEtbWlncmF0ZS1yb3NldHRhLXNkay1zLWNvbnRlbnQtc2VydmljZS1lbmRwb2ludC10by12ZXJzaW9uLTIiLCJhdWQiOiJodHRwczovL3Byb2plY3Quc2NtcC50ZWNoIn0.CPcQicVPGc2wI4IuEAorrz3jOG1jhpuMWN-KgZqgJuIusZcYr-nqe9YQdjFTxrLhGD-9n3HqJQAlo_pBPxHvzCsamIxebsIx6vEnPcTbdvOdL8LteOmCM_hWxDDk-__k3NncIs6-9i-Sxjp-mJpDloC6TKM1zSmguVsr21DzPCRovGCYH92gWRAstcfvUM7OOBO9sSpz7oEm3qugWuDYQgObGIyWjJoVaXuXSk8KCBZC2xR1O_3T2JnQwmpDpTNbEkylok9g2onbfyNMoOEMuqoz7gl2dOBUzNQ8dwiufpwcr6wO9fLaSnZ8bCDDrKqi06Q1Sqn5wi7FiRqYkLs4jg", CI_SERVER_SHELL_SSH_HOST: "project.scmp.tech", CI_JOB_URL: "https://project.scmp.tech/product/web/scmp-pwa-v2/-/jobs/2618122", PNPM_PACKAGE_NAME: "scmp-pwa-v2", FF_USE_INIT_WITH_DOCKER_EXECUTOR: "false", DEV_2_K8S_NS: "product-web", NEXT_PUBLIC_NAVIGATOR_INFO_URL: "/navigator-info", FF_TEST_FEATURE: "false", CI_MERGE_REQUEST_REF_PATH: "refs/merge-requests/3261/head", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", ELASTICSEARCH_GITLAB_ES_HTTP_PORT_9200_TCP_ADDR: "10.200.135.60", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_PORT_9200_TCP_PORT: "9200", CI_COMMIT_REF_SLUG: "scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to", PWD: "/builds/product/web/scmp-pwa-v2", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", PLANTUML_SERVER_SERVICE_HOST: "10.200.132.244", CF_BAN_WORKER_MQ_EXCHANGE_TYPE: "fanout", NEXT_PUBLIC_AMP_READER_ID: "", CI_DISPOSABLE_ENVIRONMENT: "true", KUBERNETES_SERVICE_HOST: "10.200.128.1", PLANTUML_SERVER_PORT_8080_TCP_ADDR: "10.200.132.244", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", CI_RUNNER_TAGS: '["k8s"]', CI_MERGE_REQUEST_PROJECT_PATH: "product/web/scmp-pwa-v2", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_PORT_9200_TCP_PROTO: "tcp", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", FF_SECRET_RESOLVING_FAILS_IF_MISSING: "true", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", CI_PIPELINE_ID: "520889", CI_SERVER_TLS_CA_FILE: "/builds/product/web/scmp-pwa-v2.tmp/CI_SERVER_TLS_CA_FILE", CI_MERGE_REQUEST_TITLE: 'Resolve SCMPWEB-6681 "Track undefined appconfig call on Piano execution"', PRISMACLOUD_CHECKOV_ACCESS_KEY_ID: "fe8aada2-cb3d-4b35-aea4-696cbbed2e29", CF_BAN_WORKER_MQ_USERNAME: "scmp", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_SERVICE_HOST: "10.200.143.51", ELASTICSEARCH_GITLAB_ES_HTTP_PORT_9200_TCP_PORT: "9200", CI_PROJECT_PATH_SLUG: "product-web-scmp-pwa-v2", CI_COMMIT_BEFORE_SHA: "c24c7807732604b54cb07006988e629b8b11829e", CI_CONFIG_PATH: ".gitlab-ci.yml", CI_PROJECT_URL: "https://project.scmp.tech/product/web/scmp-pwa-v2", npm_command: "run-script", PROD_US_K8S_TKN: "eyJhbGciOiJSUzI1NiIsImtpZCI6IiJ9.eyJpc3MiOiJrdWJlcm5ldGVzL3NlcnZpY2VhY2NvdW50Iiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9uYW1lc3BhY2UiOiJwcm9kdWN0LXdlYiIsImt1YmVybmV0ZXMuaW8vc2VydmljZWFjY291bnQvc2VjcmV0Lm5hbWUiOiJnaXRsYWItdG9rZW4tOXZjczUiLCJrdWJlcm5ldGVzLmlvL3NlcnZpY2VhY2NvdW50L3NlcnZpY2UtYWNjb3VudC5uYW1lIjoiZ2l0bGFiIiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9zZXJ2aWNlLWFjY291bnQudWlkIjoiYWE5MjYyM2QtMTczYi0xMWVhLTllMTItNjY2NGY0ZDYyOTcxIiwic3ViIjoic3lzdGVtOnNlcnZpY2VhY2NvdW50OnByb2R1Y3Qtd2ViOmdpdGxhYiJ9.BMae-w42JSzPRd0dAs24C41ltReErT25aNB8jKQlputvDYZsglwcF9hnkRvJ3Ecr7sHBR0NY7SkTrVjPyRsFZHWeefFV-w8QYqOcCgXWA2FdQ4y7VkJq2tXKvC0l8cQEY_OIqVbiK6ITf4s7FwOf8wJ_K4YNHUd8_k8IjoWeYxz0x5H5nhWjVqPLPIpnI_kwPl2kAOOukdwoXgxBUxmCsa5S1TSN838xide0q_rhmRw1Vp1UWIrN_8I7AxM-py4Kq2rHSsqaKkqsns0l_n4b4_aC_LV2nuhxx3237valTCOjkeZ_3Va2mNuZc7oo9JwRBiPyJQgbDtHctGnm5NyLdg", DEPENDABOT_DEPENDABOT_GITLAB_PORT: "tcp://10.200.143.203:3000", DEPENDABOT_DEPENDABOT_GITLAB_SERVICE_PORT: "3000", CI_COMMIT_MESSAGE: `Merge branch 'SCMPWEB-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-version-2' into 'master'

Resolve SCMPWEB-6681 "Track undefined appconfig call on Piano execution"

Closes SCMPWEB-6681

See merge request product/web/scmp-pwa-v2!3261`, NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", DEPENDABOT_REDIS_MASTER_PORT_6379_TCP: "tcp://10.200.139.161:6379", ELASTICSEARCH_GITLAB_ES_HTTP_PORT_9200_TCP_PROTO: "tcp", CF_BAN_WORKER_VERSION: "local", PLANTUML_SERVER_PORT_8080_TCP_PORT: "8080", PRISMACLOUD_CHECKOV_SECRET_ACCESS_KEY: "OJmp19QTYXtMabV5bV5r6ymNqM0=", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", GITLAB_USER_ID: "21", ELASTICSEARCH_GITLAB_ES_HTTP_SERVICE_HOST: "10.200.135.60", NX_BASE: "c24c7807732604b54cb07006988e629b8b11829e~1", PLANTUML_SERVER_PORT_8080_TCP_PROTO: "tcp", CI_DEPENDENCY_PROXY_GROUP_IMAGE_PREFIX: "project.scmp.tech:443/product/dependency_proxy/containers", GITLAB_DEPLOY_KEY: `-----BEGIN OPENSSH PRIVATE KEY-----
b3BlbnNzaC1rZXktdjEAAAAABG5vbmUAAAAEbm9uZQAAAAAAAAABAAABFwAAAAdzc2gtcn
NhAAAAAwEAAQAAAQEAv60/SDiC2NigFB35wR2Clr7/XMcQv3WOM3EMxN4MomCeZhN2JTp7
oowN4pGeav9yLKy2Eu+Mcs0KRZi2wM+tl9WJBxz3Vrs2lRCLTdQVpem71IYKqCrMtP9kXN
ZLGbkvZUbyuvte+0JQRZamrLIvZ28DYs4b2s+GrmdLT3Ju3z/zxwIL3PYPer9KV//hARYc
BYDGNgK0chqY4IYiGkBhAe5Y0+NBiTzxIkXOx7JUk83SKE6Id1MPkZwOo3vNGTPKMC2A3F
WZjy6kPyGria1iUYAy3QKz9jpSxVHe/YkKD5RZJzy1OMu780256q6/QgUKzuxq3RHPPE7g
U4iref0LmQAAA8iQVt0tkFbdLQAAAAdzc2gtcnNhAAABAQC/rT9IOILY2KAUHfnBHYKWvv
9cxxC/dY4zcQzE3gyiYJ5mE3YlOnuijA3ikZ5q/3IsrLYS74xyzQpFmLbAz62X1YkHHPdW
uzaVEItN1BWl6bvUhgqoKsy0/2Rc1ksZuS9lRvK6+177QlBFlqassi9nbwNizhvaz4auZ0
tPcm7fP/PHAgvc9g96v0pX/+EBFhwFgMY2ArRyGpjghiIaQGEB7ljT40GJPPEiRc7HslST
zdIoToh3Uw+RnA6je80ZM8owLYDcVZmPLqQ/IauJrWJRgDLdArP2OlLFUd79iQoPlFknPL
U4y7vzTbnqrr9CBQrO7GrdEc88TuBTiKt5/QuZAAAAAwEAAQAAAQA9wJkUsXAmYJQiJw4h
01oRKvOmdlPE+yCXHiLZAhjb73jYtghoMhFG6wxGJFf/bNDh57q5GwgKrFhU18B5Ge95bU
g6THC7NpF9MNlQd7WJwGXNMGoah79vyKAS8M89OFY2sMbeysFs/Y5S/Rgxpy5yimdy26hJ
tHZVld3DeMCTl72urdjZWAa3hJ6zWqK47bFSFaZh4WnuoHDtuYr4lbOFtGJiqN+opr5Lk2
5wZQNz3IPup5E/uFGJs7lldKO+fB0gkrw9VIGAQVJMO+hgAwnDaiA4iQlcpTtqlF1TqQje
EPj5jr2D5dcBlkcZJ3KC831R097bRx8dfcnQhJe4i5+pAAAAgEzoqFjEy4eQP9xOFlwPq7
pnrLroseOtqxnkT8Zw/leKmjUGdmrywmkQfZkdBf614Ekdjdb9cibcWHin6OR+lVTLboyK
lovM92mQGxx09smalKwLdnjn24tfkORqFGoGa1j8DxsXo40vPNSgOdIULzYMOlpGXK0+v6
Oin8uDRooBAAAAgQDx6G+bl7LvvGityg6gFhBX+SuVhZqdfycwmXmrSkUXe8USBg4JWW43
dDA1BRAaT4ymh/kWm0+FS05gWnwnTLGx69ba1alIVbIcNkt2bhVRNupDZrlNQ2AOqHme6G
/QpFq1mGj5OMo11QschxrNeCRSeMK5QHCzJOUqGjIaudR14wAAAIEAyte3FcH3P0XsnXnr
pqxn4CGvRU6DvHM5o4Q/jInLwds6nR5yU7D0WUj+B7Vy3tw/6XXCDwDtMPbSuTUQtGIgz6
4wOk9QpRHHxTJZXVafu3ladM0PTRIrYRfHfsQ/N3D5Y8zP0TXfGmjiT/33d7ypc91jCP4Q
Nx88CNZxy2VaUVMAAAAORGVwbG95bWVudCBrZXkBAgMEBQ==
-----END OPENSSH PRIVATE KEY-----`, FF_ENABLE_BASH_EXIT_CODE_CHECK: "false", CI_JOB_NAME: "checking", CI_OPEN_MERGE_REQUESTS: "product/web/scmp-pwa-v2!3261", CI_JOB_STATUS: "running", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", CI_MERGE_REQUEST_DIFF_BASE_SHA: "f393f8ab25618c1327d94d7dd0ba98de434e3122", APP_CONTAINER_LATEST_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2/scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-app:scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-latest", CI_SERVER_SHELL_SSH_PORT: "22", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", CI_MERGE_REQUEST_TARGET_BRANCH_NAME: "master", PROD_US_K8S_NS: "product-web", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", DEPENDABOT_REDIS_MASTER_SERVICE_PORT_TCP_REDIS: "6379", NX_CLI_SET: "true", NX_VERBOSE_LOGGING: "true", NX_LOAD_DOT_ENV_FILES: "true", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce=", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email=", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fscmp%2F&width=86&layout=button_count&action=like&size=small&share=false&height=21&appId=282931841805811", STORYBOOK_ROSETTA_HOST: "https://subscribe.scmp.com", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", STORYBOOK_SITE_URL: "https://local.product-web.dev-2.scmp.tech/", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", FORCE_COLOR: "true", NX_WORKSPACE_ROOT: "/builds/product/web/scmp-pwa-v2", NX_TASK_TARGET_PROJECT: "scmp-sdk", NX_TASK_TARGET_TARGET: "build", NX_TASK_HASH: "16797708093461223411", LERNA_PACKAGE_NAME: "scmp-sdk", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" }, Za = Ua, qa = function(t) {
  return t !== "theme";
}, Pr = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? Za : qa;
}, Lr = function(t, n, r) {
  var i;
  if (n) {
    var a = n.shouldForwardProp;
    i = t.__emotion_forwardProp && a ? function(s) {
      return t.__emotion_forwardProp(s) && a(s);
    } : a;
  }
  return typeof i != "function" && r && (i = t.__emotion_forwardProp), i;
}, $a = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return Ba(n, r, i), Ja(function() {
    return ka(n, r, i);
  }), null;
}, T = function e(t, n) {
  var r = t.__emotion_real === t, i = r && t.__emotion_base || t, a, s;
  n !== void 0 && (a = n.label, s = n.target);
  var l = Lr(t, n, r), c = l || Pr(i), E = !c("as");
  return function() {
    var p = arguments, d = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (a !== void 0 && d.push("label:" + a + ";"), p[0] == null || p[0].raw === void 0)
      d.push.apply(d, p);
    else {
      d.push(p[0][0]);
      for (var _ = p.length, f = 1; f < _; f++)
        d.push(p[f], p[0][f]);
    }
    var A = Pa(function(g, b, I) {
      var v = E && g.as || i, C = "", S = [], h = g;
      if (g.theme == null) {
        h = {};
        for (var y in g)
          h[y] = g[y];
        h.theme = N.useContext(ri);
      }
      typeof g.className == "string" ? C = La(b.registered, S, g.className) : g.className != null && (C = g.className + " ");
      var O = Wa(d.concat(S), b.registered, h);
      C += b.key + "-" + O.name, s !== void 0 && (C += " " + s);
      var w = E && l === void 0 ? Pr(v) : c, k = {};
      for (var o in g)
        E && o === "as" || // $FlowFixMe
        w(o) && (k[o] = g[o]);
      return k.className = C, k.ref = I, /* @__PURE__ */ N.createElement(N.Fragment, null, /* @__PURE__ */ N.createElement($a, {
        cache: b,
        serialized: O,
        isStringTag: typeof v == "string"
      }), /* @__PURE__ */ N.createElement(v, k));
    });
    return A.displayName = a !== void 0 ? a : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", A.defaultProps = t.defaultProps, A.__emotion_real = A, A.__emotion_base = i, A.__emotion_styles = d, A.__emotion_forwardProp = l, Object.defineProperty(A, "toString", {
      value: function() {
        return s === void 0 && Qa.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + s;
      }
    }), A.withComponent = function(g, b) {
      return e(g, Tn({}, n, b, {
        shouldForwardProp: Lr(A, b, !0)
      })).apply(void 0, d);
    }, A;
  };
};
function eo(e) {
  var t;
  return parseInt(N.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
function Ge(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
function ci(e) {
  if (typeof e != "string")
    throw new Error(Ge(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Pe(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function ui(e) {
  if (!Pe(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = ui(e[n]);
  }), t;
}
function ne(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Pe(e) && Pe(t) && Object.keys(t).forEach((i) => {
    Pe(t[i]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, i) && Pe(e[i]) ? r[i] = ne(e[i], t[i], n) : n.clone ? r[i] = Pe(t[i]) ? ui(t[i]) : t[i] : r[i] = t[i];
  }), r;
}
function ut(e, t) {
  return t ? ne(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
function to(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, i) => {
    var s, l;
    const a = /min-width:\s*([0-9.]+)/;
    return +(((s = r.match(a)) == null ? void 0 : s[1]) || 0) - +(((l = i.match(a)) == null ? void 0 : l[1]) || 0);
  });
  return n.length ? n.reduce((r, i) => {
    const a = t[i];
    return delete r[i], r[i] = a, r;
  }, {
    ...t
  }) : t;
}
function no(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function ro(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n)
    return null;
  const [, r, i] = n, a = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(i).up(a);
}
function io(e) {
  const t = (a, s) => a.replace("@media", s ? `@container ${s}` : "@container");
  function n(a, s) {
    a.up = (...l) => t(e.breakpoints.up(...l), s), a.down = (...l) => t(e.breakpoints.down(...l), s), a.between = (...l) => t(e.breakpoints.between(...l), s), a.only = (...l) => t(e.breakpoints.only(...l), s), a.not = (...l) => {
      const c = t(e.breakpoints.not(...l), s);
      return c.includes("not all and") ? c.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : c;
    };
  }
  const r = {}, i = (a) => (n(r, a), r);
  return n(i), {
    ...e,
    containerQueries: i
  };
}
const Mt = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Br = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Mt[e]}px)`
}, ao = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : Mt[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function ye(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const a = r.breakpoints || Br;
    return t.reduce((s, l, c) => (s[a.up(a.keys[c])] = n(t[c]), s), {});
  }
  if (typeof t == "object") {
    const a = r.breakpoints || Br;
    return Object.keys(t).reduce((s, l) => {
      if (no(a.keys, l)) {
        const c = ro(r.containerQueries ? r : ao, l);
        c && (s[c] = n(t[l], l));
      } else if (Object.keys(a.values || Mt).includes(l)) {
        const c = a.up(l);
        s[c] = n(t[l], l);
      } else {
        const c = l;
        s[c] = t[c];
      }
      return s;
    }, {});
  }
  return n(t);
}
function oo(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, i) => {
    const a = e.up(i);
    return r[a] = {}, r;
  }, {})) || {};
}
function so(e, t) {
  return e.reduce((n, r) => {
    const i = n[r];
    return (!i || Object.keys(i).length === 0) && delete n[r], n;
  }, t);
}
function xt(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((i, a) => i && i[a] ? i[a] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, i) => r && r[i] != null ? r[i] : null, e);
}
function kt(e, t, n, r = n) {
  let i;
  return typeof e == "function" ? i = e(n) : Array.isArray(e) ? i = e[n] || r : i = xt(e, n) || r, t && (i = t(i, r, e)), i;
}
function X(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: i
  } = e, a = (s) => {
    if (s[t] == null)
      return null;
    const l = s[t], c = s.theme, E = xt(c, r) || {};
    return ye(s, l, (d) => {
      let _ = kt(E, i, d);
      return d === _ && typeof d == "string" && (_ = kt(E, i, `${t}${d === "default" ? "" : ci(d)}`, d)), n === !1 ? _ : {
        [n]: _
      };
    });
  };
  return a.propTypes = {}, a.filterProps = [t], a;
}
function lo(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const co = {
  m: "margin",
  p: "padding"
}, uo = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, kr = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, _o = lo((e) => {
  if (e.length > 2)
    if (kr[e])
      e = kr[e];
    else
      return [e];
  const [t, n] = e.split(""), r = co[t], i = uo[n] || "";
  return Array.isArray(i) ? i.map((a) => r + a) : [r + i];
}), Jn = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Qn = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...Jn, ...Qn];
function St(e, t, n, r) {
  const i = xt(e, t, !0) ?? n;
  return typeof i == "number" || typeof i == "string" ? (a) => typeof a == "string" ? a : typeof i == "string" ? `calc(${a} * ${i})` : i * a : Array.isArray(i) ? (a) => {
    if (typeof a == "string")
      return a;
    const s = Math.abs(a), l = i[s];
    return a >= 0 ? l : typeof l == "number" ? -l : `-${l}`;
  } : typeof i == "function" ? i : () => {
  };
}
function Zn(e) {
  return St(e, "spacing", 8);
}
function ht(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function po(e, t) {
  return (n) => e.reduce((r, i) => (r[i] = ht(t, n), r), {});
}
function mo(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const i = _o(n), a = po(i, r), s = e[n];
  return ye(e, s, a);
}
function _i(e, t) {
  const n = Zn(e.theme);
  return Object.keys(e).map((r) => mo(e, t, r, n)).reduce(ut, {});
}
function j(e) {
  return _i(e, Jn);
}
j.propTypes = {};
j.filterProps = Jn;
function Y(e) {
  return _i(e, Qn);
}
Y.propTypes = {};
Y.filterProps = Qn;
function Ut(...e) {
  const t = e.reduce((r, i) => (i.filterProps.forEach((a) => {
    r[a] = i;
  }), r), {}), n = (r) => Object.keys(r).reduce((i, a) => t[a] ? ut(i, t[a](r)) : i, {});
  return n.propTypes = {}, n.filterProps = e.reduce((r, i) => r.concat(i.filterProps), []), n;
}
function ae(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function ue(e, t) {
  return X({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const Eo = ue("border", ae), fo = ue("borderTop", ae), go = ue("borderRight", ae), Ao = ue("borderBottom", ae), To = ue("borderLeft", ae), Io = ue("borderColor"), So = ue("borderTopColor"), ho = ue("borderRightColor"), Co = ue("borderBottomColor"), Ro = ue("borderLeftColor"), bo = ue("outline", ae), yo = ue("outlineColor"), Ft = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = St(e.theme, "shape.borderRadius", 4), n = (r) => ({
      borderRadius: ht(t, r)
    });
    return ye(e, e.borderRadius, n);
  }
  return null;
};
Ft.propTypes = {};
Ft.filterProps = ["borderRadius"];
Ut(Eo, fo, go, Ao, To, Io, So, ho, Co, Ro, Ft, bo, yo);
const Gt = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = St(e.theme, "spacing", 8), n = (r) => ({
      gap: ht(t, r)
    });
    return ye(e, e.gap, n);
  }
  return null;
};
Gt.propTypes = {};
Gt.filterProps = ["gap"];
const Vt = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = St(e.theme, "spacing", 8), n = (r) => ({
      columnGap: ht(t, r)
    });
    return ye(e, e.columnGap, n);
  }
  return null;
};
Vt.propTypes = {};
Vt.filterProps = ["columnGap"];
const jt = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = St(e.theme, "spacing", 8), n = (r) => ({
      rowGap: ht(t, r)
    });
    return ye(e, e.rowGap, n);
  }
  return null;
};
jt.propTypes = {};
jt.filterProps = ["rowGap"];
const No = X({
  prop: "gridColumn"
}), Oo = X({
  prop: "gridRow"
}), vo = X({
  prop: "gridAutoFlow"
}), wo = X({
  prop: "gridAutoColumns"
}), Po = X({
  prop: "gridAutoRows"
}), Lo = X({
  prop: "gridTemplateColumns"
}), Bo = X({
  prop: "gridTemplateRows"
}), ko = X({
  prop: "gridTemplateAreas"
}), Do = X({
  prop: "gridArea"
});
Ut(Gt, Vt, jt, No, Oo, vo, wo, Po, Lo, Bo, ko, Do);
function Ze(e, t) {
  return t === "grey" ? t : e;
}
const Mo = X({
  prop: "color",
  themeKey: "palette",
  transform: Ze
}), xo = X({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Ze
}), Uo = X({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Ze
});
Ut(Mo, xo, Uo);
function te(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const Fo = X({
  prop: "width",
  transform: te
}), qn = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var i, a, s, l, c;
      const r = ((s = (a = (i = e.theme) == null ? void 0 : i.breakpoints) == null ? void 0 : a.values) == null ? void 0 : s[n]) || Mt[n];
      return r ? ((c = (l = e.theme) == null ? void 0 : l.breakpoints) == null ? void 0 : c.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: te(n)
      };
    };
    return ye(e, e.maxWidth, t);
  }
  return null;
};
qn.filterProps = ["maxWidth"];
const Go = X({
  prop: "minWidth",
  transform: te
}), Vo = X({
  prop: "height",
  transform: te
}), jo = X({
  prop: "maxHeight",
  transform: te
}), Yo = X({
  prop: "minHeight",
  transform: te
});
X({
  prop: "size",
  cssProperty: "width",
  transform: te
});
X({
  prop: "size",
  cssProperty: "height",
  transform: te
});
const Ho = X({
  prop: "boxSizing"
});
Ut(Fo, qn, Go, Vo, jo, Yo, Ho);
const Yt = {
  // borders
  border: {
    themeKey: "borders",
    transform: ae
  },
  borderTop: {
    themeKey: "borders",
    transform: ae
  },
  borderRight: {
    themeKey: "borders",
    transform: ae
  },
  borderBottom: {
    themeKey: "borders",
    transform: ae
  },
  borderLeft: {
    themeKey: "borders",
    transform: ae
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: ae
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Ft
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Ze
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Ze
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Ze
  },
  // spacing
  p: {
    style: Y
  },
  pt: {
    style: Y
  },
  pr: {
    style: Y
  },
  pb: {
    style: Y
  },
  pl: {
    style: Y
  },
  px: {
    style: Y
  },
  py: {
    style: Y
  },
  padding: {
    style: Y
  },
  paddingTop: {
    style: Y
  },
  paddingRight: {
    style: Y
  },
  paddingBottom: {
    style: Y
  },
  paddingLeft: {
    style: Y
  },
  paddingX: {
    style: Y
  },
  paddingY: {
    style: Y
  },
  paddingInline: {
    style: Y
  },
  paddingInlineStart: {
    style: Y
  },
  paddingInlineEnd: {
    style: Y
  },
  paddingBlock: {
    style: Y
  },
  paddingBlockStart: {
    style: Y
  },
  paddingBlockEnd: {
    style: Y
  },
  m: {
    style: j
  },
  mt: {
    style: j
  },
  mr: {
    style: j
  },
  mb: {
    style: j
  },
  ml: {
    style: j
  },
  mx: {
    style: j
  },
  my: {
    style: j
  },
  margin: {
    style: j
  },
  marginTop: {
    style: j
  },
  marginRight: {
    style: j
  },
  marginBottom: {
    style: j
  },
  marginLeft: {
    style: j
  },
  marginX: {
    style: j
  },
  marginY: {
    style: j
  },
  marginInline: {
    style: j
  },
  marginInlineStart: {
    style: j
  },
  marginInlineEnd: {
    style: j
  },
  marginBlock: {
    style: j
  },
  marginBlockStart: {
    style: j
  },
  marginBlockEnd: {
    style: j
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Gt
  },
  rowGap: {
    style: jt
  },
  columnGap: {
    style: Vt
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: te
  },
  maxWidth: {
    style: qn
  },
  minWidth: {
    transform: te
  },
  height: {
    transform: te
  },
  maxHeight: {
    transform: te
  },
  minHeight: {
    transform: te
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function zo(...e) {
  const t = e.reduce((r, i) => r.concat(Object.keys(i)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function Wo(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Xo() {
  function e(n, r, i, a) {
    const s = {
      [n]: r,
      theme: i
    }, l = a[n];
    if (!l)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: E,
      transform: p,
      style: d
    } = l;
    if (r == null)
      return null;
    if (E === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const _ = xt(i, E) || {};
    return d ? d(s) : ye(s, r, (A) => {
      let g = kt(_, p, A);
      return A === g && typeof A == "string" && (g = kt(_, p, `${n}${A === "default" ? "" : ci(A)}`, A)), c === !1 ? g : {
        [c]: g
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: i = {}
    } = n || {};
    if (!r)
      return null;
    const a = i.unstable_sxConfig ?? Yt;
    function s(l) {
      let c = l;
      if (typeof l == "function")
        c = l(i);
      else if (typeof l != "object")
        return l;
      if (!c)
        return null;
      const E = oo(i.breakpoints), p = Object.keys(E);
      let d = E;
      return Object.keys(c).forEach((_) => {
        const f = Wo(c[_], i);
        if (f != null)
          if (typeof f == "object")
            if (a[_])
              d = ut(d, e(_, f, i, a));
            else {
              const A = ye({
                theme: i
              }, f, (g) => ({
                [_]: g
              }));
              zo(A, f) ? d[_] = t({
                sx: f,
                theme: i
              }) : d = ut(d, A);
            }
          else
            d = ut(d, e(_, f, i, a));
      }), to(i, so(p, d));
    }
    return Array.isArray(r) ? r.map(s) : s(r);
  }
  return t;
}
const Ht = Xo();
Ht.filterProps = ["sx"];
var di = { exports: {} }, rt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dr;
function Ko() {
  if (Dr) return rt;
  Dr = 1;
  var e = u, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, E) {
    var p, d = {}, _ = null, f = null;
    E !== void 0 && (_ = "" + E), c.key !== void 0 && (_ = "" + c.key), c.ref !== void 0 && (f = c.ref);
    for (p in c) r.call(c, p) && !a.hasOwnProperty(p) && (d[p] = c[p]);
    if (l && l.defaultProps) for (p in c = l.defaultProps, c) d[p] === void 0 && (d[p] = c[p]);
    return { $$typeof: t, type: l, key: _, ref: f, props: d, _owner: i.current };
  }
  return rt.Fragment = n, rt.jsx = s, rt.jsxs = s, rt;
}
di.exports = Ko();
var Jo = di.exports;
const Qo = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function Zo(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...i
  } = e, a = Qo(t), s = Object.keys(a);
  function l(_) {
    return `@media (min-width:${typeof t[_] == "number" ? t[_] : _}${n})`;
  }
  function c(_) {
    return `@media (max-width:${(typeof t[_] == "number" ? t[_] : _) - r / 100}${n})`;
  }
  function E(_, f) {
    const A = s.indexOf(f);
    return `@media (min-width:${typeof t[_] == "number" ? t[_] : _}${n}) and (max-width:${(A !== -1 && typeof t[s[A]] == "number" ? t[s[A]] : f) - r / 100}${n})`;
  }
  function p(_) {
    return s.indexOf(_) + 1 < s.length ? E(_, s[s.indexOf(_) + 1]) : l(_);
  }
  function d(_) {
    const f = s.indexOf(_);
    return f === 0 ? l(s[1]) : f === s.length - 1 ? c(s[f]) : E(_, s[s.indexOf(_) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: a,
    up: l,
    down: c,
    between: E,
    only: p,
    not: d,
    unit: n,
    ...i
  };
}
const qo = {
  borderRadius: 4
};
function pi(e = 8, t = Zn({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (r.length === 0 ? [1] : r).map((a) => {
    const s = t(a);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" ");
  return n.mui = !0, n;
}
function $o(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let i = n.getColorSchemeSelector(e);
    return i === "&" ? t : ((i.includes("data-") || i.includes(".")) && (i = `*:where(${i.replace(/\s*&$/, "")}) &`), {
      [i]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function mi(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: i,
    shape: a = {},
    ...s
  } = e, l = Zo(n), c = pi(i);
  let E = ne({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: c,
    shape: {
      ...qo,
      ...a
    }
  }, s);
  return E = io(E), E.applyStyles = $o, E = t.reduce((p, d) => ne(p, d), E), E.unstable_sxConfig = {
    ...Yt,
    ...s == null ? void 0 : s.unstable_sxConfig
  }, E.unstable_sx = function(d) {
    return Ht({
      sx: d,
      theme: this
    });
  }, E;
}
function es(e) {
  return Object.keys(e).length === 0;
}
function ts(e = null) {
  const t = N.useContext(ri);
  return !t || es(t) ? e : t;
}
const ns = mi();
function rs(e = ns) {
  return ts(e);
}
function is(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
var as = { CI_SERVER_REVISION: "f2789346710", FF_USE_WINDOWS_LEGACY_PROCESS_STRATEGY: "false", GITLAB_USER_LOGIN: "tony.kan", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", CI_COMMIT_SHORT_SHA: "c24c7807", FF_SCRIPT_SECTIONS: "false", NEXT_PUBLIC_ENV_SLUG: "local", PRISMACLOUD_CONSOLE_ADDRESS: "https://asia-southeast1.cloud.twistlock.com/aws-singapore-961147807", CI_SERVER_VERSION_PATCH: "3", CF_BAN_WORKER_MQ_EXCHANGE_NAME: "varnish_bans", FF_POSIXLY_CORRECT_ESCAPES: "false", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", KUBERNETES_SERVICE_PORT: "443", TECH_TEST_K8S_TKN: "eyJhbGciOiJSUzI1NiIsImtpZCI6IiJ9.eyJpc3MiOiJrdWJlcm5ldGVzL3NlcnZpY2VhY2NvdW50Iiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9uYW1lc3BhY2UiOiJwcm9kdWN0LXdlYiIsImt1YmVybmV0ZXMuaW8vc2VydmljZWFjY291bnQvc2VjcmV0Lm5hbWUiOiJnaXRsYWItdG9rZW4tdmRuajgiLCJrdWJlcm5ldGVzLmlvL3NlcnZpY2VhY2NvdW50L3NlcnZpY2UtYWNjb3VudC5uYW1lIjoiZ2l0bGFiIiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9zZXJ2aWNlLWFjY291bnQudWlkIjoiNGRmNTkyYjEtZGI1Yy0xMWU5LTk0NTctNDY0ZDU0MjlmYzc3Iiwic3ViIjoic3lzdGVtOnNlcnZpY2VhY2NvdW50OnByb2R1Y3Qtd2ViOmdpdGxhYiJ9.bJsbob7RAgJTsZSGTlaXPrh_Panqb8OVRqPqpcKroF_I8OHNr2R70y2IdLDNx2O6h1FlkDDauCGBfcYwsGHv2QVsMrUsWegNGxDp42mT81C2vse7OZjfssWBowAIw7OBpCAa3F_cU8gQwh5txTWZPdJYgeYe4da9FRqx4FwMEubGoR_y6WCd_GGA6y0BudD3AdvTfDKw8J3OhnUipLjNMufOSOPObSK97XUTKA5mC-rm5aq97df_KqE8dopwPvSQUIt4jQ5uC6FQhf8Tu_NMu3ZO8hRZSvyApw2IbCDbrCYn374ZPpXK18px9HD7CCa6XbVTRzPScUpFtXqoe4OD0Q", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", FF_GITLAB_REGISTRY_HELPER_IMAGE: "1", PLANTUML_SERVER_SERVICE_PORT: "8080", CI_DEPENDENCY_PROXY_PASSWORD: "glcbt-64_w8gsVaFfgQ9zuetNzxum", CF_BAN_WORKER_DEBUG: "true", CF_BAN_WORKER_MQ_PATH: "scmp", PLANTUML_SERVER_PORT: "tcp://10.200.132.244:8080", KUBERNETES_PORT: "tcp://10.200.128.1:443", CI_DEPENDENCY_PROXY_SERVER: "project.scmp.tech:443", CI_MERGE_REQUEST_TARGET_BRANCH_PROTECTED: "true", FF_USE_DUMB_INIT_WITH_KUBERNETES_EXECUTOR: "false", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", npm_config_user_agent: "pnpm/9.14.2 npm/? node/v20.18.1 linux x64", DEV_2_K8S_CA: `-----BEGIN CERTIFICATE-----
MIIC/zCCAmigAwIBAgIDChmPMA0GCSqGSIb3DQEBCwUAMGIxCzAJBgNVBAYTAkNO
MREwDwYDVQQIDAhaaGVKaWFuZzERMA8GA1UEBwwISGFuZ1pob3UxEDAOBgNVBAoM
B0FsaWJhYmExDDAKBgNVBAsMA0FDUzENMAsGA1UEAwwEcm9vdDAeFw0xODA5MTcw
NDUwMDBaFw0zODA5MTIwNDU1NDVaMGoxKjAoBgNVBAoTIWNiMTRhNjliNDA3Zjc0
ZjgyOTJmN2IxYzFhNTkxMmY1MDEQMA4GA1UECxMHZGVmYXVsdDEqMCgGA1UEAxMh
Y2IxNGE2OWI0MDdmNzRmODI5MmY3YjFjMWE1OTEyZjUwMIGfMA0GCSqGSIb3DQEB
AQUAA4GNADCBiQKBgQCmblHyvBcwmgL5h7jdNRvyxzh/+v98y0pHTMQ1VPRWdabG
V/tFL86A+Jz7iWgvAgvYCHiIvMQHvfeXX77DU1IYWDmHN5/WPqWtfeyIsy8cN53G
ihkrj93kWiNIFr34MDmlYAbYCfJEZPMw2JmU0YCyrHHJ7z8pqas+ZJhMtPzK6wID
AQABo4G6MIG3MA4GA1UdDwEB/wQEAwICrDAPBgNVHRMBAf8EBTADAQH/MB8GA1Ud
IwQYMBaAFIVa/90jzSVvWEFvnm1FOZtYfXX/MDwGCCsGAQUFBwEBBDAwLjAsBggr
BgEFBQcwAYYgaHR0cDovL2NlcnRzLmFjcy5hbGl5dW4uY29tL29jc3AwNQYDVR0f
BC4wLDAqoCigJoYkaHR0cDovL2NlcnRzLmFjcy5hbGl5dW4uY29tL3Jvb3QuY3Js
MA0GCSqGSIb3DQEBCwUAA4GBADKz+HFYxSJDeA7Q0lm9c4xefH9Sdw+tzHH5uYPu
tDyY1YWG+fUboTyWTRpfbbpt+hvO7NZKl4Y7F9Zivk7EaoqfiOAqHE/tBHvSqwkG
48KggF0CTP3GutsGerKqOGnciQtk0Wh3Nk47gLN+yK9BFdwGPeN6l8oIAP9oVIIP
k6UF
-----END CERTIFICATE-----`, CI_PROJECT_NAME: "scmp-pwa-v2", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_PORT_9200_TCP: "tcp://10.200.143.51:9200", NPM_CI_USERNAME: "verdaccio", CI_SERVER_PROTOCOL: "https", TECH_TEST_K8S_NS: "product-web", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", FF_USE_LEGACY_KUBERNETES_EXECUTION_STRATEGY: "0", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", CI_RUNNER_REVISION: "66269445", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_SERVICE_PORT: "9200", FF_LOG_IMAGES_CONFIGURED_FOR_JOB: "false", CI: "true", NODE_VERSION: "20.18.1", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_PORT: "tcp://10.200.143.51:9200", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/local", HOSTNAME: "runner-cnuehfn36-project-1232-concurrent-0-h6m7etnj", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", YARN_VERSION: "1.22.22", ECI_CONTAINER_TYPE: "normal", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", CI_COMMIT_DESCRIPTION: `Merge branch 'SCMPWEB-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-version-2' into 'master'

Resolve SCMPWEB-6681 "Track undefined appconfig call on Piano execution"

Closes SCMPWEB-6681

See merge request product/web/scmp-pwa-v2!3261`, CI_JOB_STAGE: "misc", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", CI_PROJECT_DESCRIPTION: `South China Morning Post web app v2\r
\r
http://product.pages.scmp.tech/web/scmp-pwa-v2`, NEXT_PUBLIC_SITE_URL: "https://local.product-web.dev-2.scmp.tech/", ELASTICSEARCH_GITLAB_ES_HTTP_SERVICE_PORT: "9200", ELASTICSEARCH_GITLAB_ES_HTTP_PORT: "tcp://10.200.135.60:9200", K8S_VAULT_ROLE: "product-web-scmp-pwa-v2", CI_SERVER_VERSION: "17.3.3-ee", ELASTICSEARCH_GITLAB_ES_HTTP_PORT_9200_TCP: "tcp://10.200.135.60:9200", VAULT_ADDR: "https://vault.dev-2.scmp.tech", CI_MERGE_REQUEST_SOURCE_PROJECT_ID: "1232", SHLVL: "2", CI_DEPENDENCY_PROXY_USER: "gitlab-ci-token", FF_DISABLE_POWERSHELL_STDIN: "false", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", PLANTUML_SERVER_PORT_8080_TCP: "tcp://10.200.132.244:8080", CF_BAN_WORKER_CLOUDFLARE_API_KEY: "DO NOT SET IN LOCAL", HOME: "/root", FF_DISABLE_AUTOMATIC_TOKEN_ROTATION: "false", CI_PROJECT_ROOT_NAMESPACE: "product", APP_RUNTIME_BASE_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2/scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-app-runtime-base:scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-c24c7807732604b54cb07006988e629b8b11829e", FF_CLEAN_UP_FAILED_CACHE_EXTRACT: "false", OLDPWD: "/app", FF_NETWORK_PER_BUILD: "false", CI_COMMIT_REF_NAME: "SCMPWEB-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-version-2", CI_SERVER_HOST: "project.scmp.tech", CI_JOB_ID: "2618122", CI_RUNNER_VERSION: "17.3.1", CI_MERGE_REQUEST_TARGET_BRANCH_SHA: "80b1b6ac84065cb4786b93b6f2598e3e551e874f", CI_PIPELINE_SOURCE: "merge_request_event", FF_RESOLVE_FULL_TLS_CHAIN: "false", FF_SKIP_NOOP_BUILD_STAGES: "true", CI_MERGE_REQUEST_SOURCE_BRANCH_NAME: "SCMPWEB-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-version-2", CI_MERGE_REQUEST_SOURCE_PROJECT_PATH: "product/web/scmp-pwa-v2", FF_USE_WINDOWS_JOB_OBJECT: "false", CI_DEFAULT_BRANCH: "master", PROD_US_K8S_CA: `-----BEGIN CERTIFICATE-----
MIIDGjCCAgKgAwIBAgIBADANBgkqhkiG9w0BAQsFADA+MScwFAYDVQQKEw1hbGli
YWJhIGNsb3VkMA8GA1UEChMIaGFuZ3pob3UxEzARBgNVBAMTCmt1YmVybmV0ZXMw
HhcNMTkxMjA1MDcxMDA4WhcNMjkxMjAyMDcxMDA4WjA+MScwFAYDVQQKEw1hbGli
YWJhIGNsb3VkMA8GA1UEChMIaGFuZ3pob3UxEzARBgNVBAMTCmt1YmVybmV0ZXMw
ggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDEYXp13ukiTy3fevdO/47O
Ocr5skJ2MMOaIyx/aFLm2RlIo0qO9RanMLD8Pjx9Lz4bJHhEpx4BnPnUemsC2cm/
UrhY+Lfjr4op8nwmtE42evx4FRzuYRBsiEbc7+Yvjvl8tE0my5HVw5MAvWOFlE+X
J75pgHmC1IT91jWmhx8NnBHgHowZ0eqPWNns5rxjc83k1U3u6275SYi9ZLhBDmUj
kTR0IwtVLRdQhljU6pIN2lfjyerab3JEcEo6RvuFlBcLHCr0tzCNLpWWXceIiDuj
vmYCac07wpw9+HtBCCnd8i7rb6uJknn0IeGD/Flx519+dbHaCK+v0/zj0iYKetmb
AgMBAAGjIzAhMA4GA1UdDwEB/wQEAwICpDAPBgNVHRMBAf8EBTADAQH/MA0GCSqG
SIb3DQEBCwUAA4IBAQBOHn3zDbHPTT+xpn7MsmRxMT6H8NSPRgUHQxcBOQwT+ylY
vGnbhAYRHv9wrEZy3Pt+F4ncjcEFTMjuf5cLjIuKOfG6+BMpGL6kt17ZKrX5mwSb
BkZHrnb7ifCPLuMtcp2JzZ2oOTwFyTVkdCo9xgaHXGZjARvJgNv39dbZiI5UtqbC
OINGWinvMu3JA6kvIHcKp67BRDl+oYj25d13nV+pY7JaIJWFnXBsVrOd2MoIByrH
NaqLulwTvcRcPJ3CiyyzP2v4t6r+0IJA+lYLD5XtYGjkxBZOw+jkvSINEuMCtIcT
reUxC93rX4LAojF3ozW5uPKWMXXqPwPDa5oAOFJQ
-----END CERTIFICATE-----`, CI_BUILDS_DIR: "/builds", CI_SERVER_VERSION_MAJOR: "17", FF_USE_FASTZIP: "false", CI_REGISTRY_PASSWORD: "glcbt-64_w8gsVaFfgQ9zuetNzxum", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", CI_COMMIT_REF_PROTECTED: "false", UNLEASH_SERVER_API_TOKEN: "token", CI_SERVER_URL: "https://project.scmp.tech", CI_TEMPLATE_REGISTRY_HOST: "registry.gitlab.com", CI_MERGE_REQUEST_DIFF_ID: "352616", CF_BAN_WORKER_CLOUDFLARE_ZONE: "DO NOT SET IN LOCAL", PRISMACLOUD_ACCESS_KEY_ID: "407567c0-39ea-479f-8bac-55a292a0053b", CI_MERGE_REQUEST_ASSIGNEES: "shawn.yeung", GITLAB_FEATURES: "audit_events,blocked_issues,board_iteration_lists,code_owners,code_review_analytics,full_codequality_report,group_activity_analytics,group_bulk_edit,issuable_default_templates,issue_weights,iterations,ldap_group_sync,merge_request_approvers,milestone_charts,multiple_issue_assignees,multiple_ldap_servers,multiple_merge_request_assignees,multiple_merge_request_reviewers,project_merge_request_analytics,protected_refs_for_users,push_rules,resource_access_token,seat_link,seat_usage_quotas,pipelines_usage_quotas,transfer_usage_quotas,product_analytics_usage_quotas,wip_limits,zoekt_code_search,blocked_work_items,description_diffs,send_emails_from_admin_area,repository_size_limit,maintenance_mode,scoped_issue_board,contribution_analytics,group_webhooks,member_lock,elastic_search,repository_mirrors,ai_chat,adjourned_deletion_for_projects_and_groups,admin_audit_log,auditor_user,blocking_merge_requests,board_assignee_lists,board_milestone_lists,ci_secrets_management,ci_pipeline_cancellation_restrictions,cluster_agents_ci_impersonation,cluster_agents_user_impersonation,cluster_deployments,code_owner_approval_required,code_suggestions,commit_committer_check,commit_committer_name_check,compliance_framework,custom_compliance_frameworks,custom_file_templates,custom_project_templates,cycle_analytics_for_groups,cycle_analytics_for_projects,db_load_balancing,default_branch_protection_restriction_in_groups,default_project_deletion_protection,delete_unconfirmed_users,dependency_proxy_for_packages,disable_name_update_for_users,disable_personal_access_tokens,domain_verification,epics,extended_audit_events,external_authorization_service_api_management,feature_flags_code_references,file_locks,geo,generic_alert_fingerprinting,git_two_factor_enforcement,group_allowed_email_domains,group_coverage_reports,group_forking_protection,group_level_compliance_dashboard,group_milestone_project_releases,group_project_templates,group_repository_analytics,group_saml,group_scoped_ci_variables,ide_schema_config,incident_metric_upload,instance_level_scim,jira_issues_integration,ldap_group_sync_filter,merge_request_performance_metrics,admin_merge_request_approvers_rules,merge_trains,metrics_reports,multiple_alert_http_integrations,multiple_approval_rules,multiple_group_issue_boards,object_storage,microsoft_group_sync,operations_dashboard,package_forwarding,pages_size_limit,pages_multiple_versions,productivity_analytics,project_aliases,protected_environments,reject_non_dco_commits,reject_unsigned_commits,remote_development,saml_group_sync,service_accounts,scoped_labels,smartcard_auth,ssh_certificates,swimlanes,target_branch_rules,type_of_work_analytics,minimal_access_role,unprotection_restrictions,ci_project_subscriptions,incident_timeline_view,oncall_schedules,escalation_policies,zentao_issues_integration,coverage_check_approval_rule,issuable_resource_links,group_protected_branches,group_level_merge_checks_setting,oidc_client_groups_claim,disable_deleting_account_for_users,disable_private_profiles,group_saved_replies,requested_changes_block_merge_request,project_saved_replies,group_ip_restriction,issues_analytics,password_complexity,group_wikis,email_additional_text,custom_file_templates_for_namespace,incident_sla,export_user_permissions,cross_project_pipelines,feature_flags_related_issues,merge_pipelines,ci_cd_projects,github_integration", OSS_HOST: "assets-v2-dev.i-scmp.com", aliyun_log_crd_user_defined_id: "k8s-group-cb14a69b407f74f8292f7b1c1a5912f50", CI_REGISTRY_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", DEV_2_K8S_API: "https://172.17.31.240:6443", CI_PROJECT_ID: "1232", PRISMACLOUD_SECRET_ACCESS_KEY: "naF4oChJr+EIx8iNtw/UKjbp+eM=", CI_MERGE_REQUEST_SOURCE_BRANCH_PROTECTED: "false", CI_COMMIT_SHA: "c24c7807732604b54cb07006988e629b8b11829e", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_COMMIT_SHA: "123456", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", GITLAB_CI: "true", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", FF_USE_LEGACY_GCS_CACHE_ADAPTER: "false", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", FF_RETRIEVE_POD_WARNING_EVENTS: "true", CONTAINER_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2/scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to:my-app-c24c7807732604b54cb07006988e629b8b11829e", TECH_TEST_K8S_CA: `-----BEGIN CERTIFICATE-----
MIIDGjCCAgKgAwIBAgIBADANBgkqhkiG9w0BAQsFADA+MScwFAYDVQQKEw1hbGli
YWJhIGNsb3VkMA8GA1UEChMIaGFuZ3pob3UxEzARBgNVBAMTCmt1YmVybmV0ZXMw
HhcNMTkwOTA2MDgxODExWhcNMjkwOTAzMDgxODExWjA+MScwFAYDVQQKEw1hbGli
YWJhIGNsb3VkMA8GA1UEChMIaGFuZ3pob3UxEzARBgNVBAMTCmt1YmVybmV0ZXMw
ggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQCjpJnyPbkYl4u9FhpfYBzf
yvzQijTIRcMTjO7S5J+vL1mW9TrEc2amGqZdE1LprnX7DmIT/kEj7AdRPtfrYoNy
fyhfZUx028Tw9y6iYTRQYrLMMHN/SfwxwE3PY62i+RwoktglL/u5d/SOGOVgqufJ
EZn9hzOPTw+N+eKGqNh0lX8LXr1r5jGmZsXlkKbUGGLjqEuKQKO207aqajEt97tb
q8ZpStK6ATIgrwlYelxv3ZwzCVso2OH0CyyvH/qugGq4vyM9Hnn729/quufLnayF
mer0PAVALX1NsdSZm0k71H1mgeT8XZJxwrsfVFf4FcGsXMEMopvqXYoXCPDydkjh
AgMBAAGjIzAhMA4GA1UdDwEB/wQEAwICpDAPBgNVHRMBAf8EBTADAQH/MA0GCSqG
SIb3DQEBCwUAA4IBAQASqGWWDbUWBePbDgMHIjQGQFrUYUpLHcFyJ1DSjmec3Y2n
lPrcBtdCNJoiI3GJW2opePg4WiSz0VEzk989MGumjT/Fgh5nun5G4ZXgpVW3eFp9
ACl/34lYHPoI3JQnFPinB9Z+IesuA/TTImlznt5YTS8+NTdLk0ZQBaJrTciPSHvH
yNkFzVqwG2pjeBnwH0jxQWzuMKRpFfTpxS749k5e02F7sg6asTB8uCoozPyPwwTJ
IWcOi0WlKqCLaBT5NzGQlsMdYNkmuebuO0uBSFEHSgtI9cwy2VE7Cx5gj3pOf3CU
7VgXQvpVBIpaQUMMffhrdBALeLq49VqmqYlxf0vT
-----END CERTIFICATE-----`, CI_CONCURRENT_ID: "3", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NPM_CI_AUTH: "product-group-access-token:glpat-T5AespE5Pb7n-PTGxdkP", CI_REGISTRY_USER: "gitlab-ci-token", KIBANA_GITLAB_KB_HTTP_PORT_5601_TCP_ADDR: "10.200.140.234", NPM_CI_TOKEN: "CmMfvanLky2LHKwSaYZf", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", FF_USE_DOCKER_AUTOSCALER_DIAL_STDIO: "true", CI_SERVER_PORT: "443", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "local-dev-sw", KANIKO_BUILD_TOKEN: "wmBPb7CzvxxsRiLK1724", CI_MERGE_REQUEST_SQUASH_ON_MERGE: "false", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", DEV_2_ARGOCD_SERVER: "argocd.dev-2.scmp.tech:443", DEV_2_ARGOCD_TKN: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJhZWNlNTM1ZS0yMWUwLTQ4MTEtOWI0ZS1lZjY4ZGU4NzEzN2IiLCJpYXQiOjE2MjU4MDU5OTAsImlzcyI6ImFyZ29jZCIsIm5iZiI6MTYyNTgwNTk5MCwic3ViIjoicHJvajpwcm9kdWN0LXdlYjpHaXRsYWItQ0kifQ.6yuMOdMujHfVuyWNjK9ydu1Evo6Q18MUTvqES1ZsOEY", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", FF_DISABLE_UMASK_FOR_DOCKER_EXECUTOR: "false", DEPENDABOT_REDIS_MASTER_SERVICE_HOST: "10.200.139.161", CI_PROJECT_PATH: "product/web/scmp-pwa-v2", CI_MERGE_REQUEST_PROJECT_URL: "https://project.scmp.tech/product/web/scmp-pwa-v2", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", CI_PROJECT_DIR: "/builds/product/web/scmp-pwa-v2", CF_BAN_WORKER_MQ_PASSWORD: "123456", CI_PROJECT_NAMESPACE: "product/web", KIBANA_GITLAB_KB_HTTP_SERVICE_PORT_HTTPS: "5601", CHUNK_SIZE_NEEDS_JOB_NAME: "build-qa-app-image", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", GITLAB_PRIVATE_ACCESS_TOKEN: "glpat-47s2_tfGH97pMgaR4vbD", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", FF_ENABLE_JOB_CLEANUP: "false", CI_COMMIT_TIMESTAMP: "2024-11-21T09:37:17+08:00", DEPENDABOT_DEPENDABOT_GITLAB_PORT_3000_TCP_ADDR: "10.200.143.203", DEV_2_K8S_DIR: "k8s.dev-2", _: "/usr/local/bin/pnpm", CI_SERVER_NAME: "GitLab", KIBANA_GITLAB_KB_HTTP_PORT_5601_TCP_PORT: "5601", PROD_US_K8S_API: "https://47.254.23.77:6443", FF_USE_DIRECT_DOWNLOAD: "true", CI_MERGE_REQUEST_DESCRIPTION: `![image](/uploads/ab28b1aabb977f0b1ce389c16453e400/image.png){width=952 height=414}

Keep track of piano performance calls even if the app configuration is undefined.
Related to SCMPWEB-6681`, K8S_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", CI_JOB_TOKEN: "glcbt-64_w8gsVaFfgQ9zuetNzxum", FF_USE_DYNAMIC_TRACE_FORCE_SEND_INTERVAL: "false", CI_NODE_TOTAL: "1", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", DOCKER_REGISTRY_MIRROR: "http://172.17.30.2:5000", CF_BAN_WORKER_MQ_HOST: "rabbitmq", KIBANA_GITLAB_KB_HTTP_PORT_5601_TCP_PROTO: "tcp", CF_BAN_WORKER_SITE_HOSTS: "staging-scmp-pwa-v2.product-web.dev-2.scmp.tech", CI_PROJECT_NAMESPACE_ID: "10", CI_MERGE_REQUEST_SOURCE_BRANCH_SHA: "47b9f3bd42d7e5adbc88435200634658ebe1b145", CI_PIPELINE_CREATED_AT: "2024-11-21T09:37:19+08:00", KIBANA_GITLAB_KB_HTTP_SERVICE_HOST: "10.200.140.234", DEPENDABOT_DEPENDABOT_GITLAB_PORT_3000_TCP_PORT: "3000", CI_JOB_NAME_SLUG: "checking", RUNNER_TEMP_PROJECT_DIR: "/builds/product/web/scmp-pwa-v2.tmp", PROD_2_ARGOCD_SERVER: "argocd.scmp.tech:443", CI_CONCURRENT_PROJECT_ID: "0", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", CI_MERGE_REQUEST_IID: "3261", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://local.product-web.dev.scmp.tech/", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", KUBERNETES_PORT_443_TCP_ADDR: "10.200.128.1", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", CI_PIPELINE_URL: "https://project.scmp.tech/product/web/scmp-pwa-v2/-/pipelines/520889", DEPENDABOT_DEPENDABOT_GITLAB_PORT_3000_TCP_PROTO: "tcp", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", FF_KUBERNETES_HONOR_ENTRYPOINT: "false", PATH: "./node_modules/.bin:/builds/product/web/scmp-pwa-v2/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", CI_RUNNER_DESCRIPTION: "", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", CI_SERVER_VERSION_MINOR: "3", TECH_TEST_K8S_API: "https://172.17.28.97:6443", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", CI_JOB_STARTED_AT: "2024-11-21T09:43:49+08:00", NEXT_PUBLIC_APPLICATION: "", GITLAB_USER_EMAIL: "tony.kan@scmp.com", FF_USE_NEW_BASH_EVAL_STRATEGY: "false", FF_DISABLE_UMASK_FOR_KUBERNETES_EXECUTOR: "false", CI_PROJECT_VISIBILITY: "private", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", DEPENDABOT_REDIS_MASTER_PORT: "tcp://10.200.139.161:6379", PROD_US_K8S_DIR: "k8s.prod-us", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", CI_COMMIT_TITLE: "Merge branch 'SCMPWEB-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-version-2' into 'master'", DEPENDABOT_DEPENDABOT_GITLAB_SERVICE_PORT_HTTP: "3000", KUBERNETES_PORT_443_TCP_PORT: "443", CI_PROJECT_TITLE: "SCMP PWA V2", DEPENDABOT_REDIS_MASTER_SERVICE_PORT: "6379", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", CI_SERVER: "yes", NEXT_PUBLIC_NAVIGATOR_INFO_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", FF_USE_GIT_BUNDLE_URIS: "true", DOLLAR_SIGN: "$", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", CI_MERGE_REQUEST_EVENT_TYPE: "merge_train", APP_DIR: "./app", KUBERNETES_PORT_443_TCP_PROTO: "tcp", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", DEPENDABOT_REDIS_MASTER_PORT_6379_TCP_ADDR: "10.200.139.161", FF_TIMESTAMPS: "false", BASE_CONTAINER_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2/scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-base:scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-c24c7807732604b54cb07006988e629b8b11829e", CI_MERGE_REQUEST_ID: "77221", CI_PAGES_URL: "https://product.pages.scmp.tech/web/scmp-pwa-v2", CI_MERGE_REQUEST_APPROVED: "true", CI_PROJECT_REPOSITORY_LANGUAGES: "tsx,typescript,javascript,html,jsonnet", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://local.product-web.dev-2.scmp.tech/centralize/register?email", GITLAB_CI_TOKEN: "glcbt-64_w8gsVaFfgQ9zuetNzxum", KIBANA_GITLAB_KB_HTTP_PORT: "tcp://10.200.140.234:5601", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", FF_SET_PERMISSIONS_BEFORE_CLEANUP: "true", FF_PRINT_POD_EVENTS: "false", CF_BAN_WORKER_MQ_PORT: "5672", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", CI_SERVER_FQDN: "project.scmp.tech", DOCKER_HUB_TOKEN: "6a334d0b-ba15-4be9-9300-97c1b2d631e7", SENTRY_PROJECT: "scmp-pwa-v2-dev", CI_COMMIT_AUTHOR: "Tony Kan <tony.kan@scmp.com>", KIBANA_GITLAB_KB_HTTP_SERVICE_PORT: "5601", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", KIBANA_GITLAB_KB_HTTP_PORT_5601_TCP: "tcp://10.200.140.234:5601", CI_RUNNER_SHORT_TOKEN: "CnuEHfn36", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", CI_PAGES_DOMAIN: "pages.scmp.tech", PLANTUML_SERVER_SERVICE_PORT_HTTP: "8080", CF_BAN_WORKER_DRY_RUN: "true", TECH_TEST_K8S_DIR: "k8s.tech-test", CI_JOB_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2/scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-base:scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-c24c7807732604b54cb07006988e629b8b11829e", CI_PIPELINE_NAME: "", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", CI_JOB_TIMEOUT: "3600", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", CI_REPOSITORY_URL: "https://gitlab-ci-token:glcbt-64_w8gsVaFfgQ9zuetNzxum@project.scmp.tech/product/web/scmp-pwa-v2.git", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", GITLAB_ENV: "/builds/product/web/scmp-pwa-v2.tmp/gitlab_runner_env", DOCKER_IO_REGISTRY_PASSWORD: "6a334d0b-ba15-4be9-9300-97c1b2d631e7", CI_PROJECT_CLASSIFICATION_LABEL: "", DEPENDABOT_REDIS_MASTER_PORT_6379_TCP_PORT: "6379", NODE_PATH: "/builds/product/web/scmp-pwa-v2/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules/nx/bin/node_modules:/builds/product/web/scmp-pwa-v2/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules/nx/node_modules:/builds/product/web/scmp-pwa-v2/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules:/builds/product/web/scmp-pwa-v2/node_modules/.pnpm/node_modules", DEPENDABOT_REDIS_MASTER_PORT_6379_TCP_PROTO: "tcp", FF_USE_POWERSHELL_PATH_RESOLVER: "false", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", CI_API_GRAPHQL_URL: "https://project.scmp.tech/api/graphql", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NPM_CI_EMAIL: "verdaccio@scmp.com", OSS_REGION: "oss-cn-hongkong", CI_RUNNER_ID: "1466", DEPENDABOT_DEPENDABOT_GITLAB_PORT_3000_TCP: "tcp://10.200.143.203:3000", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_SERVICE_PORT_HTTP: "9200", NX_HEAD: "c24c7807732604b54cb07006988e629b8b11829e", BURP_SUITE_SCANNING_API_KEY: "YoegcJ6dUKVEBlg5IJ01X3htuKXO9cX5", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", CI_API_V4_URL: "https://project.scmp.tech/api/v4", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", VAULT_TOKEN: "hvs.CAESIDMD7acriDL71ER02SBKu441KlPYh2kZLfnvmSsSuuSsGh4KHGh2cy52ZDdiUnZVVlFUQVZVWnlXeHBYNlE0OG8", CI_MERGE_REQUEST_SOURCE_PROJECT_URL: "https://project.scmp.tech/product/web/scmp-pwa-v2", CI_DEPENDENCY_PROXY_DIRECT_GROUP_IMAGE_PREFIX: "project.scmp.tech:443/product/web/dependency_proxy/containers", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", DEPENDABOT_DEPENDABOT_GITLAB_SERVICE_HOST: "10.200.143.203", CI_REGISTRY: "registry.scmp.tech", GITLAB_USER_NAME: "Tony Kan", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://local.product-web.dev-2.scmp.tech/centralize/signin?nonce", DEV_2_K8S_TKN: "eyJhbGciOiJSUzI1NiIsImtpZCI6IiJ9.eyJpc3MiOiJrdWJlcm5ldGVzL3NlcnZpY2VhY2NvdW50Iiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9uYW1lc3BhY2UiOiJwcm9kdWN0LXdlYiIsImt1YmVybmV0ZXMuaW8vc2VydmljZWFjY291bnQvc2VjcmV0Lm5hbWUiOiJnaXRsYWItdG9rZW4tazI5Z2giLCJrdWJlcm5ldGVzLmlvL3NlcnZpY2VhY2NvdW50L3NlcnZpY2UtYWNjb3VudC5uYW1lIjoiZ2l0bGFiIiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9zZXJ2aWNlLWFjY291bnQudWlkIjoiMmFmZGY4MDItYmE0Ni0xMWU4LTljNjQtMDAxNjNlMDEzMWQyIiwic3ViIjoic3lzdGVtOnNlcnZpY2VhY2NvdW50OnByb2R1Y3Qtd2ViOmdpdGxhYiJ9.FfAFuH12VLsbQQHJe-gXtPnyNowE1zB00ewEOtqZPar5WSySlkXo2gLWt34Il_3Lih1IqaIgJ8bsXiNFEn0WaRsbqwegIkq6zq9CMXhX3LK8iIVudD78Kc_YyN53EA4FZhUm_5I-UQoMNCjQmK18uBpNvIIjIOjex5TXhD4S6UxAcM7l-dgi1DLs-AslmjUKNOwIU8tvk5PX8f44mA3DMgeOO-s4DLzNkqM_gP_8Zx1zjsBImRoYEtfbD3-kwQwEeXpf8XZNCRUl6Tr5AaSxsQjM3A3wsu40J1KWxWuomi8stEI_68Eamw_otwcNygaX3xzU-CTOVDlpWJ7n1nPE3Q", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", ELASTICSEARCH_GITLAB_ES_HTTP_SERVICE_PORT_HTTP: "9200", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", CI_MERGE_REQUEST_PROJECT_ID: "1232", CI_PIPELINE_IID: "80800", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_PORT_9200_TCP_ADDR: "10.200.143.51", KUBERNETES_SERVICE_PORT_HTTPS: "443", CI_RUNNER_EXECUTABLE_ARCH: "linux/amd64", DOCKER_IO_REGISTRY_USER: "scmptechsys", NEXT_PUBLIC_DRUPAL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/scmp-d8", CI_MERGE_REQUEST_DESCRIPTION_IS_TRUNCATED: "false", KUBERNETES_PORT_443_TCP: "tcp://10.200.128.1:443", FF_USE_POD_ACTIVE_DEADLINE_SECONDS: "true", FF_USE_ADVANCED_POD_SPEC_CONFIGURATION: "false", VAULT_ID_TOKEN: "eyJraWQiOiJSM0NZUDNmS1FHZ29sZml6eTJhczBSa1NlZVNKWlBIUFFrOFQ2RWlObzVrIiwidHlwIjoiSldUIiwiYWxnIjoiUlMyNTYifQ.eyJuYW1lc3BhY2VfaWQiOiIxMCIsIm5hbWVzcGFjZV9wYXRoIjoicHJvZHVjdC93ZWIiLCJwcm9qZWN0X2lkIjoiMTIzMiIsInByb2plY3RfcGF0aCI6InByb2R1Y3Qvd2ViL3NjbXAtcHdhLXYyIiwidXNlcl9pZCI6IjIxIiwidXNlcl9sb2dpbiI6InRvbnkua2FuIiwidXNlcl9lbWFpbCI6InRvbnkua2FuQHNjbXAuY29tIiwidXNlcl9hY2Nlc3NfbGV2ZWwiOiJkZXZlbG9wZXIiLCJwaXBlbGluZV9pZCI6IjUyMDg4OSIsInBpcGVsaW5lX3NvdXJjZSI6Im1lcmdlX3JlcXVlc3RfZXZlbnQiLCJqb2JfaWQiOiIyNjE4MTIyIiwicmVmIjoiU0NNUFdFQi02NjgxLW1pZ3JhdGUtcm9zZXR0YS1zZGstcy1jb250ZW50LXNlcnZpY2UtZW5kcG9pbnQtdG8tdmVyc2lvbi0yIiwicmVmX3R5cGUiOiJicmFuY2giLCJyZWZfcGF0aCI6InJlZnMvaGVhZHMvU0NNUFdFQi02NjgxLW1pZ3JhdGUtcm9zZXR0YS1zZGstcy1jb250ZW50LXNlcnZpY2UtZW5kcG9pbnQtdG8tdmVyc2lvbi0yIiwicmVmX3Byb3RlY3RlZCI6ImZhbHNlIiwicnVubmVyX2lkIjoxNDY2LCJydW5uZXJfZW52aXJvbm1lbnQiOiJzZWxmLWhvc3RlZCIsInNoYSI6ImMyNGM3ODA3NzMyNjA0YjU0Y2IwNzAwNjk4OGU2MjliOGIxMTgyOWUiLCJwcm9qZWN0X3Zpc2liaWxpdHkiOiJwcml2YXRlIiwiY2lfY29uZmlnX3JlZl91cmkiOiJwcm9qZWN0LnNjbXAudGVjaC9wcm9kdWN0L3dlYi9zY21wLXB3YS12Mi8vLmdpdGxhYi1jaS55bWxAcmVmcy9oZWFkcy9TQ01QV0VCLTY2ODEtbWlncmF0ZS1yb3NldHRhLXNkay1zLWNvbnRlbnQtc2VydmljZS1lbmRwb2ludC10by12ZXJzaW9uLTIiLCJjaV9jb25maWdfc2hhIjoiYzI0Yzc4MDc3MzI2MDRiNTRjYjA3MDA2OTg4ZTYyOWI4YjExODI5ZSIsImp0aSI6IjIzNTU4ZDJhLTJlNzgtNDcxNS04YjhiLWRhZjQ1NjA0MjU2NCIsImlhdCI6MTczMjE1MzQzMCwibmJmIjoxNzMyMTUzNDI1LCJleHAiOjE3MzIxNTcwMzAsImlzcyI6Imh0dHBzOi8vcHJvamVjdC5zY21wLnRlY2giLCJzdWIiOiJwcm9qZWN0X3BhdGg6cHJvZHVjdC93ZWIvc2NtcC1wd2EtdjI6cmVmX3R5cGU6YnJhbmNoOnJlZjpTQ01QV0VCLTY2ODEtbWlncmF0ZS1yb3NldHRhLXNkay1zLWNvbnRlbnQtc2VydmljZS1lbmRwb2ludC10by12ZXJzaW9uLTIiLCJhdWQiOiJodHRwczovL3Byb2plY3Quc2NtcC50ZWNoIn0.CPcQicVPGc2wI4IuEAorrz3jOG1jhpuMWN-KgZqgJuIusZcYr-nqe9YQdjFTxrLhGD-9n3HqJQAlo_pBPxHvzCsamIxebsIx6vEnPcTbdvOdL8LteOmCM_hWxDDk-__k3NncIs6-9i-Sxjp-mJpDloC6TKM1zSmguVsr21DzPCRovGCYH92gWRAstcfvUM7OOBO9sSpz7oEm3qugWuDYQgObGIyWjJoVaXuXSk8KCBZC2xR1O_3T2JnQwmpDpTNbEkylok9g2onbfyNMoOEMuqoz7gl2dOBUzNQ8dwiufpwcr6wO9fLaSnZ8bCDDrKqi06Q1Sqn5wi7FiRqYkLs4jg", CI_SERVER_SHELL_SSH_HOST: "project.scmp.tech", CI_JOB_URL: "https://project.scmp.tech/product/web/scmp-pwa-v2/-/jobs/2618122", PNPM_PACKAGE_NAME: "scmp-pwa-v2", FF_USE_INIT_WITH_DOCKER_EXECUTOR: "false", DEV_2_K8S_NS: "product-web", NEXT_PUBLIC_NAVIGATOR_INFO_URL: "/navigator-info", FF_TEST_FEATURE: "false", CI_MERGE_REQUEST_REF_PATH: "refs/merge-requests/3261/head", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", ELASTICSEARCH_GITLAB_ES_HTTP_PORT_9200_TCP_ADDR: "10.200.135.60", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_PORT_9200_TCP_PORT: "9200", CI_COMMIT_REF_SLUG: "scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to", PWD: "/builds/product/web/scmp-pwa-v2", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", PLANTUML_SERVER_SERVICE_HOST: "10.200.132.244", CF_BAN_WORKER_MQ_EXCHANGE_TYPE: "fanout", NEXT_PUBLIC_AMP_READER_ID: "", CI_DISPOSABLE_ENVIRONMENT: "true", KUBERNETES_SERVICE_HOST: "10.200.128.1", PLANTUML_SERVER_PORT_8080_TCP_ADDR: "10.200.132.244", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", CI_RUNNER_TAGS: '["k8s"]', CI_MERGE_REQUEST_PROJECT_PATH: "product/web/scmp-pwa-v2", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_PORT_9200_TCP_PROTO: "tcp", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", FF_SECRET_RESOLVING_FAILS_IF_MISSING: "true", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", CI_PIPELINE_ID: "520889", CI_SERVER_TLS_CA_FILE: "/builds/product/web/scmp-pwa-v2.tmp/CI_SERVER_TLS_CA_FILE", CI_MERGE_REQUEST_TITLE: 'Resolve SCMPWEB-6681 "Track undefined appconfig call on Piano execution"', PRISMACLOUD_CHECKOV_ACCESS_KEY_ID: "fe8aada2-cb3d-4b35-aea4-696cbbed2e29", CF_BAN_WORKER_MQ_USERNAME: "scmp", ELASTICSEARCH_GITLAB_ES_INTERNAL_HTTP_SERVICE_HOST: "10.200.143.51", ELASTICSEARCH_GITLAB_ES_HTTP_PORT_9200_TCP_PORT: "9200", CI_PROJECT_PATH_SLUG: "product-web-scmp-pwa-v2", CI_COMMIT_BEFORE_SHA: "c24c7807732604b54cb07006988e629b8b11829e", CI_CONFIG_PATH: ".gitlab-ci.yml", CI_PROJECT_URL: "https://project.scmp.tech/product/web/scmp-pwa-v2", npm_command: "run-script", PROD_US_K8S_TKN: "eyJhbGciOiJSUzI1NiIsImtpZCI6IiJ9.eyJpc3MiOiJrdWJlcm5ldGVzL3NlcnZpY2VhY2NvdW50Iiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9uYW1lc3BhY2UiOiJwcm9kdWN0LXdlYiIsImt1YmVybmV0ZXMuaW8vc2VydmljZWFjY291bnQvc2VjcmV0Lm5hbWUiOiJnaXRsYWItdG9rZW4tOXZjczUiLCJrdWJlcm5ldGVzLmlvL3NlcnZpY2VhY2NvdW50L3NlcnZpY2UtYWNjb3VudC5uYW1lIjoiZ2l0bGFiIiwia3ViZXJuZXRlcy5pby9zZXJ2aWNlYWNjb3VudC9zZXJ2aWNlLWFjY291bnQudWlkIjoiYWE5MjYyM2QtMTczYi0xMWVhLTllMTItNjY2NGY0ZDYyOTcxIiwic3ViIjoic3lzdGVtOnNlcnZpY2VhY2NvdW50OnByb2R1Y3Qtd2ViOmdpdGxhYiJ9.BMae-w42JSzPRd0dAs24C41ltReErT25aNB8jKQlputvDYZsglwcF9hnkRvJ3Ecr7sHBR0NY7SkTrVjPyRsFZHWeefFV-w8QYqOcCgXWA2FdQ4y7VkJq2tXKvC0l8cQEY_OIqVbiK6ITf4s7FwOf8wJ_K4YNHUd8_k8IjoWeYxz0x5H5nhWjVqPLPIpnI_kwPl2kAOOukdwoXgxBUxmCsa5S1TSN838xide0q_rhmRw1Vp1UWIrN_8I7AxM-py4Kq2rHSsqaKkqsns0l_n4b4_aC_LV2nuhxx3237valTCOjkeZ_3Va2mNuZc7oo9JwRBiPyJQgbDtHctGnm5NyLdg", DEPENDABOT_DEPENDABOT_GITLAB_PORT: "tcp://10.200.143.203:3000", DEPENDABOT_DEPENDABOT_GITLAB_SERVICE_PORT: "3000", CI_COMMIT_MESSAGE: `Merge branch 'SCMPWEB-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-version-2' into 'master'

Resolve SCMPWEB-6681 "Track undefined appconfig call on Piano execution"

Closes SCMPWEB-6681

See merge request product/web/scmp-pwa-v2!3261`, NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", DEPENDABOT_REDIS_MASTER_PORT_6379_TCP: "tcp://10.200.139.161:6379", ELASTICSEARCH_GITLAB_ES_HTTP_PORT_9200_TCP_PROTO: "tcp", CF_BAN_WORKER_VERSION: "local", PLANTUML_SERVER_PORT_8080_TCP_PORT: "8080", PRISMACLOUD_CHECKOV_SECRET_ACCESS_KEY: "OJmp19QTYXtMabV5bV5r6ymNqM0=", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", GITLAB_USER_ID: "21", ELASTICSEARCH_GITLAB_ES_HTTP_SERVICE_HOST: "10.200.135.60", NX_BASE: "c24c7807732604b54cb07006988e629b8b11829e~1", PLANTUML_SERVER_PORT_8080_TCP_PROTO: "tcp", CI_DEPENDENCY_PROXY_GROUP_IMAGE_PREFIX: "project.scmp.tech:443/product/dependency_proxy/containers", GITLAB_DEPLOY_KEY: `-----BEGIN OPENSSH PRIVATE KEY-----
b3BlbnNzaC1rZXktdjEAAAAABG5vbmUAAAAEbm9uZQAAAAAAAAABAAABFwAAAAdzc2gtcn
NhAAAAAwEAAQAAAQEAv60/SDiC2NigFB35wR2Clr7/XMcQv3WOM3EMxN4MomCeZhN2JTp7
oowN4pGeav9yLKy2Eu+Mcs0KRZi2wM+tl9WJBxz3Vrs2lRCLTdQVpem71IYKqCrMtP9kXN
ZLGbkvZUbyuvte+0JQRZamrLIvZ28DYs4b2s+GrmdLT3Ju3z/zxwIL3PYPer9KV//hARYc
BYDGNgK0chqY4IYiGkBhAe5Y0+NBiTzxIkXOx7JUk83SKE6Id1MPkZwOo3vNGTPKMC2A3F
WZjy6kPyGria1iUYAy3QKz9jpSxVHe/YkKD5RZJzy1OMu780256q6/QgUKzuxq3RHPPE7g
U4iref0LmQAAA8iQVt0tkFbdLQAAAAdzc2gtcnNhAAABAQC/rT9IOILY2KAUHfnBHYKWvv
9cxxC/dY4zcQzE3gyiYJ5mE3YlOnuijA3ikZ5q/3IsrLYS74xyzQpFmLbAz62X1YkHHPdW
uzaVEItN1BWl6bvUhgqoKsy0/2Rc1ksZuS9lRvK6+177QlBFlqassi9nbwNizhvaz4auZ0
tPcm7fP/PHAgvc9g96v0pX/+EBFhwFgMY2ArRyGpjghiIaQGEB7ljT40GJPPEiRc7HslST
zdIoToh3Uw+RnA6je80ZM8owLYDcVZmPLqQ/IauJrWJRgDLdArP2OlLFUd79iQoPlFknPL
U4y7vzTbnqrr9CBQrO7GrdEc88TuBTiKt5/QuZAAAAAwEAAQAAAQA9wJkUsXAmYJQiJw4h
01oRKvOmdlPE+yCXHiLZAhjb73jYtghoMhFG6wxGJFf/bNDh57q5GwgKrFhU18B5Ge95bU
g6THC7NpF9MNlQd7WJwGXNMGoah79vyKAS8M89OFY2sMbeysFs/Y5S/Rgxpy5yimdy26hJ
tHZVld3DeMCTl72urdjZWAa3hJ6zWqK47bFSFaZh4WnuoHDtuYr4lbOFtGJiqN+opr5Lk2
5wZQNz3IPup5E/uFGJs7lldKO+fB0gkrw9VIGAQVJMO+hgAwnDaiA4iQlcpTtqlF1TqQje
EPj5jr2D5dcBlkcZJ3KC831R097bRx8dfcnQhJe4i5+pAAAAgEzoqFjEy4eQP9xOFlwPq7
pnrLroseOtqxnkT8Zw/leKmjUGdmrywmkQfZkdBf614Ekdjdb9cibcWHin6OR+lVTLboyK
lovM92mQGxx09smalKwLdnjn24tfkORqFGoGa1j8DxsXo40vPNSgOdIULzYMOlpGXK0+v6
Oin8uDRooBAAAAgQDx6G+bl7LvvGityg6gFhBX+SuVhZqdfycwmXmrSkUXe8USBg4JWW43
dDA1BRAaT4ymh/kWm0+FS05gWnwnTLGx69ba1alIVbIcNkt2bhVRNupDZrlNQ2AOqHme6G
/QpFq1mGj5OMo11QschxrNeCRSeMK5QHCzJOUqGjIaudR14wAAAIEAyte3FcH3P0XsnXnr
pqxn4CGvRU6DvHM5o4Q/jInLwds6nR5yU7D0WUj+B7Vy3tw/6XXCDwDtMPbSuTUQtGIgz6
4wOk9QpRHHxTJZXVafu3ladM0PTRIrYRfHfsQ/N3D5Y8zP0TXfGmjiT/33d7ypc91jCP4Q
Nx88CNZxy2VaUVMAAAAORGVwbG95bWVudCBrZXkBAgMEBQ==
-----END OPENSSH PRIVATE KEY-----`, FF_ENABLE_BASH_EXIT_CODE_CHECK: "false", CI_JOB_NAME: "checking", CI_OPEN_MERGE_REQUESTS: "product/web/scmp-pwa-v2!3261", CI_JOB_STATUS: "running", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", CI_MERGE_REQUEST_DIFF_BASE_SHA: "f393f8ab25618c1327d94d7dd0ba98de434e3122", APP_CONTAINER_LATEST_IMAGE: "registry.scmp.tech/product/web/scmp-pwa-v2/scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-app:scmpweb-6681-migrate-rosetta-sdk-s-content-service-endpoint-to-latest", CI_SERVER_SHELL_SSH_PORT: "22", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", CI_MERGE_REQUEST_TARGET_BRANCH_NAME: "master", PROD_US_K8S_NS: "product-web", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", DEPENDABOT_REDIS_MASTER_SERVICE_PORT_TCP_REDIS: "6379", NX_CLI_SET: "true", NX_VERBOSE_LOGGING: "true", NX_LOAD_DOT_ENV_FILES: "true", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce=", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email=", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fscmp%2F&width=86&layout=button_count&action=like&size=small&share=false&height=21&appId=282931841805811", STORYBOOK_ROSETTA_HOST: "https://subscribe.scmp.com", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", STORYBOOK_SITE_URL: "https://local.product-web.dev-2.scmp.tech/", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", FORCE_COLOR: "true", NX_WORKSPACE_ROOT: "/builds/product/web/scmp-pwa-v2", NX_TASK_TARGET_PROJECT: "scmp-sdk", NX_TASK_TARGET_TARGET: "build", NX_TASK_HASH: "16797708093461223411", LERNA_PACKAGE_NAME: "scmp-sdk", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" };
function $n(e, t = 0, n = 1) {
  return is(e, t, n);
}
function os(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, i) => i < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Be(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Be(os(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(Ge(9, e));
  let r = e.substring(t + 1, e.length - 1), i;
  if (n === "color") {
    if (r = r.split(" "), i = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(i))
      throw new Error(Ge(10, i));
  } else
    r = r.split(",");
  return r = r.map((a) => parseFloat(a)), {
    type: n,
    values: r,
    colorSpace: i
  };
}
const ss = (e) => {
  const t = Be(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, st = (e, t) => {
  try {
    return ss(e);
  } catch {
    return t && as.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function zt(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((i, a) => a < 3 ? parseInt(i, 10) : i) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function Ei(e) {
  e = Be(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, i = t[2] / 100, a = r * Math.min(i, 1 - i), s = (E, p = (E + n / 30) % 12) => i - a * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  let l = "rgb";
  const c = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (l += "a", c.push(t[3])), zt({
    type: l,
    values: c
  });
}
function In(e) {
  e = Be(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Be(Ei(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function ls(e, t) {
  const n = In(e), r = In(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function cs(e, t) {
  return e = Be(e), t = $n(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, zt(e);
}
function vt(e, t, n) {
  try {
    return cs(e, t);
  } catch {
    return e;
  }
}
function er(e, t) {
  if (e = Be(e), t = $n(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return zt(e);
}
function x(e, t, n) {
  try {
    return er(e, t);
  } catch {
    return e;
  }
}
function tr(e, t) {
  if (e = Be(e), t = $n(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return zt(e);
}
function U(e, t, n) {
  try {
    return tr(e, t);
  } catch {
    return e;
  }
}
function us(e, t = 0.15) {
  return In(e) > 0.5 ? er(e, t) : tr(e, t);
}
function wt(e, t, n) {
  try {
    return us(e, t);
  } catch {
    return e;
  }
}
function _s(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function ds(...e) {
  return N.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      _s(n, t);
    });
  }, e);
}
function ps(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const i = r[0];
    return typeof i == "string" && !i.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${i}${t(...r.slice(1))})` : `, ${i}`;
  }
  return (r, ...i) => `var(--${e ? `${e}-` : ""}${r}${t(...i)})`;
}
const Mr = (e, t, n, r = []) => {
  let i = e;
  t.forEach((a, s) => {
    s === t.length - 1 ? Array.isArray(i) ? i[Number(a)] = n : i && typeof i == "object" && (i[a] = n) : i && typeof i == "object" && (i[a] || (i[a] = r.includes(a) ? [] : {}), i = i[a]);
  });
}, ms = (e, t, n) => {
  function r(i, a = [], s = []) {
    Object.entries(i).forEach(([l, c]) => {
      (!n || n && !n([...a, l])) && c != null && (typeof c == "object" && Object.keys(c).length > 0 ? r(c, [...a, l], Array.isArray(c) ? [...s, l] : s) : t([...a, l], c, s));
    });
  }
  r(e);
}, Es = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function on(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, i = {}, a = {}, s = {};
  return ms(
    e,
    (l, c, E) => {
      if ((typeof c == "string" || typeof c == "number") && (!r || !r(l, c))) {
        const p = `--${n ? `${n}-` : ""}${l.join("-")}`, d = Es(l, c);
        Object.assign(i, {
          [p]: d
        }), Mr(a, l, `var(${p})`, E), Mr(s, l, `var(${p}, ${d})`, E);
      }
    },
    (l) => l[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: i,
    vars: a,
    varsWithDefaults: s
  };
}
function fs(e, t = {}) {
  const {
    getSelector: n = b,
    disableCssColorScheme: r,
    colorSchemeSelector: i
  } = t, {
    colorSchemes: a = {},
    components: s,
    defaultColorScheme: l = "light",
    ...c
  } = e, {
    vars: E,
    css: p,
    varsWithDefaults: d
  } = on(c, t);
  let _ = d;
  const f = {}, {
    [l]: A,
    ...g
  } = a;
  if (Object.entries(g || {}).forEach(([C, S]) => {
    const {
      vars: h,
      css: y,
      varsWithDefaults: O
    } = on(S, t);
    _ = ne(_, O), f[C] = {
      css: y,
      vars: h
    };
  }), A) {
    const {
      css: C,
      vars: S,
      varsWithDefaults: h
    } = on(A, t);
    _ = ne(_, h), f[l] = {
      css: C,
      vars: S
    };
  }
  function b(C, S) {
    var y, O;
    let h = i;
    if (i === "class" && (h = ".%s"), i === "data" && (h = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (h = `[${i}="%s"]`), C) {
      if (h === "media")
        return e.defaultColorScheme === C ? ":root" : {
          [`@media (prefers-color-scheme: ${((O = (y = a[C]) == null ? void 0 : y.palette) == null ? void 0 : O.mode) || C})`]: {
            ":root": S
          }
        };
      if (h)
        return e.defaultColorScheme === C ? `:root, ${h.replace("%s", String(C))}` : h.replace("%s", String(C));
    }
    return ":root";
  }
  return {
    vars: _,
    generateThemeVars: () => {
      let C = {
        ...E
      };
      return Object.entries(f).forEach(([, {
        vars: S
      }]) => {
        C = ne(C, S);
      }), C;
    },
    generateStyleSheets: () => {
      var w, k;
      const C = [], S = e.defaultColorScheme || "light";
      function h(o, R) {
        Object.keys(R).length && C.push(typeof o == "string" ? {
          [o]: {
            ...R
          }
        } : o);
      }
      h(n(void 0, {
        ...p
      }), p);
      const {
        [S]: y,
        ...O
      } = f;
      if (y) {
        const {
          css: o
        } = y, R = (k = (w = a[S]) == null ? void 0 : w.palette) == null ? void 0 : k.mode, P = !r && R ? {
          colorScheme: R,
          ...o
        } : {
          ...o
        };
        h(n(S, {
          ...P
        }), P);
      }
      return Object.entries(O).forEach(([o, {
        css: R
      }]) => {
        var M, J;
        const P = (J = (M = a[o]) == null ? void 0 : M.palette) == null ? void 0 : J.mode, B = !r && P ? {
          colorScheme: P,
          ...R
        } : {
          ...R
        };
        h(n(o, {
          ...B
        }), B);
      }), C;
    }
  };
}
function gs(e) {
  return function(n) {
    return e === "media" ? `@media (prefers-color-scheme: ${n})` : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const mt = {
  black: "#000",
  white: "#fff"
}, As = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, ze = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, We = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, it = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Xe = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Ke = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Je = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
function fi() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: mt.white,
      default: mt.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const Ts = fi();
function gi() {
  return {
    text: {
      primary: mt.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: mt.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const xr = gi();
function Ur(e, t, n, r) {
  const i = r.light || r, a = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = tr(e.main, i) : t === "dark" && (e.dark = er(e.main, a)));
}
function Is(e = "light") {
  return e === "dark" ? {
    main: Xe[200],
    light: Xe[50],
    dark: Xe[400]
  } : {
    main: Xe[700],
    light: Xe[400],
    dark: Xe[800]
  };
}
function Ss(e = "light") {
  return e === "dark" ? {
    main: ze[200],
    light: ze[50],
    dark: ze[400]
  } : {
    main: ze[500],
    light: ze[300],
    dark: ze[700]
  };
}
function hs(e = "light") {
  return e === "dark" ? {
    main: We[500],
    light: We[300],
    dark: We[700]
  } : {
    main: We[700],
    light: We[400],
    dark: We[800]
  };
}
function Cs(e = "light") {
  return e === "dark" ? {
    main: Ke[400],
    light: Ke[300],
    dark: Ke[700]
  } : {
    main: Ke[700],
    light: Ke[500],
    dark: Ke[900]
  };
}
function Rs(e = "light") {
  return e === "dark" ? {
    main: Je[400],
    light: Je[300],
    dark: Je[700]
  } : {
    main: Je[800],
    light: Je[500],
    dark: Je[900]
  };
}
function bs(e = "light") {
  return e === "dark" ? {
    main: it[400],
    light: it[300],
    dark: it[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: it[500],
    dark: it[900]
  };
}
function nr(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...i
  } = e, a = e.primary || Is(t), s = e.secondary || Ss(t), l = e.error || hs(t), c = e.info || Cs(t), E = e.success || Rs(t), p = e.warning || bs(t);
  function d(g) {
    return ls(g, xr.text.primary) >= n ? xr.text.primary : Ts.text.primary;
  }
  const _ = ({
    color: g,
    name: b,
    mainShade: I = 500,
    lightShade: v = 300,
    darkShade: C = 700
  }) => {
    if (g = {
      ...g
    }, !g.main && g[I] && (g.main = g[I]), !g.hasOwnProperty("main"))
      throw new Error(Ge(11, b ? ` (${b})` : "", I));
    if (typeof g.main != "string")
      throw new Error(Ge(12, b ? ` (${b})` : "", JSON.stringify(g.main)));
    return Ur(g, "light", v, r), Ur(g, "dark", C, r), g.contrastText || (g.contrastText = d(g.main)), g;
  };
  let f;
  return t === "light" ? f = fi() : t === "dark" && (f = gi()), ne({
    // A collection of common colors.
    common: {
      ...mt
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: _({
      color: a,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: _({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: _({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: _({
      color: p,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: _({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: _({
      color: E,
      name: "success"
    }),
    // The grey colors.
    grey: As,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: d,
    // Generate a rich color object.
    augmentColor: _,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...f
  }, i);
}
function ys(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [i, a] = r;
    typeof a == "object" && (t[i] = `${a.fontStyle ? `${a.fontStyle} ` : ""}${a.fontVariant ? `${a.fontVariant} ` : ""}${a.fontWeight ? `${a.fontWeight} ` : ""}${a.fontStretch ? `${a.fontStretch} ` : ""}${a.fontSize || ""}${a.lineHeight ? `/${a.lineHeight} ` : ""}${a.fontFamily || ""}`);
  }), t;
}
function Ns(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function Os(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Fr = {
  textTransform: "uppercase"
}, Gr = '"Roboto", "Helvetica", "Arial", sans-serif';
function vs(e, t) {
  const {
    fontFamily: n = Gr,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: E,
    pxToRem: p,
    ...d
  } = typeof t == "function" ? t(e) : t, _ = r / 14, f = p || ((b) => `${b / c * _}rem`), A = (b, I, v, C, S) => ({
    fontFamily: n,
    fontWeight: b,
    fontSize: f(I),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: v,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === Gr ? {
      letterSpacing: `${Os(C / I)}em`
    } : {},
    ...S,
    ...E
  }), g = {
    h1: A(i, 96, 1.167, -1.5),
    h2: A(i, 60, 1.2, -0.5),
    h3: A(a, 48, 1.167, 0),
    h4: A(a, 34, 1.235, 0.25),
    h5: A(a, 24, 1.334, 0),
    h6: A(s, 20, 1.6, 0.15),
    subtitle1: A(a, 16, 1.75, 0.15),
    subtitle2: A(s, 14, 1.57, 0.1),
    body1: A(a, 16, 1.5, 0.15),
    body2: A(a, 14, 1.43, 0.15),
    button: A(s, 14, 1.75, 0.4, Fr),
    caption: A(a, 12, 1.66, 0.4),
    overline: A(a, 12, 2.66, 1, Fr),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return ne({
    htmlFontSize: c,
    pxToRem: f,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: i,
    fontWeightRegular: a,
    fontWeightMedium: s,
    fontWeightBold: l,
    ...g
  }, d, {
    clone: !1
    // No need to clone deep
  });
}
const ws = 0.2, Ps = 0.14, Ls = 0.12;
function V(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${ws})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Ps})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Ls})`].join(",");
}
const Bs = ["none", V(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), V(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), V(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), V(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), V(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), V(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), V(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), V(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), V(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), V(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), V(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), V(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), V(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), V(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), V(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), V(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), V(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), V(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), V(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), V(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), V(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), V(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), V(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), V(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], ks = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Ds = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Vr(e) {
  return `${Math.round(e)}ms`;
}
function Ms(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function xs(e) {
  const t = {
    ...ks,
    ...e.easing
  }, n = {
    ...Ds,
    ...e.duration
  };
  return {
    getAutoHeightDuration: Ms,
    create: (i = ["all"], a = {}) => {
      const {
        duration: s = n.standard,
        easing: l = t.easeInOut,
        delay: c = 0,
        ...E
      } = a;
      return (Array.isArray(i) ? i : [i]).map((p) => `${p} ${typeof s == "string" ? s : Vr(s)} ${l} ${typeof c == "string" ? c : Vr(c)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const Us = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function Fs(e) {
  return Pe(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function Ai(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const i = Object.entries(r);
    for (let a = 0; a < i.length; a++) {
      const [s, l] = i[a];
      !Fs(l) || s.startsWith("unstable_") ? delete r[s] : Pe(l) && (r[s] = {
        ...l
      }, n(r[s]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Sn(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: i,
    palette: a = {},
    transitions: s = {},
    typography: l = {},
    shape: c,
    ...E
  } = e;
  if (e.vars)
    throw new Error(Ge(20));
  const p = nr(a), d = mi(e);
  let _ = ne(d, {
    mixins: Ns(d.breakpoints, r),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: Bs.slice(),
    typography: vs(p, l),
    transitions: xs(s),
    zIndex: {
      ...Us
    }
  });
  return _ = ne(_, E), _ = t.reduce((f, A) => ne(f, A), _), _.unstable_sxConfig = {
    ...Yt,
    ...E == null ? void 0 : E.unstable_sxConfig
  }, _.unstable_sx = function(A) {
    return Ht({
      sx: A,
      theme: this
    });
  }, _.toRuntimeSource = Ai, _;
}
function Gs(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const Vs = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = Gs(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function Ti(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Ii(e) {
  return e === "dark" ? Vs : [];
}
function js(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...i
  } = e, a = nr(t);
  return {
    palette: a,
    opacity: {
      ...Ti(a.mode),
      ...n
    },
    overlays: r || Ii(a.mode),
    ...i
  };
}
function Ys(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const Hs = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], zs = (e) => (t, n) => {
  const r = e.rootSelector || ":root", i = e.colorSchemeSelector;
  let a = i;
  if (i === "class" && (a = ".%s"), i === "data" && (a = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (a = `[${i}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return Hs(e.cssVarPrefix).forEach((l) => {
        s[l] = n[l], delete n[l];
      }), a === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: s
        }
      } : a ? {
        [a.replace("%s", t)]: s,
        [`${r}, ${a.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...s
        }
      };
    }
    if (a && a !== "media")
      return `${r}, ${a.replace("%s", String(t))}`;
  } else if (t) {
    if (a === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (a)
      return a.replace("%s", String(t));
  }
  return r;
};
function Ws(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function m(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function lt(e) {
  return !e || !e.startsWith("hsl") ? e : Ei(e);
}
function Re(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = st(lt(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function Xs(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Ae = (e) => {
  try {
    return e();
  } catch {
  }
}, Ks = (e = "mui") => ps(e);
function sn(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const i = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = js({
      ...t,
      palette: {
        mode: i,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: a,
    ...s
  } = Sn({
    ...n,
    palette: {
      mode: i,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: a,
    opacity: {
      ...Ti(i),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || Ii(i)
  }, s;
}
function Js(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: i = !1,
    cssVarPrefix: a = "mui",
    shouldSkipGeneratingVar: s = Ys,
    colorSchemeSelector: l = n.light && n.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...E
  } = e, p = Object.keys(n)[0], d = r || (n.light && p !== "light" ? "light" : p), _ = Ks(a), {
    [d]: f,
    light: A,
    dark: g,
    ...b
  } = n, I = {
    ...b
  };
  let v = f;
  if ((d === "dark" && !("dark" in n) || d === "light" && !("light" in n)) && (v = !0), !v)
    throw new Error(Ge(21, d));
  const C = sn(I, v, E, d);
  A && !I.light && sn(I, A, void 0, "light"), g && !I.dark && sn(I, g, void 0, "dark");
  let S = {
    defaultColorScheme: d,
    ...C,
    cssVarPrefix: a,
    colorSchemeSelector: l,
    rootSelector: c,
    getCssVar: _,
    colorSchemes: I,
    font: {
      ...ys(C.typography),
      ...C.font
    },
    spacing: Xs(E.spacing)
  };
  Object.keys(S.colorSchemes).forEach((k) => {
    const o = S.colorSchemes[k].palette, R = (P) => {
      const B = P.split("-"), M = B[1], J = B[2];
      return _(P, o[M][J]);
    };
    if (o.mode === "light" && (m(o.common, "background", "#fff"), m(o.common, "onBackground", "#000")), o.mode === "dark" && (m(o.common, "background", "#000"), m(o.common, "onBackground", "#fff")), Ws(o, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), o.mode === "light") {
      m(o.Alert, "errorColor", x(o.error.light, 0.6)), m(o.Alert, "infoColor", x(o.info.light, 0.6)), m(o.Alert, "successColor", x(o.success.light, 0.6)), m(o.Alert, "warningColor", x(o.warning.light, 0.6)), m(o.Alert, "errorFilledBg", R("palette-error-main")), m(o.Alert, "infoFilledBg", R("palette-info-main")), m(o.Alert, "successFilledBg", R("palette-success-main")), m(o.Alert, "warningFilledBg", R("palette-warning-main")), m(o.Alert, "errorFilledColor", Ae(() => o.getContrastText(o.error.main))), m(o.Alert, "infoFilledColor", Ae(() => o.getContrastText(o.info.main))), m(o.Alert, "successFilledColor", Ae(() => o.getContrastText(o.success.main))), m(o.Alert, "warningFilledColor", Ae(() => o.getContrastText(o.warning.main))), m(o.Alert, "errorStandardBg", U(o.error.light, 0.9)), m(o.Alert, "infoStandardBg", U(o.info.light, 0.9)), m(o.Alert, "successStandardBg", U(o.success.light, 0.9)), m(o.Alert, "warningStandardBg", U(o.warning.light, 0.9)), m(o.Alert, "errorIconColor", R("palette-error-main")), m(o.Alert, "infoIconColor", R("palette-info-main")), m(o.Alert, "successIconColor", R("palette-success-main")), m(o.Alert, "warningIconColor", R("palette-warning-main")), m(o.AppBar, "defaultBg", R("palette-grey-100")), m(o.Avatar, "defaultBg", R("palette-grey-400")), m(o.Button, "inheritContainedBg", R("palette-grey-300")), m(o.Button, "inheritContainedHoverBg", R("palette-grey-A100")), m(o.Chip, "defaultBorder", R("palette-grey-400")), m(o.Chip, "defaultAvatarColor", R("palette-grey-700")), m(o.Chip, "defaultIconColor", R("palette-grey-700")), m(o.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), m(o.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), m(o.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), m(o.LinearProgress, "primaryBg", U(o.primary.main, 0.62)), m(o.LinearProgress, "secondaryBg", U(o.secondary.main, 0.62)), m(o.LinearProgress, "errorBg", U(o.error.main, 0.62)), m(o.LinearProgress, "infoBg", U(o.info.main, 0.62)), m(o.LinearProgress, "successBg", U(o.success.main, 0.62)), m(o.LinearProgress, "warningBg", U(o.warning.main, 0.62)), m(o.Skeleton, "bg", `rgba(${R("palette-text-primaryChannel")} / 0.11)`), m(o.Slider, "primaryTrack", U(o.primary.main, 0.62)), m(o.Slider, "secondaryTrack", U(o.secondary.main, 0.62)), m(o.Slider, "errorTrack", U(o.error.main, 0.62)), m(o.Slider, "infoTrack", U(o.info.main, 0.62)), m(o.Slider, "successTrack", U(o.success.main, 0.62)), m(o.Slider, "warningTrack", U(o.warning.main, 0.62));
      const P = wt(o.background.default, 0.8);
      m(o.SnackbarContent, "bg", P), m(o.SnackbarContent, "color", Ae(() => o.getContrastText(P))), m(o.SpeedDialAction, "fabHoverBg", wt(o.background.paper, 0.15)), m(o.StepConnector, "border", R("palette-grey-400")), m(o.StepContent, "border", R("palette-grey-400")), m(o.Switch, "defaultColor", R("palette-common-white")), m(o.Switch, "defaultDisabledColor", R("palette-grey-100")), m(o.Switch, "primaryDisabledColor", U(o.primary.main, 0.62)), m(o.Switch, "secondaryDisabledColor", U(o.secondary.main, 0.62)), m(o.Switch, "errorDisabledColor", U(o.error.main, 0.62)), m(o.Switch, "infoDisabledColor", U(o.info.main, 0.62)), m(o.Switch, "successDisabledColor", U(o.success.main, 0.62)), m(o.Switch, "warningDisabledColor", U(o.warning.main, 0.62)), m(o.TableCell, "border", U(vt(o.divider, 1), 0.88)), m(o.Tooltip, "bg", vt(o.grey[700], 0.92));
    }
    if (o.mode === "dark") {
      m(o.Alert, "errorColor", U(o.error.light, 0.6)), m(o.Alert, "infoColor", U(o.info.light, 0.6)), m(o.Alert, "successColor", U(o.success.light, 0.6)), m(o.Alert, "warningColor", U(o.warning.light, 0.6)), m(o.Alert, "errorFilledBg", R("palette-error-dark")), m(o.Alert, "infoFilledBg", R("palette-info-dark")), m(o.Alert, "successFilledBg", R("palette-success-dark")), m(o.Alert, "warningFilledBg", R("palette-warning-dark")), m(o.Alert, "errorFilledColor", Ae(() => o.getContrastText(o.error.dark))), m(o.Alert, "infoFilledColor", Ae(() => o.getContrastText(o.info.dark))), m(o.Alert, "successFilledColor", Ae(() => o.getContrastText(o.success.dark))), m(o.Alert, "warningFilledColor", Ae(() => o.getContrastText(o.warning.dark))), m(o.Alert, "errorStandardBg", x(o.error.light, 0.9)), m(o.Alert, "infoStandardBg", x(o.info.light, 0.9)), m(o.Alert, "successStandardBg", x(o.success.light, 0.9)), m(o.Alert, "warningStandardBg", x(o.warning.light, 0.9)), m(o.Alert, "errorIconColor", R("palette-error-main")), m(o.Alert, "infoIconColor", R("palette-info-main")), m(o.Alert, "successIconColor", R("palette-success-main")), m(o.Alert, "warningIconColor", R("palette-warning-main")), m(o.AppBar, "defaultBg", R("palette-grey-900")), m(o.AppBar, "darkBg", R("palette-background-paper")), m(o.AppBar, "darkColor", R("palette-text-primary")), m(o.Avatar, "defaultBg", R("palette-grey-600")), m(o.Button, "inheritContainedBg", R("palette-grey-800")), m(o.Button, "inheritContainedHoverBg", R("palette-grey-700")), m(o.Chip, "defaultBorder", R("palette-grey-700")), m(o.Chip, "defaultAvatarColor", R("palette-grey-300")), m(o.Chip, "defaultIconColor", R("palette-grey-300")), m(o.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), m(o.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), m(o.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), m(o.LinearProgress, "primaryBg", x(o.primary.main, 0.5)), m(o.LinearProgress, "secondaryBg", x(o.secondary.main, 0.5)), m(o.LinearProgress, "errorBg", x(o.error.main, 0.5)), m(o.LinearProgress, "infoBg", x(o.info.main, 0.5)), m(o.LinearProgress, "successBg", x(o.success.main, 0.5)), m(o.LinearProgress, "warningBg", x(o.warning.main, 0.5)), m(o.Skeleton, "bg", `rgba(${R("palette-text-primaryChannel")} / 0.13)`), m(o.Slider, "primaryTrack", x(o.primary.main, 0.5)), m(o.Slider, "secondaryTrack", x(o.secondary.main, 0.5)), m(o.Slider, "errorTrack", x(o.error.main, 0.5)), m(o.Slider, "infoTrack", x(o.info.main, 0.5)), m(o.Slider, "successTrack", x(o.success.main, 0.5)), m(o.Slider, "warningTrack", x(o.warning.main, 0.5));
      const P = wt(o.background.default, 0.98);
      m(o.SnackbarContent, "bg", P), m(o.SnackbarContent, "color", Ae(() => o.getContrastText(P))), m(o.SpeedDialAction, "fabHoverBg", wt(o.background.paper, 0.15)), m(o.StepConnector, "border", R("palette-grey-600")), m(o.StepContent, "border", R("palette-grey-600")), m(o.Switch, "defaultColor", R("palette-grey-300")), m(o.Switch, "defaultDisabledColor", R("palette-grey-600")), m(o.Switch, "primaryDisabledColor", x(o.primary.main, 0.55)), m(o.Switch, "secondaryDisabledColor", x(o.secondary.main, 0.55)), m(o.Switch, "errorDisabledColor", x(o.error.main, 0.55)), m(o.Switch, "infoDisabledColor", x(o.info.main, 0.55)), m(o.Switch, "successDisabledColor", x(o.success.main, 0.55)), m(o.Switch, "warningDisabledColor", x(o.warning.main, 0.55)), m(o.TableCell, "border", x(vt(o.divider, 1), 0.68)), m(o.Tooltip, "bg", vt(o.grey[700], 0.92));
    }
    Re(o.background, "default"), Re(o.background, "paper"), Re(o.common, "background"), Re(o.common, "onBackground"), Re(o, "divider"), Object.keys(o).forEach((P) => {
      const B = o[P];
      B && typeof B == "object" && (B.main && m(o[P], "mainChannel", st(lt(B.main))), B.light && m(o[P], "lightChannel", st(lt(B.light))), B.dark && m(o[P], "darkChannel", st(lt(B.dark))), B.contrastText && m(o[P], "contrastTextChannel", st(lt(B.contrastText))), P === "text" && (Re(o[P], "primary"), Re(o[P], "secondary")), P === "action" && (B.active && Re(o[P], "active"), B.selected && Re(o[P], "selected")));
    });
  }), S = t.reduce((k, o) => ne(k, o), S);
  const h = {
    prefix: a,
    disableCssColorScheme: i,
    shouldSkipGeneratingVar: s,
    getSelector: zs(S)
  }, {
    vars: y,
    generateThemeVars: O,
    generateStyleSheets: w
  } = fs(S, h);
  return S.vars = y, Object.entries(S.colorSchemes[S.defaultColorScheme]).forEach(([k, o]) => {
    S[k] = o;
  }), S.generateThemeVars = O, S.generateStyleSheets = w, S.generateSpacing = function() {
    return pi(E.spacing, Zn(this));
  }, S.getColorSchemeSelector = gs(l), S.spacing = S.generateSpacing(), S.shouldSkipGeneratingVar = s, S.unstable_sxConfig = {
    ...Yt,
    ...E == null ? void 0 : E.unstable_sxConfig
  }, S.unstable_sx = function(o) {
    return Ht({
      sx: o,
      theme: this
    });
  }, S.toRuntimeSource = Ai, S;
}
function jr(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: nr({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function Qs(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: i = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: a = n == null ? void 0 : n.mode,
    ...s
  } = e, l = a || "light", c = i == null ? void 0 : i[l], E = {
    ...i,
    ...n ? {
      [l]: {
        ...typeof c != "boolean" && c,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return Sn(e, ...t);
    let p = n;
    "palette" in e || E[l] && (E[l] !== !0 ? p = E[l].palette : l === "dark" && (p = {
      mode: "dark"
    }));
    const d = Sn({
      ...e,
      palette: p
    }, ...t);
    return d.defaultColorScheme = l, d.colorSchemes = E, d.palette.mode === "light" && (d.colorSchemes.light = {
      ...E.light !== !0 && E.light,
      palette: d.palette
    }, jr(d, "dark", E.dark)), d.palette.mode === "dark" && (d.colorSchemes.dark = {
      ...E.dark !== !0 && E.dark,
      palette: d.palette
    }, jr(d, "light", E.light)), d;
  }
  return !n && !("light" in E) && l === "light" && (E.light = !0), Js({
    ...s,
    colorSchemes: E,
    defaultColorScheme: l,
    ...typeof r != "boolean" && r
  }, ...t);
}
const Zs = Qs(), qs = "$$material";
function $s() {
  const e = rs(Zs);
  return e[qs] || e;
}
const el = (e) => e.scrollTop;
function Yr(e, t) {
  const {
    timeout: n,
    easing: r,
    style: i = {}
  } = e;
  return {
    duration: i.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: i.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: i.transitionDelay
  };
}
const tl = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, _t = /* @__PURE__ */ N.forwardRef(function(t, n) {
  const r = $s(), i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: a,
    appear: s = !0,
    children: l,
    easing: c,
    in: E,
    onEnter: p,
    onEntered: d,
    onEntering: _,
    onExit: f,
    onExited: A,
    onExiting: g,
    style: b,
    timeout: I = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: v = Ta,
    ...C
  } = t, S = N.useRef(null), h = ds(S, eo(l), n), y = (M) => (J) => {
    if (M) {
      const Ee = S.current;
      J === void 0 ? M(Ee) : M(Ee, J);
    }
  }, O = y(_), w = y((M, J) => {
    el(M);
    const Ee = Yr({
      style: b,
      timeout: I,
      easing: c
    }, {
      mode: "enter"
    });
    M.style.webkitTransition = r.transitions.create("opacity", Ee), M.style.transition = r.transitions.create("opacity", Ee), p && p(M, J);
  }), k = y(d), o = y(g), R = y((M) => {
    const J = Yr({
      style: b,
      timeout: I,
      easing: c
    }, {
      mode: "exit"
    });
    M.style.webkitTransition = r.transitions.create("opacity", J), M.style.transition = r.transitions.create("opacity", J), f && f(M);
  }), P = y(A), B = (M) => {
    a && a(S.current, M);
  };
  return /* @__PURE__ */ Jo.jsx(v, {
    appear: s,
    in: E,
    nodeRef: S,
    onEnter: w,
    onEntered: k,
    onEntering: O,
    onExit: R,
    onExited: P,
    onExiting: o,
    addEndListener: B,
    timeout: I,
    ...C,
    children: (M, J) => /* @__PURE__ */ N.cloneElement(l, {
      style: {
        opacity: 0,
        visibility: M === "exited" && !E ? "hidden" : void 0,
        ...tl[M],
        ...b,
        ...l.props.style
      },
      ref: h,
      ...J
    })
  });
});
function nl(e) {
  return e && e.length ? e[0] : void 0;
}
var rl = nl, il = rl;
const Si = /* @__PURE__ */ fa(il), rr = /* @__PURE__ */ Xn({
  inMiniHeader: !1
}), w_ = ({
  children: e
}) => /* @__PURE__ */ u.createElement(rr.Provider, {
  value: {
    inMiniHeader: !0
  },
  "data-qa": "mini-header-indicator-context-provider"
}, e);
rr.displayName = "MiniHeaderIndicatorContext";
const al = () => Kn(rr), P_ = () => {
  const {
    currentArticleId: e,
    rosettaInstance: t
  } = re();
  return {
    computeGA4CommonParameters: de(() => {
      var r;
      if (!t) return {};
      const a = (r = new URLSearchParams(window.location.search).get("promoCode")) !== null && r !== void 0 ? r : "";
      return {
        ...t.rulesEngine.getOutcome("tracking.ga4.baseParameters"),
        ...e ? {
          article_id: e
        } : {},
        ...a ? {
          promo_code: a
        } : {}
      };
    }, [e, t])
  };
}, ol = (e) => {
  const {
    handleTrackGA4: t
  } = re(), {
    inMiniHeader: n
  } = al(), {
    ga4Event: r
  } = e, {
    captureTrackImpressionEventTargetElement: i,
    intersection: a
  } = Ra({
    ga4TrackingHandler: t,
    getGa4Event: r,
    options: {
      intersectionThreshold: [0.5],
      isSendGA4Tracking: !n,
      shouldSendOnce: !0
    }
  });
  return {
    captureTrackImpressionEventTargetElement: i,
    intersection: a
  };
};
let L = /* @__PURE__ */ function(e) {
  return e.AcquisitionNewsletterPopup = "acquisition-newsletter-popup", e.Article = "article", e.Article20 = "article20", e.ArticleDark = "article-dark", e.Footer = "footer", e.Homepage = "homepage", e.LiveArticle = "live-article", e.NewsletterArticle = "newsletter-article", e.NewsletterArticleBottom = "newsletter-article-bottom", e.NewsletterList = "newsletter-list", e.Posties = "posties", e.Section = "section", e;
}({}), q = /* @__PURE__ */ function(e) {
  return e.FindOutMore = "find-out-more", e.SignUpNewsletter = "sign-up-newsletter", e.SignUpSuccessMessage = "sign-up-success-message", e;
}({});
const ir = /* @__PURE__ */ Xn({
  campaignName: "",
  dataMatrix: {},
  newsletterItems: [],
  queryParametersForSocialButtons: {},
  variant: L.Footer
}), sl = ({
  children: e,
  multipleNewsletters: t = !1,
  value: {
    newsletterItems: n,
    ...r
  }
}) => {
  const [i, a] = Se(""), s = Fe(() => Si(n), [n]);
  return /* @__PURE__ */ u.createElement(ir.Provider, {
    value: {
      ...r,
      lastSubscribedNewsletter: i,
      newsletterItemForDisplay: s,
      newsletterItems: t ? n : n.slice(0, 1),
      setLastSubscribedNewsletter: a
    },
    "data-qa": "newsletter-context-provider"
  }, e);
};
ir.displayName = "NewsletterContext";
const me = () => Kn(ir), hi = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "first"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "newsletterIds"
  }], t = [{
    fields: [{
      kind: "Variable",
      name: "entityIds",
      variableName: "newsletterIds"
    }],
    kind: "ObjectValue",
    name: "filter"
  }, {
    kind: "Variable",
    name: "first",
    variableName: "first"
  }], n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityId",
    storageKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "name",
    storageKey: null
  }, i = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "alternativeName",
    storageKey: null
  }, a = [{
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "text",
    storageKey: null
  }], s = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "description",
    plural: !1,
    selections: a,
    storageKey: null
  }, l = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "summary",
    plural: !1,
    selections: a,
    storageKey: null
  }, c = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "homepageDescription",
    plural: !1,
    selections: a,
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "hooksNewsletterQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "NewsletterConnection",
        kind: "LinkedField",
        name: "newsletters",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "NewsletterEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Newsletter",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [
              n,
              r,
              i,
              s,
              l,
              c
              /*: any*/
            ],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "hooksNewsletterQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "NewsletterConnection",
        kind: "LinkedField",
        name: "newsletters",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "NewsletterEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Newsletter",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [n, r, i, s, l, c, {
              alias: null,
              args: null,
              kind: "ScalarField",
              name: "id",
              storageKey: null
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }]
    },
    params: {
      cacheID: "db6ce7df57fd46a0894ca1c99f5593c8",
      id: null,
      metadata: {},
      name: "hooksNewsletterQuery",
      operationKind: "query",
      text: `query hooksNewsletterQuery(
  $first: Int
  $newsletterIds: [String]
) {
  newsletters(first: $first, filter: {entityIds: $newsletterIds}) {
    edges {
      node {
        entityId
        name
        alternativeName
        description {
          text
        }
        summary {
          text
        }
        homepageDescription {
          text
        }
        id
      }
    }
  }
}
`
    }
  };
}();
hi.hash = "07926024ff85778e6f495ad0f59ef656";
var Ci = { exports: {} }, ln = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hr;
function ll() {
  if (Hr) return ln;
  Hr = 1;
  var e = u;
  function t(d, _) {
    return d === _ && (d !== 0 || 1 / d === 1 / _) || d !== d && _ !== _;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, a = e.useLayoutEffect, s = e.useDebugValue;
  function l(d, _) {
    var f = _(), A = r({ inst: { value: f, getSnapshot: _ } }), g = A[0].inst, b = A[1];
    return a(function() {
      g.value = f, g.getSnapshot = _, c(g) && b({ inst: g });
    }, [d, f, _]), i(function() {
      return c(g) && b({ inst: g }), d(function() {
        c(g) && b({ inst: g });
      });
    }, [d]), s(f), f;
  }
  function c(d) {
    var _ = d.getSnapshot;
    d = d.value;
    try {
      var f = _();
      return !n(d, f);
    } catch {
      return !0;
    }
  }
  function E(d, _) {
    return _();
  }
  var p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? E : l;
  return ln.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : p, ln;
}
Ci.exports = ll();
var cl = Ci.exports;
const Le = () => {
}, ee = (
  /*#__NOINLINE__*/
  Le()
), cn = Object, D = (e) => e === ee, Ie = (e) => typeof e == "function", ke = (e, t) => ({
  ...e,
  ...t
}), ul = (e) => Ie(e.then), Pt = /* @__PURE__ */ new WeakMap();
let _l = 0;
const Et = (e) => {
  const t = typeof e, n = e && e.constructor, r = n == Date;
  let i, a;
  if (cn(e) === e && !r && n != RegExp) {
    if (i = Pt.get(e), i) return i;
    if (i = ++_l + "~", Pt.set(e, i), n == Array) {
      for (i = "@", a = 0; a < e.length; a++)
        i += Et(e[a]) + ",";
      Pt.set(e, i);
    }
    if (n == cn) {
      i = "#";
      const s = cn.keys(e).sort();
      for (; !D(a = s.pop()); )
        D(e[a]) || (i += a + ":" + Et(e[a]) + ",");
      Pt.set(e, i);
    }
  } else
    i = r ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
  return i;
}, be = /* @__PURE__ */ new WeakMap(), un = {}, Lt = {}, ar = "undefined", Wt = typeof window != ar, hn = typeof document != ar, dl = () => Wt && typeof window.requestAnimationFrame != ar, Ri = (e, t) => {
  const n = be.get(e);
  return [
    // Getter
    () => !D(t) && e.get(t) || un,
    // Setter
    (r) => {
      if (!D(t)) {
        const i = e.get(t);
        t in Lt || (Lt[t] = i), n[5](t, ke(i, r), i || un);
      }
    },
    // Subscriber
    n[6],
    // Get server cache snapshot
    () => !D(t) && t in Lt ? Lt[t] : !D(t) && e.get(t) || un
  ];
};
let Cn = !0;
const pl = () => Cn, [Rn, bn] = Wt && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  Le,
  Le
], ml = () => {
  const e = hn && document.visibilityState;
  return D(e) || e !== "hidden";
}, El = (e) => (hn && document.addEventListener("visibilitychange", e), Rn("focus", e), () => {
  hn && document.removeEventListener("visibilitychange", e), bn("focus", e);
}), fl = (e) => {
  const t = () => {
    Cn = !0, e();
  }, n = () => {
    Cn = !1;
  };
  return Rn("online", t), Rn("offline", n), () => {
    bn("online", t), bn("offline", n);
  };
}, gl = {
  isOnline: pl,
  isVisible: ml
}, Al = {
  initFocus: El,
  initReconnect: fl
}, zr = !u.useId, ft = !Wt || "Deno" in window, Tl = (e) => dl() ? window.requestAnimationFrame(e) : setTimeout(e, 1), _n = ft ? Qe : ga, dn = typeof navigator < "u" && navigator.connection, Wr = !ft && dn && ([
  "slow-2g",
  "2g"
].includes(dn.effectiveType) || dn.saveData), or = (e) => {
  if (Ie(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const t = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? Et(e) : "", [
    e,
    t
  ];
};
let Il = 0;
const yn = () => ++Il, bi = 0, yi = 1, Ni = 2, Sl = 3;
var at = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT: Sl,
  FOCUS_EVENT: bi,
  MUTATE_EVENT: Ni,
  RECONNECT_EVENT: yi
};
async function Oi(...e) {
  const [t, n, r, i] = e, a = ke({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let s = a.populateCache;
  const l = a.rollbackOnError;
  let c = a.optimisticData;
  const E = (_) => typeof l == "function" ? l(_) : l !== !1, p = a.throwOnError;
  if (Ie(n)) {
    const _ = n, f = [], A = t.keys();
    for (const g of A)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(g) && _(t.get(g)._k) && f.push(g);
    return Promise.all(f.map(d));
  }
  return d(n);
  async function d(_) {
    const [f] = or(_);
    if (!f) return;
    const [A, g] = Ri(t, f), [b, I, v, C] = be.get(t), S = () => {
      const B = b[f];
      return (Ie(a.revalidate) ? a.revalidate(A().data, _) : a.revalidate !== !1) && (delete v[f], delete C[f], B && B[0]) ? B[0](Ni).then(() => A().data) : A().data;
    };
    if (e.length < 3)
      return S();
    let h = r, y;
    const O = yn();
    I[f] = [
      O,
      0
    ];
    const w = !D(c), k = A(), o = k.data, R = k._c, P = D(R) ? o : R;
    if (w && (c = Ie(c) ? c(P, o) : c, g({
      data: c,
      _c: P
    })), Ie(h))
      try {
        h = h(P);
      } catch (B) {
        y = B;
      }
    if (h && ul(h))
      if (h = await h.catch((B) => {
        y = B;
      }), O !== I[f][0]) {
        if (y) throw y;
        return h;
      } else y && w && E(y) && (s = !0, g({
        data: P,
        _c: ee
      }));
    if (s && !y)
      if (Ie(s)) {
        const B = s(h, P);
        g({
          data: B,
          error: ee,
          _c: ee
        });
      } else
        g({
          data: h,
          error: ee,
          _c: ee
        });
    if (I[f][1] = yn(), Promise.resolve(S()).then(() => {
      g({
        _c: ee
      });
    }), y) {
      if (p) throw y;
      return;
    }
    return h;
  }
}
const Xr = (e, t) => {
  for (const n in e)
    e[n][0] && e[n][0](t);
}, hl = (e, t) => {
  if (!be.has(e)) {
    const n = ke(Al, t), r = {}, i = Oi.bind(ee, e);
    let a = Le;
    const s = {}, l = (p, d) => {
      const _ = s[p] || [];
      return s[p] = _, _.push(d), () => _.splice(_.indexOf(d), 1);
    }, c = (p, d, _) => {
      e.set(p, d);
      const f = s[p];
      if (f)
        for (const A of f)
          A(d, _);
    }, E = () => {
      if (!be.has(e) && (be.set(e, [
        r,
        {},
        {},
        {},
        i,
        c,
        l
      ]), !ft)) {
        const p = n.initFocus(setTimeout.bind(ee, Xr.bind(ee, r, bi))), d = n.initReconnect(setTimeout.bind(ee, Xr.bind(ee, r, yi)));
        a = () => {
          p && p(), d && d(), be.delete(e);
        };
      }
    };
    return E(), [
      e,
      i,
      E,
      a
    ];
  }
  return [
    e,
    be.get(e)[4]
  ];
}, Cl = (e, t, n, r, i) => {
  const a = n.errorRetryCount, s = i.retryCount, l = ~~((Math.random() + 0.5) * (1 << (s < 8 ? s : 8))) * n.errorRetryInterval;
  !D(a) && s > a || setTimeout(r, l, i);
}, Rl = (e, t) => Et(e) == Et(t), [vi, bl] = hl(/* @__PURE__ */ new Map()), yl = ke(
  {
    // events
    onLoadingSlow: Le,
    onSuccess: Le,
    onError: Le,
    onErrorRetry: Cl,
    onDiscarded: Le,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: Wr ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: Wr ? 5e3 : 3e3,
    // providers
    compare: Rl,
    isPaused: () => !1,
    cache: vi,
    mutate: bl,
    fallback: {}
  },
  // use web preset by default
  gl
), Nl = (e, t) => {
  const n = ke(e, t);
  if (t) {
    const { use: r, fallback: i } = e, { use: a, fallback: s } = t;
    r && a && (n.use = r.concat(a)), i && s && (n.fallback = ke(i, s));
  }
  return n;
}, Ol = Xn({}), vl = "$inf$", wi = Wt && window.__SWR_DEVTOOLS_USE__, wl = wi ? window.__SWR_DEVTOOLS_USE__ : [], Pl = () => {
  wi && (window.__SWR_DEVTOOLS_REACT__ = u);
}, Pi = (e) => Ie(e[1]) ? [
  e[0],
  e[1],
  e[2] || {}
] : [
  e[0],
  null,
  (e[1] === null ? e[2] : e[1]) || {}
], Ll = () => ke(yl, Kn(Ol)), Bl = (e) => (t, n, r) => e(t, n && ((...a) => {
  const [s] = or(t), [, , , l] = be.get(vi);
  if (s.startsWith(vl))
    return n(...a);
  const c = l[s];
  return D(c) ? n(...a) : (delete l[s], c);
}), r), kl = wl.concat(Bl), Dl = (e) => function(...n) {
  const r = Ll(), [i, a, s] = Pi(n), l = Nl(r, s);
  let c = e;
  const { use: E } = l, p = (E || []).concat(kl);
  for (let d = p.length; d--; )
    c = p[d](c);
  return c(i, a || l.fetcher || null, l);
}, Ml = (e, t, n) => {
  const r = t[e] || (t[e] = []);
  return r.push(n), () => {
    const i = r.indexOf(n);
    i >= 0 && (r[i] = r[r.length - 1], r.pop());
  };
}, xl = (e, t) => (...n) => {
  const [r, i, a] = Pi(n), s = (a.use || []).concat(t);
  return e(r, i, {
    ...a,
    use: s
  });
};
Pl();
const Kr = u.use || ((e) => {
  if (e.status === "pending")
    throw e;
  if (e.status === "fulfilled")
    return e.value;
  throw e.status === "rejected" ? e.reason : (e.status = "pending", e.then((t) => {
    e.status = "fulfilled", e.value = t;
  }, (t) => {
    e.status = "rejected", e.reason = t;
  }), e);
}), pn = {
  dedupe: !0
}, Ul = (e, t, n) => {
  const { cache: r, compare: i, suspense: a, fallbackData: s, revalidateOnMount: l, revalidateIfStale: c, refreshInterval: E, refreshWhenHidden: p, refreshWhenOffline: d, keepPreviousData: _ } = n, [f, A, g, b] = be.get(r), [I, v] = or(e), C = Ue(!1), S = Ue(!1), h = Ue(I), y = Ue(t), O = Ue(n), w = () => O.current, k = () => w().isVisible() && w().isOnline(), [o, R, P, B] = Ri(r, I), M = Ue({}).current, J = D(s) ? n.fallback[I] : s, Ee = (F, G) => {
    for (const Z in M) {
      const z = Z;
      if (z === "data") {
        if (!i(F[z], G[z]) && (!D(F[z]) || !i(Ot, G[z])))
          return !1;
      } else if (G[z] !== F[z])
        return !1;
    }
    return !0;
  }, bt = Fe(() => {
    const F = !I || !t ? !1 : D(l) ? w().isPaused() || a ? !1 : D(c) ? !0 : c : l, G = ($) => {
      const he = ke($);
      return delete he._k, F ? {
        isValidating: !0,
        isLoading: !0,
        ...he
      } : he;
    }, Z = o(), z = B(), ge = G(Z), He = Z === z ? ge : G(z);
    let Q = ge;
    return [
      () => {
        const $ = G(o());
        return Ee($, Q) ? (Q.data = $.data, Q.isLoading = $.isLoading, Q.isValidating = $.isValidating, Q.error = $.error, Q) : (Q = $, $);
      },
      () => He
    ];
  }, [
    r,
    I
  ]), ve = cl.useSyncExternalStore(de(
    (F) => P(I, (G, Z) => {
      Ee(Z, G) || F();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      I
    ]
  ), bt[0], bt[1]), yt = !C.current, H = f[I] && f[I].length > 0, fe = ve.data, we = D(fe) ? J : fe, Nt = ve.error, Ir = Ue(we), Ot = _ ? D(fe) ? Ir.current : fe : we, Sr = H && !D(Nt) ? !1 : yt && !D(l) ? l : w().isPaused() ? !1 : a ? D(we) ? !1 : c : D(we) || c, hr = !!(I && t && yt && Sr), da = D(ve.isValidating) ? hr : ve.isValidating, pa = D(ve.isLoading) ? hr : ve.isLoading, nt = de(
    async (F) => {
      const G = y.current;
      if (!I || !G || S.current || w().isPaused())
        return !1;
      let Z, z, ge = !0;
      const He = F || {}, Q = !g[I] || !He.dedupe, $ = () => zr ? !S.current && I === h.current && C.current : I === h.current, he = {
        isValidating: !1,
        isLoading: !1
      }, Rr = () => {
        R(he);
      }, br = () => {
        const ie = g[I];
        ie && ie[1] === z && delete g[I];
      }, yr = {
        isValidating: !0
      };
      D(o().data) && (yr.isLoading = !0);
      try {
        if (Q && (R(yr), n.loadingTimeout && D(o().data) && setTimeout(() => {
          ge && $() && w().onLoadingSlow(I, n);
        }, n.loadingTimeout), g[I] = [
          G(v),
          yn()
        ]), [Z, z] = g[I], Z = await Z, Q && setTimeout(br, n.dedupingInterval), !g[I] || g[I][1] !== z)
          return Q && $() && w().onDiscarded(I), !1;
        he.error = ee;
        const ie = A[I];
        if (!D(ie) && // case 1
        (z <= ie[0] || // case 2
        z <= ie[1] || // case 3
        ie[1] === 0))
          return Rr(), Q && $() && w().onDiscarded(I), !1;
        const Ce = o().data;
        he.data = i(Ce, Z) ? Ce : Z, Q && $() && w().onSuccess(Z, I, n);
      } catch (ie) {
        br();
        const Ce = w(), { shouldRetryOnError: nn } = Ce;
        Ce.isPaused() || (he.error = ie, Q && $() && (Ce.onError(ie, I, Ce), (nn === !0 || Ie(nn) && nn(ie)) && (!w().revalidateOnFocus || !w().revalidateOnReconnect || k()) && Ce.onErrorRetry(ie, I, Ce, (ma) => {
          const rn = f[I];
          rn && rn[0] && rn[0](at.ERROR_REVALIDATE_EVENT, ma);
        }, {
          retryCount: (He.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return ge = !1, Rr(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      I,
      r
    ]
  ), Cr = de(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...F) => Oi(r, h.current, ...F),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (_n(() => {
    y.current = t, O.current = n, D(fe) || (Ir.current = fe);
  }), _n(() => {
    if (!I) return;
    const F = nt.bind(ee, pn);
    let G = 0;
    const z = Ml(I, f, (ge, He = {}) => {
      if (ge == at.FOCUS_EVENT) {
        const Q = Date.now();
        w().revalidateOnFocus && Q > G && k() && (G = Q + w().focusThrottleInterval, F());
      } else if (ge == at.RECONNECT_EVENT)
        w().revalidateOnReconnect && k() && F();
      else {
        if (ge == at.MUTATE_EVENT)
          return nt();
        if (ge == at.ERROR_REVALIDATE_EVENT)
          return nt(He);
      }
    });
    return S.current = !1, h.current = I, C.current = !0, R({
      _k: v
    }), Sr && (D(we) || ft ? F() : Tl(F)), () => {
      S.current = !0, z();
    };
  }, [
    I
  ]), _n(() => {
    let F;
    function G() {
      const z = Ie(E) ? E(o().data) : E;
      z && F !== -1 && (F = setTimeout(Z, z));
    }
    function Z() {
      !o().error && (p || w().isVisible()) && (d || w().isOnline()) ? nt(pn).then(G) : G();
    }
    return G(), () => {
      F && (clearTimeout(F), F = -1);
    };
  }, [
    E,
    p,
    d,
    I
  ]), Aa(Ot), a && D(we) && I) {
    if (!zr && ft)
      throw new Error("Fallback data is required when using suspense in SSR.");
    y.current = t, O.current = n, S.current = !1;
    const F = b[I];
    if (!D(F)) {
      const G = Cr(F);
      Kr(G);
    }
    if (D(Nt)) {
      const G = nt(pn);
      D(Ot) || (G.status = "fulfilled", G.value = !0), Kr(G);
    } else
      throw Nt;
  }
  return {
    mutate: Cr,
    get data() {
      return M.data = !0, Ot;
    },
    get error() {
      return M.error = !0, Nt;
    },
    get isValidating() {
      return M.isValidating = !0, da;
    },
    get isLoading() {
      return M.isLoading = !0, pa;
    }
  };
}, Fl = Dl(Ul), Gl = (e) => (t, n, r) => (r.revalidateOnFocus = !1, r.revalidateIfStale = !1, r.revalidateOnReconnect = !1, e(t, n, r)), Vl = xl(Fl, Gl), Li = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "input"
  }], t = [{
    kind: "Variable",
    name: "input",
    variableName: "input"
  }], n = {
    kind: "InlineFragment",
    selections: [{
      alias: null,
      args: null,
      concreteType: "SimplenewsSubscriberUid",
      kind: "LinkedField",
      name: "uid",
      plural: !1,
      selections: [{
        alias: null,
        args: null,
        concreteType: "SimplenewsSubscriberUidEntity",
        kind: "LinkedField",
        name: "entity",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "uid",
          storageKey: null
        }],
        storageKey: null
      }],
      storageKey: null
    }, {
      alias: null,
      args: null,
      concreteType: "SimplenewsSubscriberSubscription",
      kind: "LinkedField",
      name: "subscriptions",
      plural: !0,
      selections: [{
        alias: null,
        args: null,
        concreteType: "SimplenewsSubscriberSubscriptionEntity",
        kind: "LinkedField",
        name: "entity",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "entityId",
          storageKey: null
        }, {
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "entityLabel",
          storageKey: null
        }],
        storageKey: null
      }],
      storageKey: null
    }],
    type: "SimplenewsSubscriber",
    abstractKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "errors",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "apisSignUpNewslettersApiMutation",
      selections: [{
        alias: null,
        args: t,
        concreteType: "EntityCrudOutput",
        kind: "LinkedField",
        name: "upsertNewsletterSubscriber",
        plural: !1,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: null,
            kind: "LinkedField",
            name: "entity",
            plural: !1,
            selections: [
              n
              /*: any*/
            ],
            storageKey: null
          },
          r
          /*: any*/
        ],
        storageKey: null
      }],
      type: "Mutation",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "apisSignUpNewslettersApiMutation",
      selections: [{
        alias: null,
        args: t,
        concreteType: "EntityCrudOutput",
        kind: "LinkedField",
        name: "upsertNewsletterSubscriber",
        plural: !1,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: null,
            kind: "LinkedField",
            name: "entity",
            plural: !1,
            selections: [
              {
                alias: null,
                args: null,
                kind: "ScalarField",
                name: "__typename",
                storageKey: null
              },
              n
              /*: any*/
            ],
            storageKey: null
          },
          r
          /*: any*/
        ],
        storageKey: null
      }]
    },
    params: {
      cacheID: "1fb3fb9786fa62f38926c967a5046b9b",
      id: null,
      metadata: {},
      name: "apisSignUpNewslettersApiMutation",
      operationKind: "mutation",
      text: `mutation apisSignUpNewslettersApiMutation(
  $input: NewsletterSubscriberInput
) {
  upsertNewsletterSubscriber(input: $input) {
    entity {
      __typename
      ... on SimplenewsSubscriber {
        uid {
          entity {
            uid
          }
        }
        subscriptions {
          entity {
            entityId
            entityLabel
          }
        }
      }
    }
    errors
  }
}
`
    }
  };
}();
Li.hash = "9c5f8eda66218d275fb91bd0162382c4";
const Bi = /* @__PURE__ */ function() {
  var e = [{
    alias: null,
    args: null,
    concreteType: "CurrentUserContext",
    kind: "LinkedField",
    name: "currentUserContext",
    plural: !1,
    selections: [{
      alias: null,
      args: null,
      concreteType: "ReverseUidSimplenewsSubscriber",
      kind: "LinkedField",
      name: "reverseUidSimplenewsSubscriber",
      plural: !1,
      selections: [{
        alias: null,
        args: null,
        concreteType: "SimplenewsSubscriber",
        kind: "LinkedField",
        name: "entities",
        plural: !0,
        selections: [{
          alias: null,
          args: null,
          concreteType: "SimplenewsSubscriberSubscription",
          kind: "LinkedField",
          name: "subscriptions",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            kind: "ScalarField",
            name: "status",
            storageKey: null
          }, {
            alias: null,
            args: null,
            concreteType: "SimplenewsSubscriberSubscriptionEntity",
            kind: "LinkedField",
            name: "entity",
            plural: !1,
            selections: [{
              alias: null,
              args: null,
              kind: "ScalarField",
              name: "entityId",
              storageKey: null
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      storageKey: null
    }],
    storageKey: null
  }];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: "Fragment",
      metadata: null,
      name: "apisSignupNewsletterQuery",
      selections: e,
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: [],
      kind: "Operation",
      name: "apisSignupNewsletterQuery",
      selections: e
      /*: any*/
    },
    params: {
      cacheID: "bee14d13a84d3a7ae570d06e18ab0d29",
      id: null,
      metadata: {},
      name: "apisSignupNewsletterQuery",
      operationKind: "query",
      text: `query apisSignupNewsletterQuery {
  currentUserContext {
    reverseUidSimplenewsSubscriber {
      entities {
        subscriptions {
          status
          entity {
            entityId
          }
        }
      }
    }
  }
}
`
    }
  };
}();
Bi.hash = "9ef62adb5a9764d0efceaca536e80013";
const jl = Bi, Yl = (e) => async () => {
  var t, n;
  const r = await ni(e, jl, {}).toPromise();
  return (t = r == null || (n = r.currentUserContext) === null || n === void 0 || (n = n.reverseUidSimplenewsSubscriber) === null || n === void 0 || (n = n.entities) === null || n === void 0 ? void 0 : n.flatMap((i) => {
    var a;
    return i == null || (a = i.subscriptions) === null || a === void 0 || (a = a.filter((s) => s == null ? void 0 : s.status)) === null || a === void 0 ? void 0 : a.map((s) => {
      var l;
      return s == null || (l = s.entity) === null || l === void 0 ? void 0 : l.entityId;
    });
  }).filter((i) => qe(i))) !== null && t !== void 0 ? t : [];
}, Hl = Li, zl = (e, t, n, r = {}) => {
  const i = t.map((a) => ({
    source: JSON.stringify(r),
    status: "1",
    targetId: a
  }));
  return new Promise((a) => {
    Na(e, {
      mutation: Hl,
      onCompleted: (s) => {
        a(s.upsertNewsletterSubscriber);
      },
      variables: {
        input: {
          append: !0,
          mail: n,
          subscriptions: i
        }
      }
    });
  });
}, Wl = "subscription_newsletterItems", ki = "subscription_dataMetrix", Xl = hi, Di = () => {
  const {
    environment: e,
    handleSetV1SignedUpNewslettersLocalStorage: t,
    user: n,
    v1SignedUpNewsletters: r
  } = re();
  e || console.error("Relay environment not found, make sure you wrapped your application with RelayEnvironmentProvider");
  const {
    set: i,
    value: a
  } = Bt(Sa, {
    defaultValue: 0
  }), {
    remove: s,
    value: l
  } = Bt(ki, {
    defaultValue: {}
  }), c = de((b) => {
    n && i(Date.now()), t(b);
  }, [t, i, n]), E = () => Date.now() > Oa(a ?? 0, 60).getTime(), {
    data: p,
    mutate: d
  } = Vl(n ? ha : null, Yl(e), {
    fallbackData: r,
    isPaused: () => !E(),
    onSuccess: (b) => c(b),
    refreshInterval: 1e3 * 30,
    revalidateOnMount: !0
  }), [_, f] = Se(!1);
  Qe(() => {
    p && f(!0);
  }, [p]);
  const A = de(async (b, I) => {
    const v = await ni(e, Xl, {
      first: I,
      newsletterIds: b
    }).toPromise();
    return v == null ? void 0 : v.newsletters.edges.map(({
      node: C
    }) => {
      var S, h, y;
      return {
        alternativeName: C.alternativeName,
        description: (S = C.description) !== null && S !== void 0 && S.text ? {
          text: C.description.text
        } : void 0,
        entityId: C.entityId,
        homepageDescription: (h = C.homepageDescription) !== null && h !== void 0 && h.text ? {
          text: C.homepageDescription.text
        } : void 0,
        name: C.name,
        summary: (y = C.summary) !== null && y !== void 0 && y.text ? {
          text: C.summary.text
        } : void 0
      };
    });
  }, [e]), g = de(async (b, I, v) => {
    const C = !qe(v), S = await zl(e, b, I, C ? l : v);
    if (qe(S.errors)) return S;
    const h = An(p ?? [], b, r);
    return await d(h, {
      optimisticData: h,
      populateCache: !0,
      revalidate: !1,
      rollbackOnError: !0
    }), C && s(), c(h), S;
  }, [p, l, e, c, d, s, r]);
  return {
    data: p,
    fetchNewsletterByIds: A,
    handleSignUpNewsletter: g,
    isDataReady: _,
    mutate: d
  };
}, Kl = () => {
  const {
    data: e
  } = Di(), {
    v1SignedUpNewsletters: t
  } = re(), [n, r] = Se(An(e ?? [], t ?? []));
  return Qe(() => {
    const i = setTimeout(() => r(An(e ?? [], t ?? [])), 1500);
    return () => clearTimeout(i);
  }, [e, t]), n;
}, Jl = (e) => e == null ? void 0 : e.name, Ne = (e) => {
  switch (e) {
    case L.AcquisitionNewsletterPopup:
      return "ppto";
    case L.Article:
      return "article inline";
    case L.Footer:
      return "footer inline";
    case L.Homepage:
      return "homepage inline";
    case L.LiveArticle:
      return "article_side";
    case L.NewsletterArticle:
      return "newsletter article";
    case L.NewsletterArticleBottom:
      return "newsletter article";
    case L.NewsletterList:
      return "newsletter index";
    case L.Section:
      return "section inline";
  }
  return "newsletter index";
}, Ql = /* @__PURE__ */ T("img", {
  target: "e1expqve0"
})({
  name: "1f3tddi",
  styles: "inline-size:21px;block-size:18px"
});
function Nn() {
  return Nn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nn.apply(null, arguments);
}
const Zl = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwCAYAAABE1blzAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAOKADAAQAAAABAAAAMAAAAAA9JyOSAAAC8klEQVRoBe2aOY/UQBSEBzaBhDvjEDcJvwAQGWzCnQMBQohLWuC3QMx9ZZtwCyEEJGQgEWzMAiE3AbuC+kZ+o2czPWaMPeMeXFJtv26321WuXu/O0WqlcVDdSXFa/BUZ0Yx2PPyBBRq5JcZmKqQXL3jq4Kqq0ORYx/HUmiPuFO/TSfBQ7QWRyGPCcok9Ie5wosep/da8oz6mYwXa74q2625i5I0b2MpA5Ngm/WYQb60ZN7CUgcixTPrN4MxcdcacIczGDu9hDIMhbA8dqNk4HtiWQVictAuTWVvU0uehsyIZq2OzSaJeiD/FzYnARWq9p1QHgzyJXrpJH1UfEesEUjsn/hDNzDPVaM81OF+TLrkTbYF7GlspDhsbJYDUTJe1aJ4n5hrUnDZ26ec70Rag/SQeFYcBUjsrfhe9Jv4hQavhrw1ywmLxsugXpH4grhIHBVJ7LmZ1oA2NHn0ZtBN3q8im+Vljx0T2fVUIpYYWNHVDIYMsxJ26Imbv4iONrRbLRig1NGRT89cubNAW2aMim+YXjR0Xy0iT1M6I2d+1Xqlpegf/bJCVlojdXmI91vgaJhTEBp3H4z67S7hWr9T85UoxaAvuVfFe9IK+qn9S7CfNUGqszY7pB6Ua5MKhNJ/o2Fom5KBXaqzdL0o3aAK6pflNB0+L3dLslRprFUVlBhHEHb8m+i1L/VRcLxpCqXFukdRsXdpKDdqF9qn4IHqjpDmRMPuEZC7nlIGBGEQoL56vi95kt5o5Zb7QHphB6W5jv35m08QoYxwrGwM3iAESuiFagtRlpqblOhiKQbv6ARWwSgzVYJXGbO2UQf4WjTQag7HH2yTYJFjzO9Bs0ZoHlCuvSTD3FtV8QpNgzQPKlfdfJDjrbsMoGPYeZulMOYPrXB1r6T1MYfC1czLh6lhL7+EV71eOi3y4abio4rz41gYiafmo/ZR42OnFWxu892/vl4xKi6cO+OLabXFUzOEl9WU8c3pIxaQ4LcZmFs1oT32d8jfZJ27pe+yPvgAAAABJRU5ErkJggg==", ql = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwCAYAAABE1blzAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAOKADAAQAAAABAAAAMAAAAAA9JyOSAAADTElEQVRoBe2auW+TQRDF46SBhpCEikvcNJRUENGBm5yAaLgKFCEuKcDfQhoaIAl3DeEQQghooAIpRWoSKCFcBYnM71keNF7yxTb+bLOWR3ra2fl2Z97zSyxwnGlzkcvljrM9DHaDte5RDOkcJN+C+5lMZtwIZ5QgbBXLVXBE+yaIu2gYQei8CZygcLQJhHkJkwg8lsG9A1QfuSdPyMfArKvFkK6D5Fmw35HN6sfzDrB4QJJ31R2KJhV38NDEsN6WwGlX2BuNmgSiaOl1eqYlcMEVehLuRVNGyxqnZ6Ed5h2O/YLLY029hg4JXDJ4FfYt+eA/K8KzHfQm0nJ2Ku3UQdY9hbredNYnXm7wA7jtBK/BL7CrwH01+Z+QGB+dbPRO9MYVP5OfarCWovHwkWuXwU9g8ZJE3EsKXMmh63bLrVPkG4omNWADhx1AroUhzivA8gKNMwf7wBzw8YXNiJ2p58pcuXYJ/AA+Ztn0GRfy8gTqAoe7wA0QxmMKG61prVdmybVXIQn24tbl57MvX6Bd5FI/CN2cp3Ya1OxfPvROck1c+o2fX6lXLlANuCg3x0EYTyls8kPSyOmZ5Jo4FLnm5/Hs3wRaExoMgNDNr9TOgKrdpIdcuwjC37VE14ybVu5VJ7DQpJtGEyCMZxQ2+4GV5NzdDvR2H4ZmJbrmZ3CueoHWkGaD4CPw8Y3NOVC2m5xNck29B2xeOSvn0xOogTRMcvM5z7aUIsWZ5VzrLnU/fJ66QBtA46Xc/E79AvjLTWrLuTZofStd6Zuug54AzeXmJAjjBYVtdpY8yTXdrdg166uV+7UTaIMYMgQ+AR9yc7SA8B1SZ4fsfjUrfWovUAQZ1ANuglKhM6n9R5te9RFoLjBwGIRuUsrXhu1cWit96ytQxBkqN28BC+WpueZfHPrWX6ARYPhBwfa1WBsqsBaCwp6hwMTPZMKLse5bAmN1zni3HLRXIta15WCszhnvloP2SsS6thyM1Tnj3XLQXolYVzm46Mg3g6New6I2M07gVpfHmnoNMxL43ikZdXmsqdfwTn8RzaJkyqm5Rn4FfHC1GFL9qf08OOnIZvMfyCKyab/KZb+Q+grUPac89lRapKmt6CN1nDxB7RBomq9T/gb9K0lQ38SgeAAAAABJRU5ErkJggg==", Mi = ({
  ...e
}) => {
  var t;
  const n = Dt();
  return /* @__PURE__ */ u.createElement(Ql, Nn({}, e, {
    src: (n == null || (t = n.newsletterIcon) === null || t === void 0 ? void 0 : t.icon) === "black" ? Zl : ql,
    "data-qa": "newsletter-icon"
  }));
};
Mi.displayName = "NewsletterIcon";
const sr = /* @__PURE__ */ T("div", {
  target: "e4lcx306"
})({
  name: "1xbksb9",
  styles: "display:flex;flex-flow:row;justify-content:space-between;align-items:center;margin-block:16px;margin-inline:0"
}), je = /* @__PURE__ */ T("div", {
  target: "e4lcx305"
})("color:#000000;font-size:18px;font-family:", le, ";line-height:23px;", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.findOutMore) === null || t === void 0 ? void 0 : t.titleFontStyle) {
    case "large":
      return `
          font-size: 21px;
          line-height: 27px;
        `;
  }
}, ";"), lr = /* @__PURE__ */ T(Mi, {
  target: "e4lcx304"
})({
  name: "wb048k",
  styles: "inline-size:28px;block-size:24px"
}), Xt = /* @__PURE__ */ T("a", {
  target: "e4lcx303"
})(""), cr = /* @__PURE__ */ T("div", {
  target: "e4lcx302"
})(Xt, "{display:inline-block;inline-size:auto;color:#4585ff;font-size:14px;font-family:", W, ";line-height:16px;text-decoration:underline;cursor:pointer;}"), xi = /* @__PURE__ */ T("div", {
  target: "e4lcx301"
})({
  name: "ip6zvp",
  styles: "inline-size:60px;block-size:1px;margin-block-end:28px;background-color:#001246"
}), Ye = /* @__PURE__ */ T("div", {
  target: "e4lcx300"
})('display:grid;grid-template-areas:"SummaryLine" "Icon" "Message" "Button";justify-items:center;text-align:center;', lr, "{grid-area:Icon;}", cr, "{grid-area:Button;}", sr, "{grid-area:Message;}", xi, "{grid-area:SummaryLine;}");
function On() {
  return On = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, On.apply(null, arguments);
}
const Ui = ({
  ...e
}) => {
  const {
    handleRoutePush: t,
    handleTrackGA4: n
  } = re(), {
    campaignName: r,
    findOutMoreButtonDisplayComponent: i,
    variant: a
  } = me(), s = Dt();
  return /* @__PURE__ */ u.createElement(Ye, On({}, e, {
    "data-qa": "find-out-more"
  }), (s == null ? void 0 : s.hasSummaryLine) && /* @__PURE__ */ u.createElement(xi, null), /* @__PURE__ */ u.createElement(lr, null), /* @__PURE__ */ u.createElement(sr, null, /* @__PURE__ */ u.createElement(je, null, "Sign up for our Newsletters")), /* @__PURE__ */ u.createElement(cr, null, /* @__PURE__ */ u.createElement(Xt, {
    href: "/newsletters",
    onClick: (l) => {
      l.preventDefault(), n({
        action: "click",
        category: "nl",
        customized_parameters: {
          internal_campaign: r ?? "",
          trigger_point: Ne(a)
        },
        subcategory: "entry"
      }), t("/newsletters");
    }
  }, i ?? "Find out more")));
};
Ui.displayName = "FindOutMore";
var ur = {}, Fi = { exports: {} };
/*! js-cookie v3.0.5 | MIT */
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(gn, function() {
    function n(s) {
      for (var l = 1; l < arguments.length; l++) {
        var c = arguments[l];
        for (var E in c)
          s[E] = c[E];
      }
      return s;
    }
    var r = {
      read: function(s) {
        return s[0] === '"' && (s = s.slice(1, -1)), s.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
      },
      write: function(s) {
        return encodeURIComponent(s).replace(
          /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
          decodeURIComponent
        );
      }
    };
    function i(s, l) {
      function c(p, d, _) {
        if (!(typeof document > "u")) {
          _ = n({}, l, _), typeof _.expires == "number" && (_.expires = new Date(Date.now() + _.expires * 864e5)), _.expires && (_.expires = _.expires.toUTCString()), p = encodeURIComponent(p).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
          var f = "";
          for (var A in _)
            _[A] && (f += "; " + A, _[A] !== !0 && (f += "=" + _[A].split(";")[0]));
          return document.cookie = p + "=" + s.write(d, p) + f;
        }
      }
      function E(p) {
        if (!(typeof document > "u" || arguments.length && !p)) {
          for (var d = document.cookie ? document.cookie.split("; ") : [], _ = {}, f = 0; f < d.length; f++) {
            var A = d[f].split("="), g = A.slice(1).join("=");
            try {
              var b = decodeURIComponent(A[0]);
              if (_[b] = s.read(g, b), p === b)
                break;
            } catch {
            }
          }
          return p ? _[p] : _;
        }
      }
      return Object.create(
        {
          set: c,
          get: E,
          remove: function(p, d) {
            c(
              p,
              "",
              n({}, d, {
                expires: -1
              })
            );
          },
          withAttributes: function(p) {
            return i(this.converter, n({}, this.attributes, p));
          },
          withConverter: function(p) {
            return i(n({}, this.converter, p), this.attributes);
          }
        },
        {
          attributes: { value: Object.freeze(l) },
          converter: { value: Object.freeze(s) }
        }
      );
    }
    var a = i(r, { path: "/" });
    return a;
  });
})(Fi);
var $l = Fi.exports, Kt = {};
Object.defineProperty(Kt, "__esModule", { value: !0 });
Kt.useFirstMountState = void 0;
const Jr = u;
function ec() {
  const e = (0, Jr.useRef)(!0);
  return (0, Jr.useEffect)(() => {
    e.current = !1;
  }, []), e.current;
}
Kt.useFirstMountState = ec;
var Jt = {};
Object.defineProperty(Jt, "__esModule", { value: !0 });
Jt.useMountEffect = void 0;
const tc = u;
function nc(e) {
  (0, tc.useEffect)(() => {
    e();
  }, []);
}
Jt.useMountEffect = nc;
var Qt = {};
Object.defineProperty(Qt, "__esModule", { value: !0 });
Qt.useSyncedRef = void 0;
const Qr = u;
function rc(e) {
  const t = (0, Qr.useRef)(e);
  return t.current = e, (0, Qr.useMemo)(() => Object.freeze({
    get current() {
      return t.current;
    }
  }), []);
}
Qt.useSyncedRef = rc;
var oe = {};
Object.defineProperty(oe, "__esModule", { value: !0 });
oe.truthyOrArrayPredicate = oe.truthyAndArrayPredicate = oe.isStrictEqual = oe.isBrowser = oe.noop = void 0;
const ic = () => {
};
oe.noop = ic;
oe.isBrowser = typeof window < "u" && typeof navigator < "u" && typeof document < "u";
const ac = (e, t) => e === t;
oe.isStrictEqual = ac;
const oc = (e) => e.every(Boolean);
oe.truthyAndArrayPredicate = oc;
const sc = (e) => e.some(Boolean);
oe.truthyOrArrayPredicate = sc;
var lc = gn && gn.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ur, "__esModule", { value: !0 });
var _r = ur.useCookieValue = void 0;
const mn = lc($l), ot = u, cc = Kt, uc = Jt, _c = Qt, dc = oe, gt = /* @__PURE__ */ new Map(), pc = (e, t) => {
  let n = gt.get(e);
  n || (n = /* @__PURE__ */ new Set(), gt.set(e, n)), n.add(t);
}, mc = (e, t) => {
  const n = gt.get(e);
  n && (n.delete(t), n.size || gt.delete(e));
}, En = (e, t, n) => {
  const r = gt.get(e);
  r && r.forEach((i) => {
    i !== n && i(t);
  });
};
function Ec(e, t = {}) {
  let { initializeWithValue: n = !0, ...r } = t;
  dc.isBrowser || (n = !1);
  const i = (0, _c.useSyncedRef)({
    set(c) {
      l(c), mn.default.set(e, c, r), En(e, c, l);
    },
    remove() {
      l(null), mn.default.remove(e, r), En(e, null, l);
    },
    fetchVal: () => mn.default.get(e) ?? null,
    fetch() {
      const c = i.current.fetchVal();
      l(c), En(e, c, l);
    }
  }), a = (0, cc.useFirstMountState)(), [s, l] = (0, ot.useState)(a && n ? i.current.fetchVal() : void 0);
  return (0, uc.useMountEffect)(() => {
    n || i.current.fetch();
  }), (0, ot.useEffect)(() => (pc(e, l), () => {
    mc(e, l);
  }), [e]), [
    s,
    (0, ot.useCallback)((c) => {
      i.current.set(c);
    }, []),
    (0, ot.useCallback)(() => {
      i.current.remove();
    }, []),
    (0, ot.useCallback)(() => {
      i.current.fetch();
    }, [])
  ];
}
_r = ur.useCookieValue = Ec;
const fc = "Please enter a valid email address", gc = "There was a problem. Please try again", fn = "";
function Ac(e) {
  return /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/.test(e);
}
const Tc = /* @__PURE__ */ T("span", {
  target: "ek9223x1"
})({
  name: "34b66o",
  styles: '::after{content:"";display:inline-block;animation:dotty steps(1, end) 2s infinite;}@keyframes dotty{0%{content:"";}25%{content:".";}50%{content:"..";}75%{content:"...";}100%{content:"";}}'
});
var Ic = {
  name: "c0yhd0",
  styles: "min-inline-size:82px"
}, Sc = {
  name: "1nw19os",
  styles: "min-inline-size:244px"
};
const Me = /* @__PURE__ */ T("button", {
  target: "ek9223x0"
})("block-size:35px;min-inline-size:86px;color:#ffffff;font-size:14px;line-height:16px;border:0;border-radius:2px;background-color:#4585ff;cursor:pointer;", (e) => {
  switch (e.$buttonSize) {
    case "large":
      return Sc;
    case "small":
      return Ic;
  }
}, ";");
function vn() {
  return vn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vn.apply(null, arguments);
}
const dr = ({
  children: e,
  isLoading: t,
  onClick: n,
  size: r = "medium",
  ...i
}) => {
  const a = (s) => {
    t || n(s);
  };
  return /* @__PURE__ */ u.createElement(Me, vn({}, i, {
    $buttonSize: r,
    onClick: a,
    "data-qa": "sign-up-button"
  }), t ? /* @__PURE__ */ u.createElement(Tc, null, "SENDING") : /* @__PURE__ */ u.createElement("span", null, e));
};
dr.displayName = "SignUpButton";
const hc = (e) => /* @__PURE__ */ N.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 17, viewBox: "0 0 17 17", ...e }, /* @__PURE__ */ N.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ N.createElement("path", { d: "M21-4H-3v24h24z" }), /* @__PURE__ */ N.createElement("path", { d: "M17 8.177H.875m8-8l-8 8 8 8", stroke: "#FEFEFE" }))), et = /* @__PURE__ */ T(hc, {
  target: "e1kldszr7"
})({
  name: "gz16y9",
  styles: "path{stroke:#4585ff;}"
}), Cc = /* @__PURE__ */ T("div", {
  target: "e1kldszr6"
})({
  name: "ebvuqd",
  styles: "display:flex;flex-flow:row;justify-content:stretch;align-items:center;margin-inline-end:12px;cursor:pointer"
}), Gi = /* @__PURE__ */ T("input", {
  target: "e1kldszr5"
})("inline-size:100%;block-size:35px;padding-inline-start:10px;color:#000000;font-size:16px;font-family:", W, ";border:1px solid #d7d7d7;border-color:", (e) => e.$isError ? "#eb4254" : "#d7d7d7", ";border-radius:2px;&::placeholder{color:#999999;}"), Rc = /* @__PURE__ */ T("div", {
  target: "e1kldszr4"
})("margin-block:2px 0;margin-inline:2px 0;color:#eb4254;font-size:10px;font-family:", W, ";line-height:11px;"), bc = /* @__PURE__ */ T("div", {
  target: "e1kldszr3"
})({
  name: "1ckj6g",
  styles: "margin-inline-end:8px"
}), yc = /* @__PURE__ */ T("form", {
  target: "e1kldszr2"
})({
  name: "zjik7",
  styles: "display:flex"
}), Nc = /* @__PURE__ */ T("div", {
  target: "e1kldszr1"
})({
  name: "zjik7",
  styles: "display:flex"
}), Zt = /* @__PURE__ */ T(dr, {
  target: "e1kldszr0"
})("");
function wn() {
  return wn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wn.apply(null, arguments);
}
const Vi = ({
  onPreviousClick: e,
  onSubmit: t,
  ...n
}) => {
  const [r, i] = Se(""), [a, s] = Se(fn), [l, c] = Se(!1), {
    executeRecaptcha: E
  } = Da(), p = async () => {
    if (!Ac(r)) {
      s(fc);
      return;
    }
    c(!0);
    const d = await (E == null ? void 0 : E());
    if (!d) return;
    s(fn);
    const _ = await t({
      email: r,
      recaptchaToken: d
    });
    _ != null && _.error && (s(gc), c(!1));
  };
  return /* @__PURE__ */ u.createElement(Nc, wn({}, n, {
    "data-qa": "email-form"
  }), /* @__PURE__ */ u.createElement(Cc, null, /* @__PURE__ */ u.createElement(et, {
    height: "15",
    onClick: e,
    width: "15"
  })), /* @__PURE__ */ u.createElement(yc, {
    method: "post",
    onSubmit: (d) => {
      d.preventDefault(), p();
    }
  }, /* @__PURE__ */ u.createElement(bc, null, /* @__PURE__ */ u.createElement(Gi, {
    $isError: !!a,
    onChange: (d) => {
      d.target.value || s(fn), i(d.target.value);
    },
    placeholder: "Email",
    value: r
  }), a && /* @__PURE__ */ u.createElement(Rc, null, a)), /* @__PURE__ */ u.createElement(Zt, {
    isLoading: l,
    onClick: (d) => {
      d.preventDefault(), p();
    }
  }, "SIGN UP")));
};
Vi.displayName = "EmailForm";
let K = /* @__PURE__ */ function(e) {
  return e.EmailForm = "email-form", e.OverlaySignUpButton = "overlay-sign-up-button", e.SignUpButton = "sign-up-button", e.SocialButtons = "social-buttons", e;
}({}), Pn = /* @__PURE__ */ function(e) {
  return e.Email = "email", e.Facebook = "facebook", e.Google = "google", e;
}({});
const Oc = () => {
  const {
    config: e
  } = re();
  return {
    getSocialLoginUrl: (n, r, i) => {
      const a = new URL(e.accounts.host), s = new URL(location.href);
      s.search = Nr.stringify(r);
      const {
        triggerPoint: l,
        ...c
      } = r, E = new URL(location.href);
      return E.search = Nr.stringify(c), a.searchParams.set("callback", E.toString()), a.searchParams.set("destination", s.toString()), a.searchParams.set("nonce", ""), a.searchParams.set("optIn", i ? "true" : "false"), a.searchParams.set("triggerPoint", l), a.pathname = `/login/${n}`, a.toString();
    }
  };
}, vc = (e) => /* @__PURE__ */ N.createElement("svg", { width: 22, height: 19, viewBox: "0 0 22 19", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ N.createElement("path", { d: "M22 7.548v9.1c0 1.15-.99 2.09-2.2 2.09H2.2c-1.21 0-2.2-.94-2.2-2.09l.007-9.1 11.026 4.635L22 7.548zM19.8.738c1.21 0 2.2.94 2.2 2.089v3.332l-10.968 4.669L.008 6.16l.003-3.333c0-1.1.896-2.007 2.033-2.084L2.2.738z", fill: "#AAA" })), wc = (e) => /* @__PURE__ */ N.createElement("svg", { width: 22, height: 23, viewBox: "0 0 22 23", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ N.createElement("path", { d: "M22 11.805C22 5.692 17.075.738 11 .738S0 5.692 0 11.805c0 5.524 4.023 10.102 9.281 10.933v-7.734H6.488v-3.2h2.793V9.367c0-2.773 1.642-4.305 4.155-4.305 1.204 0 2.462.216 2.462.216V8h-1.387c-1.366 0-1.792.853-1.792 1.729v2.076h3.05l-.487 3.199h-2.563v7.734c5.258-.83 9.281-5.41 9.281-10.933", fill: "#1977F2", fillRule: "evenodd" })), Pc = (e) => /* @__PURE__ */ N.createElement("svg", { width: 22, height: 23, viewBox: "0 0 22 23", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ N.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ N.createElement("path", { d: "M21.168 11.783c0-.766-.069-1.502-.196-2.21H10.8v4.179h5.812a4.968 4.968 0 0 1-2.155 3.26v2.709h3.49c2.043-1.88 3.221-4.649 3.221-7.938z", fill: "#4285F4", fillRule: "nonzero" }), /* @__PURE__ */ N.createElement("path", { d: "M10.8 22.338c2.916 0 5.36-.968 7.148-2.617l-3.49-2.71c-.968.648-2.205 1.031-3.658 1.031-2.813 0-5.194-1.9-6.043-4.452H1.149v2.798a10.796 10.796 0 0 0 9.651 5.95z", fill: "#34A853", fillRule: "nonzero" }), /* @__PURE__ */ N.createElement("path", { d: "M4.757 13.59a6.492 6.492 0 0 1-.339-2.052c0-.712.123-1.404.339-2.052V6.687H1.149A10.796 10.796 0 0 0 0 11.537c0 1.743.417 3.393 1.149 4.85l3.608-2.797z", fill: "#FBBC05", fillRule: "nonzero" }), /* @__PURE__ */ N.createElement("path", { d: "M10.8 5.033c1.586 0 3.01.545 4.129 1.615l3.097-3.098C16.156 1.808 13.711.738 10.8.738c-4.222 0-7.874 2.42-9.651 5.95l3.608 2.798c.85-2.553 3.23-4.453 6.043-4.453z", fill: "#EA4335", fillRule: "nonzero" }), /* @__PURE__ */ N.createElement("path", { d: "M0 .738h21.6v21.6H0z" }))), se = /* @__PURE__ */ T("div", {
  target: "e1uwm9yr1"
})({
  name: "1qitn38",
  styles: "display:flex;flex-flow:row;justify-content:center;align-items:center;inline-size:52px;block-size:35px;margin-inline-end:12px;box-sizing:border-box;border:1px solid #d7d7d7;border-radius:2px;background:#000000;cursor:pointer"
}), pr = /* @__PURE__ */ T("div", {
  target: "e1uwm9yr0"
})({
  name: "1nb6kt7",
  styles: "display:flex;flex-flow:row;justify-content:flex-start;align-items:center"
});
function Ln() {
  return Ln = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ln.apply(null, arguments);
}
const ji = ({
  isAgreedReceiveMarketing: e,
  onEmailClick: t,
  ...n
}) => {
  const {
    campaignName: r,
    dataMatrix: i,
    newsletterItems: a,
    queryParametersForSocialButtons: s,
    variant: l
  } = me(), {
    getSocialLoginUrl: c
  } = Oc(), {
    handleRoutePush: E,
    handleTrackGA4: p
  } = re(), {
    set: d
  } = Bt(Wl), {
    set: _
  } = Bt(ki), f = (g) => {
    var b, I;
    d(a), _(i), p({
      action: "click",
      category: "nl",
      customized_parameters: {
        method: g,
        newsletter_name: (b = a[0].name) !== null && b !== void 0 ? b : "",
        trigger_point: Ne(l)
      },
      subcategory: "sign_up"
    });
    const v = a.filter((C) => C.entityId).map((C) => C.entityId);
    E(c(g, {
      campaignName: r,
      newsletterIds: v,
      newsletterName: (I = a[0].name) !== null && I !== void 0 ? I : "",
      subscription: "true",
      triggerPoint: Ne(l),
      variant: l
    }, e), {
      query: s
    });
  }, A = Fe(() => va(), []);
  return /* @__PURE__ */ u.createElement(pr, Ln({}, n, {
    "data-qa": "social-buttons"
  }), /* @__PURE__ */ u.createElement(se, {
    onClick: () => f(Pn.Facebook)
  }, /* @__PURE__ */ u.createElement(wc, {
    height: "100%",
    width: "22"
  })), !A && /* @__PURE__ */ u.createElement(se, {
    onClick: () => f(Pn.Google)
  }, /* @__PURE__ */ u.createElement(Pc, {
    height: "100%",
    width: "22"
  })), /* @__PURE__ */ u.createElement(se, {
    onClick: t
  }, /* @__PURE__ */ u.createElement(vc, {
    height: "100%",
    width: "22"
  })));
};
ji.displayName = "SocialButtons";
const Yi = /* @__PURE__ */ T(dr, {
  target: "e1e053fq14"
})(""), mr = /* @__PURE__ */ T("div", {
  target: "e1e053fq13"
})({
  name: "e0dnmk",
  styles: "cursor:pointer"
}), De = /* @__PURE__ */ T("div", {
  target: "e1e053fq12"
})("max-inline-size:254px;margin-inline-end:8px;color:#666666;font-size:11px;font-family:", W, ";line-height:13px;"), At = /* @__PURE__ */ T("div", {
  target: "e1e053fq11"
})("grid-area:Agreement;display:flex;margin-block-end:12px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block-end:", (e) => {
  var t;
  return ((t = e.theme) === null || t === void 0 ? void 0 : t.orientation) === "landscape" ? "0" : "12px";
}, ";}:empty{margin-block-end:0;}"), Lc = /* @__PURE__ */ T("div", {
  target: "e1e053fq10"
})({
  name: "1501yv5",
  styles: "grid-area:Description;margin-block:4px 10px"
}), Bc = /* @__PURE__ */ T("div", {
  target: "e1e053fq9"
})("font-size:14px;font-family:", le, ";line-height:19px;"), qt = /* @__PURE__ */ T("div", {
  target: "e1e053fq8"
})({
  name: "110j674",
  styles: "grid-area:Summary;margin-block-end:4px"
});
var kc = {
  name: "1b6c22i",
  styles: "font-size:11px;line-height:13px"
};
const $t = /* @__PURE__ */ T("div", {
  target: "e1e053fq7"
})("color:#222222;font-size:12px;font-family:", W, ";line-height:14px;text-align:center;text-transform:uppercase;", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.signUpNewsletter) === null || t === void 0 ? void 0 : t.summaryFontStyle) {
    case "small":
      return kc;
  }
}, ";");
var Dc = {
  name: "1vu3ru",
  styles: "font-size:15px;line-height:19px"
}, Mc = {
  name: "11tjyy3",
  styles: "font-size:21px;line-height:27px"
}, xc = {
  name: "wh4tv7",
  styles: "font-weight:300;font-size:21px;font-style:italic;line-height:27px"
};
const pe = /* @__PURE__ */ T("div", {
  target: "e1e053fq6"
})("color:#000000;font-size:18px;font-family:", le, ";line-height:23px;", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.signUpNewsletter) === null || t === void 0 ? void 0 : t.titleFontStyle) {
    case "italic-large":
      return xc;
    case "large":
      return Mc;
    case "small":
      return Dc;
  }
}, ";"), Tt = /* @__PURE__ */ T("div", {
  target: "e1e053fq5"
})({
  name: "1wl4b09",
  styles: "grid-area:Title;margin-block-end:8px"
}), $e = /* @__PURE__ */ T("div", {
  target: "e1e053fq4"
})({
  name: "cfcqlx",
  styles: "grid-area:Action;margin-block-end:10px"
}), It = /* @__PURE__ */ T("a", {
  target: "e1e053fq3"
})({
  name: "4dv4e3",
  styles: "margin-block:0;margin-inline:2px"
}), en = /* @__PURE__ */ T("div", {
  target: "e1e053fq2"
})("grid-area:TermAndCondition;color:#999999;font-size:10px;font-family:", W, ";line-height:11px;", It, "{color:#999999;text-decoration:underline;}"), Uc = /* @__PURE__ */ T("div", {
  target: "e1e053fq1"
})({
  name: "10rfpyb",
  styles: "grid-area:SummaryLine;inline-size:60px;block-size:1px;margin-block-end:16px;background-color:#001246"
});
var Fc = {
  name: "1y77c6w",
  styles: 'grid-template-areas:"SummaryLine" "Summary" "Title" "Description" "Agreement" "Action" "TermAndCondition";justify-items:center;text-align:center'
}, Gc = {
  name: "1wz5quw",
  styles: 'grid-template-areas:"SummaryLine Action" "Summary Action" "Title Action" "Description Action" "Agreement TermAndCondition";grid-template-rows:repeat(5, minmax(0, min-content));justify-items:center;text-align:center;column-gap:20px'
};
const ce = /* @__PURE__ */ T("div", {
  target: "e1e053fq0"
})('display:grid;grid-template-areas:"SummaryLine" "Summary" "Title" "Description" "Agreement" "Action" "TermAndCondition";grid-template-rows:repeat(7, minmax(0, min-content));justify-items:center;color:#ffffff;text-align:center;', (e) => e.theme.breakpoints.up("tablet"), "{", (e) => {
  var t;
  return ((t = e.theme) === null || t === void 0 ? void 0 : t.orientation) === "landscape" ? Gc : Fc;
}, ";}"), Vc = () => {
  const {
    campaignName: e,
    dataMatrix: t,
    newsletterItems: n,
    variant: r
  } = me(), {
    config: i,
    handleRegisterMixPanel: a,
    handleTrackGA4: s,
    handleTrackGTM: l,
    handleTrackMirror: c,
    handleTrackMixPanel: E,
    user: p
  } = re(), {
    handleSignUpNewsletter: d
  } = Di(), {
    createUser: _
  } = ba(i.accounts.host), [f] = _r("scmp_user_login_type"), A = qe(p == null ? void 0 : p.useremail), g = (v) => {
    var C, S, h, y;
    if (!A) return;
    const O = {
      [L.AcquisitionNewsletterPopup]: {
        format: "In-line",
        location: ""
      },
      [L.Article]: {
        format: "In-line",
        location: ""
      },
      [L.Article20]: {
        format: "In-line",
        location: ""
      },
      [L.ArticleDark]: {
        format: "In-line",
        location: ""
      },
      [L.Footer]: {
        format: "In-line",
        location: ""
      },
      [L.Homepage]: {
        format: "In-line",
        location: "Homepage"
      },
      [L.LiveArticle]: {
        format: "In-line",
        location: "Article"
      },
      [L.NewsletterArticle]: {
        format: "Sticky widget",
        location: "Newsletter Article"
      },
      [L.NewsletterArticleBottom]: {
        format: "Sticky widget",
        location: "Newsletter Article"
      },
      [L.NewsletterList]: {
        format: "NL List",
        location: "Newsletter Index"
      },
      [L.Posties]: {
        format: "In-line",
        location: ""
      },
      [L.Section]: {
        format: "In-line",
        location: "Section Index"
      }
    }, w = {
      Location: (C = (S = O[r]) === null || S === void 0 ? void 0 : S.location) !== null && C !== void 0 ? C : "",
      "Newsletters Signed-up": v,
      "Sign-up Format": (h = (y = O[r]) === null || y === void 0 ? void 0 : y.format) !== null && h !== void 0 ? h : "In-line"
    };
    a(w), E({
      name: "Newsletters Signed-up",
      property: w
    });
  }, b = async (v) => {
    var C, S, h;
    if ((n == null ? void 0 : n.length) === 0) return {
      error: !0
    };
    const y = await d(n.map((O) => O.entityId), v, t);
    return (C = y.errors) !== null && C !== void 0 && C.length ? {
      error: !0
    } : (n.forEach((O, w) => {
      (() => {
        var o;
        if (r === L.AcquisitionNewsletterPopup) {
          var R;
          if (w > 0 || !e) return;
          s({
            action: "sys",
            category: "nl",
            customized_parameters: {
              internal_campaign: e ?? "",
              method: A ? (R = f == null ? void 0 : f.toLowerCase()) !== null && R !== void 0 ? R : "" : "email",
              newsletter_name: O.name,
              trigger_point: "ppto"
            },
            subcategory: "sign_up"
          });
          return;
        }
        s({
          action: "sys",
          category: "nl",
          customized_parameters: {
            internal_campaign: e ?? "",
            method: A ? (o = f == null ? void 0 : f.toLowerCase()) !== null && o !== void 0 ? o : "" : "email",
            newsletter_name: O.name,
            trigger_point: Ne(r)
          },
          subcategory: "sign_up"
        });
      })(), c({
        event_name: "newsletter_sign_up",
        newsletter_subscribe: O.name
      }), l({
        event: "newsletter-subscribe",
        "newsletter-id": O.entityId,
        "newsletter-name": O.name
      }), g(O.name);
    }), {
      error: !1,
      result: {
        uid: (S = (h = y.entity) === null || h === void 0 || (h = h.uid) === null || h === void 0 || (h = h.entity) === null || h === void 0 ? void 0 : h.uid) !== null && S !== void 0 ? S : ""
      }
    });
  };
  return {
    handleSubmit: b,
    handleSubmitWithEmail: async (v, C, S) => {
      try {
        var h;
        const y = await b(v);
        if (y.error) return y;
        (h = y.result) !== null && h !== void 0 && h.uid || (await _({
          newsletterId: JSON.stringify(n.map((O) => O.entityId)),
          newsletterName: JSON.stringify(n.map((O) => O.name)),
          optIn: S ? 1 : 0,
          recaptchaToken: C,
          recaptchaVersion: "v3",
          username: v
        }), s({
          action: "sys",
          category: "login",
          customized_parameters: {
            internal_campaign: e ?? "",
            method: "email",
            result: "register_success",
            trigger_point: "ppto"
          },
          subcategory: "result"
        }));
      } catch {
        return {
          error: !0
        };
      }
      return {
        error: !1
      };
    }
  };
}, Hi = ({
  isAgreedReceiveMarketing: e,
  isDisableSignupButtonMouseOver: t,
  isShowOverlaySignUp: n,
  onSuccess: r
}) => {
  const {
    handleTrackGA4: i,
    user: a
  } = re(), {
    campaignName: s,
    newsletterItemForDisplay: l,
    newsletterItems: c,
    setLastSubscribedNewsletter: E,
    signUpButtonDisplayComponent: p,
    variant: d
  } = me(), _ = qe(a == null ? void 0 : a.useremail), [f] = _r("scmp_user_login_type"), [A, g] = Se(() => _ ? K.SignUpButton : n ? K.OverlaySignUpButton : K.SocialButtons), [b, I] = Se(!1), v = async () => {
    if ((() => {
      var w;
      if (d !== L.AcquisitionNewsletterPopup || !s) {
        var k, o;
        i({
          action: "click",
          category: "nl",
          customized_parameters: {
            method: _ ? (k = f == null ? void 0 : f.toLowerCase()) !== null && k !== void 0 ? k : "" : "email",
            newsletter_name: (o = c[0].name) !== null && o !== void 0 ? o : "",
            trigger_point: Ne(d)
          },
          subcategory: "sign_up"
        });
        return;
      }
      i({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          internal_campaign: s,
          message: (w = p == null ? void 0 : p.toString()) !== null && w !== void 0 ? w : "SIGN UP NOW",
          step: "1"
        },
        subcategory: ""
      });
    })(), A === K.OverlaySignUpButton)
      g(K.SocialButtons);
    else if (_ && a !== null && a !== void 0 && a.useremail) {
      I(!0);
      const {
        error: w
      } = await S(a.useremail);
      l && (E == null || E(l.name)), !w && r();
    }
  }, C = () => {
    t || A !== K.OverlaySignUpButton || g(K.SocialButtons);
  }, {
    handleSubmit: S,
    handleSubmitWithEmail: h
  } = Vc();
  return {
    actionComponent: A,
    handleRenderActionComponent: () => {
      switch (A) {
        case K.EmailForm:
          return /* @__PURE__ */ u.createElement(Vi, {
            onPreviousClick: () => g(K.SocialButtons),
            onSubmit: async ({
              email: O,
              recaptchaToken: w
            }) => {
              var k;
              i({
                action: "click",
                category: "nl",
                customized_parameters: {
                  method: Pn.Email,
                  newsletter_name: (k = c[0].name) !== null && k !== void 0 ? k : "",
                  trigger_point: Ne(d)
                },
                subcategory: "sign_up"
              });
              const o = await h(O, w, e);
              return !o.error && r(), o;
            }
          });
        case K.SocialButtons:
          return /* @__PURE__ */ u.createElement(ji, {
            isAgreedReceiveMarketing: e,
            onEmailClick: () => {
              g(K.EmailForm);
            }
          });
        default:
          return /* @__PURE__ */ u.createElement(Yi, {
            isLoading: b,
            onClick: () => void v(),
            onMouseOver: C,
            size: "large"
          }, p ?? "SIGN UP NOW");
      }
    }
  };
}, jc = (e) => /* @__PURE__ */ N.createElement("svg", { width: "18px", height: "18px", viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ N.createElement("title", null, "6D08B3E1-4507-43DB-B459-BF91FB343A6F"), /* @__PURE__ */ N.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ N.createElement("g", { id: "email_footer_3", transform: "translate(-297.000000, -361.000000)" }, /* @__PURE__ */ N.createElement("g", { id: "email_footer3", transform: "translate(32.000000, 301.000000)" }, /* @__PURE__ */ N.createElement("g", { id: "Tick", transform: "translate(0.000000, 56.000000)" }, /* @__PURE__ */ N.createElement("g", { id: "checkbox_checked", transform: "translate(265.000000, 4.000000)" }, /* @__PURE__ */ N.createElement("path", { d: "M16,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 L16,0 L16,0 Z", id: "Shape", fill: "#484848" }), /* @__PURE__ */ N.createElement("polygon", { id: "Path", fill: "#000000", points: "17 1 17 17 1 17 1 1" }), /* @__PURE__ */ N.createElement("path", { d: "M6.69230769,12.1145318 L6.69584957,12.1111217 L6.69230769,12.1145318 Z M14.3322932,5 L15,5.62497311 L7.44005099,12.6985528 L7.10176706,13 L3,9.16213131 L3.66769707,8.53714907 L7.1099159,11.7579034 L14.3322932,5 Z", id: "icon_signedup_tick", fill: "#FFFFFF", fillRule: "nonzero" }))))))), zi = (e) => /* @__PURE__ */ N.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ N.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ N.createElement("path", { d: "M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z", fill: "#4585FF" }), /* @__PURE__ */ N.createElement("path", { fill: "#4585FF", d: "M17 1v16H1V1z" }), /* @__PURE__ */ N.createElement("path", { d: "M6.692 12.115l.004-.004-.004.004zM14.332 5l.668.625-7.56 7.074-.338.301L3 9.162l.668-.625 3.442 3.22L14.332 5z", fill: "#FFF", fillRule: "nonzero" }))), Wi = (e) => /* @__PURE__ */ N.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ N.createElement("path", { d: "M17 1v16H1V1h16zm-1-1H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z", fill: "#CCC", fillRule: "evenodd" }));
function Bn() {
  return Bn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bn.apply(null, arguments);
}
const Xi = ({
  isDisableSignupButtonMouseOver: e = !1,
  isShowOverlaySignUp: t = !1,
  onSuccess: n,
  ...r
}) => {
  var i, a, s, l;
  const {
    handleRoutePush: c,
    handleTrackGA4: E,
    user: p
  } = re(), d = qe(p == null ? void 0 : p.useremail), _ = Dt(), [f, A] = ti(!1), {
    campaignName: g,
    newsletterItemForDisplay: b,
    summaryComponent: I,
    titleComponent: v
  } = me(), C = () => {
    if (f) {
      var O;
      return (_ == null || (O = _.signUpNewsletter) === null || O === void 0 ? void 0 : O.checkboxStyle) === "black" ? /* @__PURE__ */ u.createElement(jc, null) : /* @__PURE__ */ u.createElement(zi, null);
    }
    return /* @__PURE__ */ u.createElement(Wi, {
      "data-qa": "render-checkbox"
    });
  }, {
    actionComponent: S,
    handleRenderActionComponent: h
  } = Hi({
    isAgreedReceiveMarketing: f,
    isDisableSignupButtonMouseOver: e,
    isShowOverlaySignUp: t,
    onSuccess: n
  }), y = Jl(b);
  return /* @__PURE__ */ u.createElement(ce, Bn({}, r, {
    "data-qa": "sign-up-newsletter"
  }), (_ == null ? void 0 : _.hasSummaryLine) && /* @__PURE__ */ u.createElement(Uc, null), (_ == null || (i = _.signUpNewsletter) === null || i === void 0 ? void 0 : i.hasSummary) && /* @__PURE__ */ u.createElement(qt, null, /* @__PURE__ */ u.createElement($t, null, I ?? (b == null || (a = b.summary) === null || a === void 0 ? void 0 : a.text))), (_ == null ? void 0 : _.hasTitle) && y && /* @__PURE__ */ u.createElement(Tt, null, /* @__PURE__ */ u.createElement(pe, null, v ?? y)), (_ == null || (s = _.signUpNewsletter) === null || s === void 0 ? void 0 : s.hasDescription) && /* @__PURE__ */ u.createElement(Lc, null, /* @__PURE__ */ u.createElement(Bc, null, b == null || (l = b.description) === null || l === void 0 ? void 0 : l.text)), !d && /* @__PURE__ */ u.createElement(At, null, /* @__PURE__ */ u.createElement(De, null, "By submitting, you consent to receiving marketing emails from SCMP. If you don't want these, tick here"), /* @__PURE__ */ u.createElement(mr, {
    onClick: A
  }, C())), /* @__PURE__ */ u.createElement(ct, {
    mode: "out-in"
  }, /* @__PURE__ */ u.createElement(_t, {
    key: S,
    timeout: 500
  }, /* @__PURE__ */ u.createElement($e, null, h()))), /* @__PURE__ */ u.createElement(en, null, "By registering, you agree to our", /* @__PURE__ */ u.createElement(It, {
    href: "/terms-conditions",
    onClick: (O) => {
      O.preventDefault(), E({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/terms-conditions",
          internal_campaign: g ?? "",
          message: "T&C",
          step: "1"
        },
        subcategory: ""
      }), c("/terms-conditions");
    }
  }, "T&C"), "and", /* @__PURE__ */ u.createElement(It, {
    href: "/privacy-policy",
    onClick: (O) => {
      O.preventDefault(), E({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/privacy-policy",
          internal_campaign: g ?? "",
          message: "Privacy Policy",
          step: "1"
        },
        subcategory: ""
      }), c("/privacy-policy");
    }
  }, "Privacy Policy")));
};
Xi.displayName = "SignUpNewsletter";
const Ki = /* @__PURE__ */ T("iframe", {
  target: "emit8cs2"
})({
  name: "nw1hot",
  styles: "margin-inline-start:12px;border:none;overflow:hidden"
}), Ct = /* @__PURE__ */ T("div", {
  target: "emit8cs1"
})("color:#6f6f6f;font-size:12px;font-family:", W, ";line-height:16px;"), Ji = /* @__PURE__ */ T("div", {
  target: "emit8cs0"
})('display:grid;grid-template-areas:"Description LikeWidget";', Ki, "{grid-area:LikeWidget;}", Ct, "{grid-area:Description;}");
function kn() {
  return kn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kn.apply(null, arguments);
}
const Er = ({
  ...e
}) => {
  const {
    config: t,
    handleTrackGA4: n
  } = re(), {
    campaignName: r,
    lastSubscribedNewsletter: i,
    variant: a
  } = me(), {
    activeElement: s
  } = ya(), l = de((c) => {
    s === c && n({
      action: "click",
      category: "nl",
      customized_parameters: {
        internal_campaign: r ?? "",
        newsletter_name: i ?? "",
        trigger_point: Ne(a)
      },
      subcategory: "like"
    });
  }, [s, n, r, a, i]);
  return /* @__PURE__ */ u.createElement(Ji, kn({}, e, {
    "data-qa": "follow-us-on-facebook"
  }), /* @__PURE__ */ u.createElement(Ct, null, " Follow us on Facebook to get our latest news."), /* @__PURE__ */ u.createElement(Ki, {
    allow: "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share",
    allowFullScreen: !0,
    frameBorder: 0,
    height: "21",
    ref: l,
    scrolling: "no",
    src: t.facebook.likeUrl,
    width: "100"
  }));
};
Er.displayName = "FollowUsOnFacebook";
const Yc = (e) => /* @__PURE__ */ N.createElement("svg", { width: 25, height: 26, viewBox: "0 0 25 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ N.createElement("path", { d: "M25 13C25 19.9036 19.4036 25.5 12.5 25.5C5.59644 25.5 0 19.9036 0 13C0 6.09644 5.59644 0.5 12.5 0.5C19.4036 0.5 25 6.09644 25 13Z", fill: "#FFCA05" }), /* @__PURE__ */ N.createElement("path", { d: "M10.0957 16.4492L10.0996 16.4454L10.0957 16.4492Z", fill: "#001246" }), /* @__PURE__ */ N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.9194 19.1667L5 13.1442L7.38647 10.7473L10.9194 14.3106L17.6141 7.5L20 9.92801L10.9194 19.1667Z", fill: "#001246" })), fr = /* @__PURE__ */ T(Yc, {
  target: "evzk65t7"
})("");
var Hc = {
  name: "itm9fh",
  styles: "font-size:16px;line-height:20px"
};
const xe = /* @__PURE__ */ T("div", {
  target: "evzk65t6"
})("grid-area:Title;font-weight:700;font-size:20px;font-family:", le, ";line-height:25px;", (e) => {
  var t;
  if (((t = e.theme) === null || t === void 0 || (t = t.signUpSuccess) === null || t === void 0 ? void 0 : t.titleFontStyle) === "small")
    return Hc;
}, ";"), tn = /* @__PURE__ */ T("div", {
  target: "evzk65t5"
})({
  name: "1mkq020",
  styles: "grid-area:Icon;inline-size:25px;block-size:25px;margin-block-end:8px"
}), tt = /* @__PURE__ */ T(Er, {
  target: "evzk65t4"
})({
  name: "1u3slon",
  styles: "margin-block-start:24px;text-align:start"
});
var zc = {
  name: "1dgbe91",
  styles: "color:#ffffff"
}, Wc = {
  name: "d10iyn",
  styles: "color:#a1a1a1"
};
const Ve = /* @__PURE__ */ T("div", {
  target: "evzk65t3"
})("grid-area:CheckEmail;margin-block-end:8px;padding-block-start:12px;color:#000000;font-size:14px;font-family:", le, ";line-height:18px;", (e) => {
  var t, n;
  if (((t = e.theme) === null || t === void 0 || (t = t.signUpSuccess) === null || t === void 0 ? void 0 : t.checkEmailMessageStyle) === "gray")
    return Wc;
  if (((n = e.theme) === null || n === void 0 || (n = n.signUpSuccess) === null || n === void 0 ? void 0 : n.checkEmailMessageStyle) === "white")
    return zc;
}, ";"), gr = /* @__PURE__ */ T("a", {
  target: "evzk65t2"
})("grid-area:SeeMoreLink;font-size:14px;font-family:", W, ";line-height:18px;text-decoration:underline;cursor:pointer;"), Xc = /* @__PURE__ */ T("div", {
  target: "evzk65t1"
})('grid-area:Footer;display:grid;grid-template-areas:"CheckEmail" "SeeMoreLink" "FollowOnFacebook";', (e) => e.theme.breakpoints.up("mediumDesktop"), "{border-color:#eeeeee;}", gr, "{color:#4585ff;}"), Oe = /* @__PURE__ */ T("div", {
  target: "evzk65t0"
})({
  name: "1hilg2l",
  styles: 'display:grid;grid-template-areas:"Icon" "Title" "Footer";grid-template-columns:1fr;grid-column-gap:12px;justify-items:center;color:#001246;text-align:center'
});
function Dn() {
  return Dn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dn.apply(null, arguments);
}
const Qi = ({
  ...e
}) => {
  const {
    handleRoutePush: t,
    handleTrackGA4: n
  } = re(), {
    signUpSuccess: r
  } = Dt(), {
    campaignName: i,
    variant: a
  } = me(), s = a === L.AcquisitionNewsletterPopup ? "Please check the email for further details." : "Please check your email to confirm your subscription.", l = a === L.AcquisitionNewsletterPopup ? "Thank you for your registration." : "Thanks for signing up to our newsletter!";
  return /* @__PURE__ */ u.createElement(Oe, Dn({}, e, {
    "data-qa": "sign-up-success-message"
  }), /* @__PURE__ */ u.createElement(tn, null, /* @__PURE__ */ u.createElement(fr, {
    height: 25,
    width: 25
  })), /* @__PURE__ */ u.createElement(xe, null, l), /* @__PURE__ */ u.createElement(Xc, null, (r == null ? void 0 : r.hasCheckEmail) && /* @__PURE__ */ u.createElement(Ve, null, s), (r == null ? void 0 : r.hasSeeMoreLinks) && /* @__PURE__ */ u.createElement(gr, {
    onClick: (c) => {
      c.preventDefault(), n({
        action: "click",
        category: "nl",
        customized_parameters: {
          internal_campaign: i ?? "",
          trigger_point: Ne(a)
        },
        subcategory: "entry"
      }), t("/newsletters");
    }
  }, "See more newsletters"), /* @__PURE__ */ u.createElement(tt, null)));
};
Qi.displayName = "SignUpSuccessMessage";
const Kc = /* @__PURE__ */ T(Ui, {
  target: "e34cblv4"
})(""), Rt = /* @__PURE__ */ T(Xi, {
  target: "e34cblv3"
})(""), Jc = /* @__PURE__ */ T(Qi, {
  target: "e34cblv2"
})(""), Qc = {
  findOutMore: {
    titleFontStyle: "medium"
  },
  hasSummaryLine: !1,
  hasTitle: !0,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    hasDescription: !1,
    hasSummary: !0,
    summaryFontStyle: "medium",
    titleFontStyle: "medium"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "small"
  }
};
var Zc = {
  name: "1wwwzme",
  styles: "max-inline-size:720px"
}, qc = {
  name: "1o60ovs",
  styles: "max-inline-size:300px"
}, $c = {
  name: "1k15hls",
  styles: "max-inline-size:307px"
}, eu = {
  name: "enj17d",
  styles: "max-inline-size:640px"
};
const Zi = /* @__PURE__ */ T("div", {
  target: "e34cblv1"
})("block-size:auto;font-family:", W, ";", (e) => e.theme.breakpoints.up("desktop"), "{", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.root) === null || t === void 0 ? void 0 : t.containerSize) {
    case "large":
      return eu;
    case "medium":
      return $c;
    case "small":
      return qc;
  }
}, " ", (e) => {
  var t;
  return ((t = e.theme) === null || t === void 0 ? void 0 : t.orientation) === "landscape" && Zc;
}, ";}", (e) => e.theme.root.customCss, ";"), tu = /* @__PURE__ */ T("div", {
  target: "e34cblv0"
})(""), nu = (e) => ai(Qc, e), ru = /* @__PURE__ */ T("div", {
  target: "e1252bbu0"
})(""), _e = ({
  children: e,
  theme: t
}) => /* @__PURE__ */ u.createElement(ru, {
  "data-qa": "variant-base"
}, /* @__PURE__ */ u.createElement(Ma, {
  theme: nu(t)
}, e));
_e.displayName = "VariantBase";
const iu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  hasTitle: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !1,
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, au = /* @__PURE__ */ T("div", {
  target: "ejc3no00"
})(Zi, "{max-inline-size:100%;}", ce, "{justify-items:center;text-align:start;", se, "{background-color:#ffffff;}", De, ",", It, ",", en, "{color:#ffffff;line-height:12px;text-align:center;}", Me, "{min-inline-size:240px;color:#001246;font-size:14px;font-family:", W, ";background-color:#ffca05;}", At, "{align-items:center;", De, "{max-inline-size:278px;line-height:13px;text-align:start;opacity:0.7;}", mr, "{display:flex;svg{color:#ffffff;background-color:#ffffff;}}}", Zt, "{min-inline-size:86px;}}", Oe, "{justify-content:center;color:#ffca05;text-align:start;", xe, "{font-size:21px;line-height:27px;text-align:center;}", Ve, "{color:#ffca05;font-size:16px;text-align:center;}", tt, "{align-items:center;}}"), ou = {
  defaultDisplayComponent: q.SignUpNewsletter,
  hasResetAfterSuccess: !1,
  hasSanitizeSubscribedNewsletter: !1
};
function Mn() {
  return Mn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mn.apply(null, arguments);
}
const su = (e) => ({
  [q.SignUpNewsletter]: (t) => /* @__PURE__ */ u.createElement(Rt, Mn({
    isDisableSignupButtonMouseOver: !0,
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t))
}), qi = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: iu,
  "data-qa": "acquisition-newsletter-popup-theme"
}, /* @__PURE__ */ u.createElement(au, t, e));
qi.displayName = "AcquisitionNewsletterPopupTheme";
const lu = (e) => /* @__PURE__ */ N.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z", fill: "white" })), L_ = /* @__PURE__ */ T("div", {
  target: "euah2f21"
})("inline-size:100%;font-size:12px;font-family:", W, ";"), cu = /* @__PURE__ */ T(lu, {
  target: "euah2f20"
})({
  name: "1o82tng",
  styles: "margin-inline-end:12px"
}), uu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "black"
  },
  orientation: "portrait",
  root: {
    containerSize: "custom",
    customCss: {
      name: "16bq70n",
      styles: "max-inline-size:260px"
    }
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasDescription: !1,
    summaryFontStyle: "medium",
    titleFontStyle: "large"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, _u = /* @__PURE__ */ T("div", {
  target: "e1vgfju90"
})(Oe, '{grid-template-areas:"Title Icon" "Footer Footer";grid-template-columns:1fr min-content;color:#000000;text-align:start;', xe, "{font-weight:700;font-size:18px;font-family:", dt, ";line-height:normal;}", Ve, "{margin-block-end:12px;font-size:12px;font-family:", W, ";line-height:normal;}", tt, "{margin-block-start:0;", Ct, "{color:#666666;font-size:10px;line-height:normal;}}", fr, "{path:first-child{fill:#eb4254;}path:last-child{fill:#ffffff;}}}", Ye, "{text-align:center;", je, "{color:#000000;}", cu, "{display:none;}}", ce, "{justify-items:left;color:#000000;font-family:", dt, ";text-align:start;", et, "{path{stroke:#000000;}}", De, "{color:#999999;}", en, ",", It, "{color:#666666;}", se, "{background-color:#ffffff;}", Yi, "{inline-size:100%;block-size:38px;}", Zt, "{min-inline-size:70px;font-size:12px;font-family:", W, ";line-height:14px;}", Tt, ",", $e, ",", qt, "{margin-block-end:12px;}", $e, "{inline-size:100%;}", At, "{flex-direction:row-reverse;gap:8px;", De, "{margin-inline-end:0;color:#333333;font-weight:400;font-size:11px;font-family:", W, ";line-height:13px;}}}");
function xn() {
  return xn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xn.apply(null, arguments);
}
const du = (e) => ({
  [q.SignUpNewsletter]: (t) => /* @__PURE__ */ u.createElement(Rt, xn({
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t))
}), $i = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: uu,
  "data-qa": "article-20-theme"
}, /* @__PURE__ */ u.createElement(_u, t, e));
$i.displayName = "Article20Theme";
const ea = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "black"
  },
  orientation: "portrait",
  root: {
    containerSize: "custom",
    customCss: /* @__PURE__ */ ii("max-inline-size:335px;", oi.breakpoints.up("tablet"), "{max-inline-size:440px;}", "")
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasDescription: !0,
    summaryFontStyle: "medium",
    titleFontStyle: "large"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, ta = /* @__PURE__ */ T("div", {
  target: "e14px9co0"
})(Oe, '{grid-template-areas:"Title Icon" "Footer Footer";grid-template-columns:1fr min-content;color:#001246;text-align:start;', (e) => e.theme.breakpoints.up("tablet"), "{text-align:center;}", tt, "{margin-block-start:12px;}", fr, "{path:first-child{fill:#eb4254;}path:last-child{fill:#ffffff;}}}", Ye, "{text-align:center;", je, "{color:#000000;}}", ce, "{color:#000000;text-align:center;", et, "{path{stroke:#000000;}}", De, "{color:#999999;}", qt, "{margin-block-end:8px;}", pe, "{color:#001246;font-weight:700;font-size:20px;line-height:23px;}", se, "{background-color:#ffffff;}}"), pu = ai(ea, {
  newsletterIcon: {
    icon: "white"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "white"
  }
}), mu = /* @__PURE__ */ T(ta, {
  target: "e1h0z9h50"
})(Oe, "{color:#ffffff;", gr, ",", Ct, "{color:#ffffff;}}", Ye, "{", je, ",", Xt, "{color:#ffffff;}}", ce, "{color:#ffffff;", et, "{path{stroke:#ffffff;}}", pe, ",", $t, "{color:#ffffff;}", pe, " path{fill:#ffffff;}", Me, "{background-color:#000000;}", pe, "{color:#ffffff;}", se, "{background-color:#000000;}}"), na = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: pu,
  "data-qa": "article-dark-theme"
}, /* @__PURE__ */ u.createElement(mu, t, e));
na.displayName = "ArticleDarkTheme";
function Un() {
  return Un = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Un.apply(null, arguments);
}
const Zr = (e) => ({
  [q.SignUpNewsletter]: (t) => /* @__PURE__ */ u.createElement(Rt, Un({
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t))
}), ra = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: ea,
  "data-qa": "article-theme"
}, /* @__PURE__ */ u.createElement(ta, t, e));
ra.displayName = "ArticleTheme";
const Eu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, fu = /* @__PURE__ */ T("div", {
  target: "eok5vf10"
})(et, "{path{stroke:#ffffff;}}", je, "{color:#ffffff;}", Me, "{background-color:#000000;}", ce, "{", De, "{color:#a1a1a1;}", pe, ",", $t, "{color:#ffffff;}}", Oe, '{grid-template-areas:"Icon Title" ". Footer";grid-template-columns:min-content 1fr;color:#ffffff;text-align:start;', tt, "{margin-block-start:0;}", xe, "{text-align:start;}}", (e) => e.theme.breakpoints.up("tablet"), "{", Ye, ",", ce, "{justify-items:flex-start;text-align:start;}}"), ia = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: Eu,
  "data-qa": "footer-theme"
}, /* @__PURE__ */ u.createElement(fu, t, e));
ia.displayName = "FooterTheme";
const gu = {
  findOutMore: {
    titleFontStyle: "large"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    summaryFontStyle: "medium",
    titleFontStyle: "medium"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, Au = /* @__PURE__ */ T("div", {
  target: "e1jfys6k0"
})(se, "{background-color:#ffffff;}", ce, "{", pe, "{color:#001246;}}"), aa = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: gu,
  "data-qa": "live-article-theme"
}, /* @__PURE__ */ u.createElement(Au, t, e));
aa.displayName = "LiveArticleTheme";
const Tu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !1,
    summaryFontStyle: "medium",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "small"
  }
}, Iu = /* @__PURE__ */ T("div", {
  target: "e1w0j1kx0"
})(pe, "{color:#001246;}", Tt, "{margin-block-end:12px;}", se, "{background-color:#ffffff;}", Rt, "{color:#001246;}", Me, "{color:#ffffff;}", $e, "{margin-block-end:8px;}", Oe, '{grid-template-areas:"Icon Title" "Icon Footer";grid-template-columns:25px 1fr;justify-items:flex-start;max-inline-size:402.5px;margin-block:0;margin-inline:auto;text-align:start;', xe, "{margin-block-end:4px;margin-block-end:4px;color:#001246;font-weight:400;font-family:", le, ";}", Ve, "{margin-block-end:0;padding-block-start:0;color:#000000;font-size:12px;font-family:", W, ";line-height:14px;}", tn, "{margin-block-end:0;}}"), Su = {
  defaultDisplayComponent: q.SignUpNewsletter,
  hasResetAfterSuccess: !1,
  hasSanitizeSubscribedNewsletter: !1
}, oa = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: Tu,
  "data-qa": "newsletter-article-bottom-theme"
}, /* @__PURE__ */ u.createElement(Iu, t, e));
oa.displayName = "NewsletterArticleBottomTheme";
const hu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "landscape",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !0,
    summaryFontStyle: "medium",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, Cu = /* @__PURE__ */ T("div", {
  target: "e1hazlo20"
})(ce, "{place-items:center center;text-align:start;", Tt, "{margin-block-end:5px;}", pe, "{max-inline-size:382px;color:#001246;font-size:18px;font-family:", le, ";line-height:23px;text-align:center;}", qt, ",", At, ",", Tt, "{", (e) => e.theme.breakpoints.up("tablet"), "{justify-self:flex-start;}}", en, "{", (e) => e.theme.breakpoints.down("tablet"), "{text-align:center;}}", At, "{align-items:center;}", mr, "{display:flex;}", $e, "{margin-block-end:0;}}", Oe, '{grid-template-areas:"Icon Title" "Icon Footer";grid-template-columns:25px 1fr;justify-items:flex-start;max-inline-size:402.5px;margin-block:0;margin-inline:auto;text-align:start;', xe, "{margin-block-end:4px;color:#001246;font-weight:400;font-size:18px;font-family:", le, ";line-height:23px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block-end:8px;}}", Ve, "{margin-block-end:0;padding-block-start:0;color:#000000;font-size:14px;font-family:", W, ";line-height:18px;}", tn, "{margin-block-end:0;}}", Me, "{margin-block-end:8px;}", pr, "{justify-content:center;margin-block-end:8px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block:10px 0;}", se, "{background-color:#ffffff;}}", Ji, "{margin-block-start:0;", Ct, "{display:flex;align-items:center;}}"), Ru = {
  defaultDisplayComponent: q.SignUpNewsletter,
  hasResetAfterSuccess: !1,
  hasSanitizeSubscribedNewsletter: !1
}, sa = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: hu,
  "data-qa": "newsletter-article-theme"
}, /* @__PURE__ */ u.createElement(Cu, t, e));
sa.displayName = "NewsletterArticleTheme";
const bu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "landscape",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !1,
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, yu = /* @__PURE__ */ T("div", {
  target: "e1njrwzb0"
})(ce, "{justify-items:flex-start;text-align:start;", pe, "{max-inline-size:382px;color:#00001f;font-size:18px;font-family:", dt, ";line-height:21px;}}", Ve, ",", xe, "{color:#00001f;}", Ve, "{margin-block-end:0;padding-block-start:8px;}", tn, "{margin-block-end:0;}", se, "{background-color:#ffffff;}", $e, "{justify-self:center;}"), Nu = {
  defaultDisplayComponent: q.SignUpNewsletter,
  hasResetAfterSuccess: !0,
  hasSanitizeSubscribedNewsletter: !1
}, la = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: bu,
  "data-qa": "newsletter-list-theme"
}, /* @__PURE__ */ u.createElement(yu, t, e));
la.displayName = "NewsletterListTheme";
const Ou = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "black"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, vu = /* @__PURE__ */ T("div", {
  target: "ez4a9ka0"
})(et, "{path{stroke:#000000;}}", je, "{color:#000000;}", Me, "{background-color:#000000;}", ce, "{", De, "{color:#a1a1a1;}", pe, ",", $t, "{color:#000000;}}", Oe, '{grid-template-areas:"Icon Title" ". Footer";grid-template-columns:min-content 1fr;color:#000000;text-align:start;', tt, "{margin-block-start:0;}", xe, "{text-align:start;}}", (e) => e.theme.breakpoints.up("tablet"), "{", Ye, ",", ce, "{justify-items:flex-start;text-align:start;}}"), ca = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: Ou,
  "data-qa": "posties-theme"
}, /* @__PURE__ */ u.createElement(vu, t, e));
ca.displayName = "PostiesTheme";
const wu = (e) => /* @__PURE__ */ N.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z", fill: "white" })), Pu = /* @__PURE__ */ T("div", {
  target: "e15wm59j1"
})("display:flex;align-items:center;color:#ffffff;font-size:14px;font-family:", W, ";text-transform:uppercase;"), Lu = /* @__PURE__ */ T(wu, {
  target: "e15wm59j0"
})({
  name: "t5e8y3",
  styles: "margin-inline-end:10px"
}), Ar = ({
  children: e
}) => /* @__PURE__ */ u.createElement(Pu, {
  "data-qa": "homepage-theme-button-display"
}, /* @__PURE__ */ u.createElement(Lu, null), e);
Ar.displayName = "HomepageThemeButtonDisplay";
const Bu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "landscape",
  root: {
    containerSize: "medium",
    customCss: /* @__PURE__ */ ii("max-inline-size:100%;", oi.breakpoints.up("desktop"), "{max-inline-size:100%;}", "")
  }
}, ku = /* @__PURE__ */ T("div", {
  target: "e1ds7hvh0"
})("padding-block:20px 12px;padding-inline:24px;border:1px solid rgba(0, 0, 0, 0.2);border-radius:4px;background:#f6f6f6;", Ye, '{grid-template-areas:"Message" "Button";gap:16px;place-items:center center;', (e) => e.theme.breakpoints.up("tablet"), '{grid-template-areas:"Message Button";justify-items:flex-start;}', Xt, "{padding-block:10px;padding-inline:16px;border-radius:2px;background-color:#4585ff;}", sr, "{margin-block:0;", (e) => e.theme.breakpoints.up("tablet"), "{margin-inline-start:12px;}}", cr, "{", (e) => e.theme.breakpoints.up("tablet"), "{justify-self:end;}}", je, "{color:#001246;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:18px;line-height:23px;}}", lr, "{display:none;}}"), Fn = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(_e, {
  theme: Bu,
  "data-qa": "homepage-theme"
}, /* @__PURE__ */ u.createElement(ku, t, e)), B_ = () => /* @__PURE__ */ u.createElement(Ar, {
  "data-qa": "homepage-theme-sign-up-button-display"
}, "Get Our Newsletter"), k_ = () => /* @__PURE__ */ u.createElement(Ar, {
  "data-qa": "homepage-theme-find-our-more-display"
}, "Find Out More");
Fn.displayName = "HomepageTheme";
const Du = /* @__PURE__ */ T("div", {
  target: "ebzef8g0"
})("color:#001246;font-weight:400;font-size:14px;font-family:", le, ";line-height:140%;"), Gn = () => {
  var e;
  const {
    newsletterItemForDisplay: t
  } = me();
  return /* @__PURE__ */ u.createElement(Du, {
    "data-qa": "description-display"
  }, t == null || (e = t.homepageDescription) === null || e === void 0 ? void 0 : e.text);
};
Gn.displayName = "DescriptionDisplay";
const Mu = /* @__PURE__ */ T("div", {
  target: "e1fn0hgx2"
})("color:#001246;font-weight:400;font-size:18px;font-family:", le, ";line-height:140%;"), xu = /* @__PURE__ */ T("div", {
  target: "e1fn0hgx1"
})({
  name: "1b2kh57",
  styles: "font-size:14px;line-height:140%"
}), Uu = /* @__PURE__ */ T("span", {
  target: "e1fn0hgx0"
})("font-weight:700;font-family:", le, ";"), Tr = ({
  className: e
}) => {
  const {
    newsletterItemForDisplay: t
  } = me(), n = wa(t == null ? void 0 : t.name, t == null ? void 0 : t.alternativeName);
  return /* @__PURE__ */ u.createElement(Mu, {
    className: e,
    "data-qa": "title-display"
  }, /* @__PURE__ */ u.createElement(xu, null, "Sign-up for"), /* @__PURE__ */ u.createElement(Uu, null, n));
};
Tr.displayName = "TitleDisplay";
const Fu = /* @__PURE__ */ T("div", {
  target: "eu7rj6m16"
})({
  name: "e0dnmk",
  styles: "cursor:pointer"
}), Gu = /* @__PURE__ */ T("div", {
  target: "eu7rj6m15"
})("max-inline-size:340px;margin-inline-start:8px;color:#000000;font-size:11px;font-family:", W, ";line-height:13px;text-align:start;"), Vu = /* @__PURE__ */ T("div", {
  target: "eu7rj6m14"
})("display:flex;margin-block-start:24px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block-start:0;}"), ju = /* @__PURE__ */ T("div", {
  target: "eu7rj6m13"
})({
  name: "1vkjxf6",
  styles: "margin-block-end:8px"
}), Vn = /* @__PURE__ */ T("a", {
  target: "eu7rj6m12"
})({
  name: "4dv4e3",
  styles: "margin-block:0;margin-inline:2px"
}), Yu = /* @__PURE__ */ T("div", {
  target: "eu7rj6m11"
})("color:#999999;font-size:10px;font-family:", W, ";line-height:11px;white-space:nowrap;", Vn, "{color:#999999;text-decoration:underline;}"), Hu = /* @__PURE__ */ T("div", {
  target: "eu7rj6m10"
})("display:flex;flex-flow:column;gap:2px;justify-items:center;max-inline-size:500px;margin:auto;padding:0;color:#ffffff;text-align:center;", Me, "{display:flex;justify-content:center;align-items:center;block-size:36px;min-inline-size:173px;padding-inline:16px;", (e) => e.theme.breakpoints.up("tablet"), "{min-inline-size:205px;}}", Zt, "{min-inline-size:86px;font-family:", W, ";}", pr, "{justify-content:center;", se, "{background-color:#ffffff;}}", Gi, "{", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:186px;}}", (e) => e.theme.breakpoints.up("tablet"), "{justify-items:center;max-inline-size:initial;margin:initial;text-align:center;}"), zu = /* @__PURE__ */ T("div", {
  target: "eu7rj6m9"
})("display:flex;flex-flow:column;gap:16px;", (e) => e.theme.breakpoints.up("tablet"), "{flex-flow:row;}"), Wu = /* @__PURE__ */ T("div", {
  target: "eu7rj6m8"
})((e) => e.theme.breakpoints.up("tablet"), "{align-self:flex-end;}"), Xu = /* @__PURE__ */ T("div", {
  target: "eu7rj6m7"
})("inline-size:100%;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{text-align:start;}"), qr = /* @__PURE__ */ T("div", {
  target: "eu7rj6m6"
})((e) => e.theme.breakpoints.up("tablet"), "{margin-block-start:0;}"), Ku = /* @__PURE__ */ T("div", {
  target: "eu7rj6m5"
})("display:flex;flex-direction:column;align-items:center;inline-size:100%;", (e) => e.theme.breakpoints.up("tablet"), "{justify-self:end;align-items:end;inline-size:unset;}"), $r = /* @__PURE__ */ T("div", {
  target: "eu7rj6m3"
})("display:flex;justify-content:center;", (e) => e.theme.breakpoints.up("tablet"), "{gap:16px;justify-content:unset;}"), Ju = /* @__PURE__ */ T("div", {
  target: "eu7rj6m2"
})("display:none;", (e) => e.theme.breakpoints.up("tablet"), "{display:block;inline-size:100%;}"), Qu = /* @__PURE__ */ T("div", {
  target: "eu7rj6m1"
})("display:block;", (e) => e.theme.breakpoints.up("tablet"), "{display:none;}"), Zu = /* @__PURE__ */ T(Tr, {
  target: "eu7rj6m0"
})({
  name: "c79c4p",
  styles: "margin-block-start:12px"
}), qu = (e) => /* @__PURE__ */ N.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ N.createElement("g", { id: "icon_email_24x24" }, /* @__PURE__ */ N.createElement("path", { id: "Fill 45", fillRule: "evenodd", clipRule: "evenodd", d: "M22 10.0606V18.1419C22 18.6539 21.8039 19.0912 21.4108 19.4547C21.0178 19.8182 20.5465 20 19.9961 20H4.00388C3.45423 20 2.98218 19.8182 2.58917 19.4547C2.19687 19.0912 2 18.6539 2 18.1419V10.0606L12.0194 14.1818L22 10.0606ZM22 8.80827L12.0194 12.9701L2 8.80827V5.85888C2 5.34688 2.19687 4.90876 2.58917 4.54525C2.98218 4.18175 3.45423 4 4.00388 4H19.9961C20.5465 4 21.0178 4.18175 21.4108 4.54525C21.8039 4.90876 22 5.34688 22 5.85888V8.80827Z", fill: "#4585FF" }))), $u = /* @__PURE__ */ T("div", {
  target: "essnwrk3"
})({
  name: "zpo6p0",
  styles: "display:flex;block-size:100%"
}), e_ = /* @__PURE__ */ T("div", {
  target: "essnwrk2"
})("display:flex;flex-direction:row;gap:4px;justify-content:space-between;align-items:center;inline-size:100%;padding-block-end:8px;border-block-end:1px solid #001246;", (e) => e.theme.breakpoints.up("tablet"), "{flex-direction:column;justify-content:unset;align-items:flex-start;padding-block-end:0;padding-inline-end:16px;border-block-end:0;border-inline-end:1px solid #001246;}"), t_ = /* @__PURE__ */ T("span", {
  target: "essnwrk1"
})("display:flex;gap:8px;align-items:center;color:#4585ff;font-weight:700;font-size:14px;font-family:", dt, ";text-transform:uppercase;"), n_ = /* @__PURE__ */ T("div", {
  target: "essnwrk0"
})("color:#001246;font-weight:700;font-size:14px;font-family:", dt, ";text-align:start;"), jn = () => {
  var e;
  const {
    newsletterItemForDisplay: t
  } = me();
  return /* @__PURE__ */ u.createElement($u, {
    "data-qa": "summary-display"
  }, /* @__PURE__ */ u.createElement(e_, null, /* @__PURE__ */ u.createElement(t_, null, /* @__PURE__ */ u.createElement(qu, null), "NEWSLETTER"), /* @__PURE__ */ u.createElement(n_, null, t == null || (e = t.summary) === null || e === void 0 ? void 0 : e.text)));
};
jn.displayName = "SummaryDisplay";
function Yn() {
  return Yn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yn.apply(null, arguments);
}
const ua = ({
  isDisableSignupButtonMouseOver: e = !1,
  isShowOverlaySignUp: t = !1,
  onSuccess: n,
  ...r
}) => {
  const {
    handleRoutePush: i,
    handleTrackGA4: a
  } = re(), [s, l] = ti(!1), {
    campaignName: c
  } = me(), E = () => s ? /* @__PURE__ */ u.createElement(zi, null) : /* @__PURE__ */ u.createElement(Wi, {
    "data-qa": "render-checkbox"
  }), {
    actionComponent: p,
    handleRenderActionComponent: d
  } = Hi({
    isAgreedReceiveMarketing: s,
    isDisableSignupButtonMouseOver: e,
    isShowOverlaySignUp: t,
    onSuccess: n
  }), _ = () => /* @__PURE__ */ u.createElement(Vu, {
    "data-qa": "handle-render-agreement"
  }, /* @__PURE__ */ u.createElement(Fu, {
    onClick: l
  }, E()), /* @__PURE__ */ u.createElement(Gu, null, "By submitting, you consent to receiving marketing emails from SCMP. If you don't want these, tick here")), f = () => {
    const g = () => p === K.OverlaySignUpButton || p === K.SignUpButton ? /* @__PURE__ */ u.createElement(u.Fragment, null, /* @__PURE__ */ u.createElement(qr, null, /* @__PURE__ */ u.createElement(jn, null)), /* @__PURE__ */ u.createElement(Xu, null, /* @__PURE__ */ u.createElement(Tr, null), /* @__PURE__ */ u.createElement(Gn, null))) : _();
    return /* @__PURE__ */ u.createElement(Ju, {
      "data-qa": "handle-render-tablet-up-content"
    }, /* @__PURE__ */ u.createElement(ct, {
      mode: "out-in"
    }, /* @__PURE__ */ u.createElement(_t, {
      key: String(p === K.OverlaySignUpButton || p === K.SignUpButton),
      timeout: 500
    }, /* @__PURE__ */ u.createElement($r, null, g()))));
  }, A = () => {
    const g = () => p === K.OverlaySignUpButton || p === K.SignUpButton ? /* @__PURE__ */ u.createElement(Gn, null) : _();
    return /* @__PURE__ */ u.createElement(Qu, {
      "data-qa": "handle-render-mobile-content"
    }, /* @__PURE__ */ u.createElement(qr, null, /* @__PURE__ */ u.createElement(jn, null)), /* @__PURE__ */ u.createElement(Zu, null), /* @__PURE__ */ u.createElement(ct, {
      mode: "out-in"
    }, /* @__PURE__ */ u.createElement(_t, {
      key: String(p === K.OverlaySignUpButton || p === K.SignUpButton),
      timeout: 500
    }, /* @__PURE__ */ u.createElement($r, null, g()))));
  };
  return /* @__PURE__ */ u.createElement(Hu, Yn({}, r, {
    "data-qa": "sign-up-newsletter"
  }), /* @__PURE__ */ u.createElement(zu, null, f(), A(), /* @__PURE__ */ u.createElement(Ku, null, /* @__PURE__ */ u.createElement(ct, {
    mode: "out-in"
  }, /* @__PURE__ */ u.createElement(_t, {
    key: p,
    timeout: 500
  }, /* @__PURE__ */ u.createElement(ju, null, d()))))), /* @__PURE__ */ u.createElement(Wu, null, /* @__PURE__ */ u.createElement(Yu, null, "By registering, you agree to our", /* @__PURE__ */ u.createElement(Vn, {
    href: "/terms-conditions",
    onClick: (g) => {
      g.preventDefault(), a({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/terms-conditions",
          internal_campaign: c ?? "",
          message: "T&C",
          step: "1"
        },
        subcategory: ""
      }), i("/terms-conditions");
    }
  }, "T&C"), "and", /* @__PURE__ */ u.createElement(Vn, {
    href: "/privacy-policy",
    onClick: (g) => {
      g.preventDefault(), a({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/privacy-policy",
          internal_campaign: c ?? "",
          message: "Privacy Policy",
          step: "1"
        },
        subcategory: ""
      }), i("/privacy-policy");
    }
  }, "Privacy Policy"))));
};
ua.displayName = "SignUpNewsletter";
const r_ = (e) => /* @__PURE__ */ N.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ N.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM18.2767 8L19 8.70309L10.8101 16.6609L10.4436 17L6 12.6824L6.72334 11.9793L10.4524 15.6026L18.2767 8Z", fill: "#EB4254" })), i_ = /* @__PURE__ */ T(r_, {
  target: "e18vlar15"
})(""), a_ = /* @__PURE__ */ T("div", {
  target: "e18vlar14"
})("grid-area:Title;font-weight:400;font-size:18px;font-family:", le, ";line-height:23px;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{font-weight:700;line-height:25px;text-align:start;}"), o_ = /* @__PURE__ */ T("div", {
  target: "e18vlar13"
})({
  name: "1mkq020",
  styles: "grid-area:Icon;inline-size:25px;block-size:25px;margin-block-end:8px"
}), s_ = /* @__PURE__ */ T(Er, {
  target: "e18vlar12"
})('grid-area:FollowUsOnFacebook;grid-template-areas:"Description" "LikeWidget";grid-row-gap:4px;justify-items:center;text-align:center;', (e) => e.theme.breakpoints.up("tablet"), "{justify-items:end;justify-self:end;text-align:start;}"), l_ = /* @__PURE__ */ T("div", {
  target: "e18vlar11"
})("grid-area:CheckEmail;color:#001246;font-size:12px;font-family:", W, ";line-height:18px;text-align:center;"), c_ = /* @__PURE__ */ T("div", {
  target: "e18vlar10"
})('display:grid;grid-template:"Icon" min-content "." 20px "Title" min-content "CheckEmail" min-content "." 48px "FollowUsOnFacebook" min-content/fit-content(100%);place-items:center;justify-content:center;color:#001246;', (e) => e.theme.breakpoints.up("tablet"), '{grid-template:"Icon Title FollowUsOnFacebook" min-content "Icon CheckEmail FollowUsOnFacebook" min-content/max-content fit-content(50%) 1fr max-content;grid-gap:4px 12px;place-items:center start;}');
function Hn() {
  return Hn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hn.apply(null, arguments);
}
const _a = ({
  ...e
}) => /* @__PURE__ */ u.createElement(c_, Hn({}, e, {
  "data-qa": "sign-up-success-message"
}), /* @__PURE__ */ u.createElement(o_, null, /* @__PURE__ */ u.createElement(i_, {
  height: 25,
  width: 25
})), /* @__PURE__ */ u.createElement(a_, null, "Thanks for signing up to our newsletter!"), /* @__PURE__ */ u.createElement(l_, null, "Please check your email to confirm your subscription."), /* @__PURE__ */ u.createElement(s_, null));
_a.displayName = "SignUpSuccessMessage";
function zn() {
  return zn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zn.apply(null, arguments);
}
const ei = (e) => ({
  [q.SignUpNewsletter]: (t) => /* @__PURE__ */ u.createElement(ua, zn({
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t)),
  [q.SignUpSuccessMessage]: (t) => /* @__PURE__ */ u.createElement(_a, null)
});
function Wn() {
  return Wn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wn.apply(null, arguments);
}
const u_ = {
  defaultDisplayComponent: q.FindOutMore,
  hasResetAfterSuccess: !0,
  hasSanitizeSubscribedNewsletter: !0
}, __ = ({
  campaignName: e,
  children: t,
  hideWhenNoNewsletters: n = !1,
  isToggleSuccessMessage: r = !1,
  multipleNewsletters: i = !1,
  newsletterItems: a,
  onSuccess: s,
  trigger_point: l,
  variant: c,
  ...E
}) => {
  var p;
  const d = Fe(() => ({
    [L.AcquisitionNewsletterPopup]: {
      config: ou,
      hook: su,
      renderComponent: qi
    },
    [L.Article]: {
      hook: Zr,
      renderComponent: ra
    },
    [L.Article20]: {
      hook: du,
      renderComponent: $i
    },
    [L.ArticleDark]: {
      hook: Zr,
      renderComponent: na
    },
    [L.Footer]: {
      renderComponent: ia
    },
    [L.Homepage]: {
      hook: ei,
      renderComponent: Fn
    },
    [L.LiveArticle]: {
      renderComponent: aa
    },
    [L.NewsletterArticle]: {
      config: Ru,
      renderComponent: sa
    },
    [L.NewsletterArticleBottom]: {
      config: Su,
      renderComponent: oa
    },
    [L.NewsletterList]: {
      config: Nu,
      renderComponent: la
    },
    [L.Posties]: {
      renderComponent: ca
    },
    [L.Section]: {
      hook: ei,
      renderComponent: Fn
    }
  }), []), _ = Fe(() => d[c].renderComponent, [d, c]), f = Fe(() => {
    var H;
    return (H = d[c].config) !== null && H !== void 0 ? H : u_;
  }, [d, c]), [A, g] = Se(!1), b = de(() => {
    R(q.SignUpSuccessMessage), f.hasResetAfterSuccess && g(!0), s == null || s();
  }, [s, f]), I = {
    [q.FindOutMore]: (H) => /* @__PURE__ */ u.createElement(Kc, H),
    [q.SignUpNewsletter]: (H) => /* @__PURE__ */ u.createElement(Rt, Wn({
      onSuccess: b
    }, H)),
    [q.SignUpSuccessMessage]: (H) => /* @__PURE__ */ u.createElement(Jc, H)
  };
  Qe(() => {
    if (!A) return;
    const H = setTimeout(() => g(!1), Ca);
    return () => clearTimeout(H);
  }, [A, f.hasResetAfterSuccess]);
  const v = d[c].hook, C = (p = v == null ? void 0 : v(b)) !== null && p !== void 0 ? p : {}, S = Object.entries({
    ...I,
    ...C
  }).reduce((H, [fe, we]) => (H[fe] = we(), H), {}), h = Kl(), y = Ea(() => f.hasSanitizeSubscribedNewsletter ? a.filter((H) => !h.includes(H.entityId)) : a, [a, h, f.hasSanitizeSubscribedNewsletter]), O = Fe(() => Si(y), [y]), w = de(() => ({
    action: "imp",
    category: "nl",
    customized_parameters: {
      internal_campaign: e,
      newsletter_name: O == null ? void 0 : O.name,
      trigger_point: l ?? Ne(c)
    },
    subcategory: "sign_up"
  }), [O, l, c, e]), {
    captureTrackImpressionEventTargetElement: k
  } = ol({
    ga4Event: w
  }), [o, R] = Se(f.defaultDisplayComponent), P = de(() => {
    R(y.length > 0 ? q.SignUpNewsletter : f.defaultDisplayComponent);
  }, [y, f.defaultDisplayComponent]), B = Ia(P);
  Qe(() => {
    A || B.current();
  }, [A, B]), Qe(() => {
    r ? R(q.SignUpSuccessMessage) : B.current();
  }, [r, B]);
  const {
    dataMatrix: M,
    findOutMoreButtonDisplayComponent: J,
    queryParametersForSocialButtons: Ee,
    signUpButtonDisplayComponent: bt,
    summaryComponent: ve,
    titleComponent: yt
  } = E;
  return n && y.length === 0 ? null : /* @__PURE__ */ u.createElement(sl, {
    multipleNewsletters: i,
    value: {
      campaignName: e,
      dataMatrix: M,
      findOutMoreButtonDisplayComponent: J,
      newsletterItems: y,
      queryParametersForSocialButtons: Ee,
      signUpButtonDisplayComponent: bt,
      summaryComponent: ve,
      titleComponent: yt,
      variant: c
    },
    "data-qa": "newsletter-widget"
  }, t, /* @__PURE__ */ u.createElement(_, E, /* @__PURE__ */ u.createElement(Zi, {
    ref: k
  }, /* @__PURE__ */ u.createElement(ct, {
    mode: "out-in"
  }, /* @__PURE__ */ u.createElement(_t, {
    appear: !1,
    key: o,
    timeout: 500
  }, /* @__PURE__ */ u.createElement(tu, null, Object.entries(S).map(([H, fe]) => /* @__PURE__ */ u.createElement(u.Fragment, {
    key: H
  }, H === o && fe))))))));
};
__.displayName = "NewsletterWidget";
export {
  xe as A,
  Ve as B,
  L_ as C,
  Ct as D,
  P_ as E,
  Er as F,
  ol as G,
  k_ as H,
  w_ as M,
  __ as N,
  cu as S,
  qs as T,
  L as V,
  sl as a,
  B_ as b,
  Ac as c,
  Kl as d,
  Vc as e,
  Hi as f,
  Ne as g,
  T as h,
  _t as i,
  Si as j,
  mi as k,
  Ht as l,
  Pe as m,
  ds as n,
  Zs as o,
  me as p,
  Jl as q,
  ci as r,
  Wa as s,
  Jo as t,
  Di as u,
  eo as v,
  _s as w,
  _r as x,
  Qi as y,
  tt as z
};
//# sourceMappingURL=index-CJx5uIQY.mjs.map
